import React, { Component , Fragment } from "react";
import TeamFull from "../elements/Team_full";
import FooterTwo from "../component/footer/FooterTwo";
import Header from "../component/header/Header";
import { FiCheck, FiClock, FiUser, FiMonitor, FiRadio, FiDownload, FiVideo, FiCheckCircle, FiPackage} from "react-icons/fi";
import { GoRocket } from "react-icons/go";
import { FaGraduationCap, FaPhone, FaRunning, FaEye, FaWhatsapp, FaPaypal, FaFacebookSquare, FaStar, FaChevronCircleRight, FaLinkedin, FaCalendarWeek, FaFilm, FaCheckCircle } from "react-icons/fa";
import { BsCircle, BsArrowLeftCircle, BsSun, BsFillPlayCircleFill, BsCloudSunFill } from "react-icons/bs";
import { IoCloseCircleOutline, IoCard } from "react-icons/io5";
import { AiOutlineDown, AiOutlineRight, AiOutlineClose } from "react-icons/ai";
import { MdWork, MdEmail, MdPayments, MdModeNight, MdOutlineVideoLabel } from "react-icons/md";
import Typical from 'react-typical';    
import Modal from "react-bootstrap/Modal";
import 'custom-react-accordion/dist/Accordion.css'
import NonPassiveTouchTarget from "./NonPassiveTouchTarget";
import TouchCarousel, { clamp } from "react-touch-carousel";
import touchWithMouseHOC from "react-touch-carousel/lib/touchWithMouseHOC";
import "./styles.css";
import data from "./data";
import data2 from "./data2";
import cx from "classnames";
import AOS from 'aos';
import 'aos/dist/aos.css';
import TestimonialOne from "../blocks/testimonial/TestimonialOne";
import ReactCountryFlag from "react-country-flag";
import axios from 'axios';
import Selectrix from "react-selectrix";
import 'react-toastify/dist/ReactToastify.css';
import TestimonialTree from "../blocks/testimonial/TestimonialTree";
import { VerticalTimeline, VerticalTimelineElement }  from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import Spinner from 'react-bootstrap/Spinner';
import ReactPlayer from "react-player";
import FlipCountdown from '@rumess/react-flip-countdown';
import Plataforma from "../component/dojopy/Plataforma";
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { toast } from 'react-toastify';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import PreguntasEmpleo from "../component/dojopy/PreguntasEmpleo";
import { GiPlatform } from "react-icons/gi";
import { FaFilePdf } from "react-icons/fa6";
import { FaRegFilePdf } from "react-icons/fa6";
import { CiCalendar } from "react-icons/ci";
import { FcConferenceCall } from "react-icons/fc";
import { MdWorkOutline, MdWatchLater } from "react-icons/md";
import { TbWorldCheck } from "react-icons/tb";
import { IoVideocamOutline } from "react-icons/io5";
import { IoIosDocument, IoMdCall } from "react-icons/io";
import { HiMiniPencilSquare } from "react-icons/hi2";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import {AccordionWrapper, AccordionItem} from "custom-react-accordion";




const cardSize = 300;
const cardSize2 = 280;
const cardPadCount = 2;
const carouselWidth = clamp(window.innerWidth, 0, 960);

const FECHAS_EVENTO = [
    'Hoy, 7:00 PM',
    'Jueves, 14 de diciembre, 7:00 PM',
    'Viernes, 15 de diciembre, 7:00 PM',
]


AOS.init({
    // Global settings:
    disable: false, // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
    startEvent: 'DOMContentLoaded', // name of the event dispatched on the document, that AOS should initialize on
    initClassName: 'aos-init', // class applied after initialization
    animatedClassName: 'aos-animate', // class applied on animation
    useClassNames: false, // if true, will add content of `data-aos` as classes on scroll
    disableMutationObserver: false, // disables automatic mutations' detections (advanced)
    debounceDelay: 50, // the delay on debounce used while resizing window (advanced)
    throttleDelay: 99, // the delay on throttle used while scrolling the page (advanced)

    // Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
    offset: 120, // offset (in px) from the original trigger point
    delay: 10, // values from 0 to 3000, with step 50ms
    duration: 1000, // values from 0 to 3000, with step 50ms
    easing: 'ease', // default easing for AOS animations
    once: false, // whether animation should happen only once - while scrolling down
    mirror: false, // whether elements should animate out while scrolling past them
    anchorPlacement: 'top-bottom', // defines which position of the element regarding to window should trigger the animation
  });

// const then = moment('05 26 2019, 6:00 am', 'MM DD YYYY, h:mm a');
// const now = moment();
// const countdown = moment(then - now);
// const days = countdown.format('D');
// const hours = countdown.format('HH');
// const minutes = countdown.format('mm');
// const seconds = countdown.format('ss');



// const VIDEO_MOBILE = "https://media.dojofullstack.com/bootcamp/ads/intro-vls-beta-v-7.mp4";
// const VIDEO_DESKTOP = "https://media.dojofullstack.com/bootcamp/ads/intro-vls-beta-v-7-desktop.mp4";

// const VIDEO_VLS = window.type_device ? VIDEO_MOBILE: VIDEO_DESKTOP;

const VIDEO_POSTER = window.type_device ? "https://media.dojofullstack.com/bootcamp/ads/vlcsnap-2024-10-30-16h36m12s314.png": "https://media.dojofullstack.com/bootcamp/ads/vlcsnap-2024-10-30-16h36m12s314.png";


const VIDEO_MOBILE = "https://media.dojofullstack.com/bootcamp/webinar-oficial-v3.mp4";
const VIDEO_DESKTOP = "https://media.dojofullstack.com/bootcamp/webinar-oficial-v3.mp4";

const VIDEO_VLS = window.type_device ? VIDEO_MOBILE: VIDEO_DESKTOP;

// const Turnos =

const KeyCountry =  [
    {key: "MX", label: "México", countryNumber: "+52"},
    {key: "EC", label: "Ecuador", countryNumber: "+593"},
    {key: "GT", label: "Guatemala", countryNumber: "+502"},
    {key: "CR", label: "Costa Rica", countryNumber: "+506"},
    {key: "PE", label: "Perú", countryNumber: "+51"},
    {key: "SV", label: "El Salvador", countryNumber: "+503"},
    {key: "HN", label: "Honduras", countryNumber: "+504"},
    {key: "UY", label: "Uruguay", countryNumber: "+598"},
    {key: "PY", label: "Paraguay", countryNumber: "+595"},
    {key: "PA", label: "Panamá", countryNumber: "+507"},
    {key: "NI", label: "Nicaragua", countryNumber: "+505"},
    {key: "US", label: "Estados Unidos", countryNumber: "+1"},
  ]


function CarouselContainer(props) {
    const {
      cursor,
      carouselState: { active, dragging },
      ...rest
    } = props;
    let current = -Math.round(cursor) % data.length;
    while (current < 0) {
      current += data.length;
    }
    // Put current card at center
    const translateX =
      (cursor - cardPadCount) * cardSize + (carouselWidth - cardSize) / 2;
    return (
      <NonPassiveTouchTarget
        className={cx("carousel-container", {
          "is-active": active,
          "is-dragging": dragging
        })}
      >
        <NonPassiveTouchTarget
          className="carousel-track"
          style={{ transform: `translate3d(${translateX}px, 0, 0)` }}
          {...rest}
        />

        <div className="carousel-pagination-wrapper">
          <ol className="carousel-pagination">
            {data.map((_, index) => (
              <li key={index} className={current === index ? "current" : ""} />
            ))}
          </ol>
        </div>
      </NonPassiveTouchTarget>
    );
}


function CarouselContainer2(props) {
    const {
      cursor,
      carouselState: { active, dragging },
      ...rest
    } = props;
    let current = -Math.round(cursor) % data2.length;
    while (current < 0) {
      current += data2.length;
    }
    // Put current card at center
    const translateX =
      (cursor - cardPadCount) * 390 + (carouselWidth - 390) / 2;
    return (
      <NonPassiveTouchTarget
        className={cx("carousel-container", {
          "is-active": active,
          "is-dragging": dragging,
        })}
        style={{height: "450px"}}
      >
        <NonPassiveTouchTarget
          className="carousel-track"
          style={{ transform: `translate3d(${translateX}px, 0, 0)` }}
          {...rest}
        />

        <div className="carousel-pagination-wrapper">
          <ol className="carousel-pagination">
            {data2.map((_, index) => (
              <li key={index} className={current === index ? "current" : ""} />
            ))}
          </ol>
        </div>
      </NonPassiveTouchTarget>
    );
  }

const Container = touchWithMouseHOC(CarouselContainer);
const Container2 = touchWithMouseHOC(CarouselContainer2);

// const SlideList = [
//     {
//         textPosition: 'text-center',
//         category: '',
//         title: 'Desarrollo <br/> Web Full Stack Developer a medida y escalable',
//         description: '',
//         buttonText: 'INSCRÍBETE HOY',
//         buttonLink: '#project'
//     }
// ]



const InfoAcordeon = {
    nodejs: "Es ideal para manejar aplicaciones de alto tráfico de usuarios y eventos, como por ejemplo Twitter donde a cada segundo se envían cientos de miles de tuits. El desarrollo de aplicaciones es mucho más rápido, las aplicaciones también y por lo tanto el usuario puede acceder a una mejor experiencia de uso",
    database: "Es muy importante saber qué, cómo y dónde se guardarán tus datos. Aprende desde cero los fundamentos y práctica para administrar DBs profesionalmente, aprende bases de datos Relacionales y No Relacionales.",
    web: "En este módulo aprenderás a crear tu sitio web partiendo del prototipo en papel. Te sumergirás en las mejores prácticas del desarrollo web, trabajando con HTML y CSS. Conocerás herramientas para optimizar al máximo tu sitio web, implementando prácticas de versionado de código con GIT. Al finalizar, sabrás cómo aplicar Bootstrap y Tailwind CSS a tus proyectos.",
    web_deploy: "En este módulo dominarás el despliegue de aplicaciones completas en la nube: aprenderás a publicar tu proyecto en Vercel, Netlify y AWS Amplify, configurar dominios TLD, activar certificados SSL y proteger tu aplicación en cuestión de minutos.",
    js: "En este módulo aprenderás los fundamentos del lenguaje de programación más usado en la actualidad, con el cual es posible crear aplicaciones de todo tipo. Explorarás inicialmente herramientas propias del mismo, indagando casos prácticos de aplicación y cómo aplicar técnicas de desarrollo para apps modernas con AJAX. Al graduarte, estarás en condiciones de crear soluciones web interactivas, y trasladar los conocimientos del curso a cualquier framework JavaScript.  ",
    react: "En este módulo, que es el tercer nivel del Bootcamp, aprenderás a programar por componentes, mediante Javascript y React, y también conocerás las ventajas de la utilización del flujos de datos. Comprenderás la utilización del virtual DOM mediante los desarrollos de React JS. Al finalizar, podrás crear tus propias aplicaciones SPA, y estarás en condiciones de hacer cualquier desarrollo con uno de los frameworks más populares y avanzados del momento.",
    python: "Python es uno de los lenguajes de programación más valorados y usados a nivel mundial según estadísticas de Stack Overflow la plataforma más grande de desarrolladores, multitud de Startups y empresas lo utilizan en su día a día como Instagram, Spotify, Amazon, Netflix, Google, Facebook, Dropbox, Youtube, etc,  Python es flexible, claro y con un código legible para todos, tambien trabajaremos con el Framework Django.",
    git: "Aprende todas las herramientas necesarias para dominar el mundo de la programación colaborativa. Aprenderás las bases y conceptos esenciales que necesitas para trabajar en proyectos profesionales, ya sea en una empresa, conjunto de desarrolladores. Con este módulo aprenderás todo lo necesario para involucrarte en cualquier grupo de desarrolladores.",
    project: "El proyecto final se desarrolla en el cuarto mes y sirve para certificar el aprendizaje poniéndolo en práctica creando una réplica de una empresa o Startup real como MercadoLibre, Instagram o Airbnb, con tus mentores. El proyecto final es una herramienta increíble para agregar a tu portafolio y así mostrar tu trabajo en tus próximas oportunidades laborales 😎!",
    deploy_aws: "Amazon Web Services (AWS) es una de las principales plataformas de servicios de computación en la nube a nivel mundial, en este Bootcamp desplegaremos el proyecto final en esta infraestructura muy potente, con tecnología de vanguardia, seguridad, confiabilidad, y escalabilidad.",
    serverless: "La arquitectura serverless también conocida como FaaS (Functions as a Service), habilita la ejecución de una aplicación mediante contenedores temporales y sin estado; estos son creados en el momento en el que se produce un evento que dispare dicha aplicación.",
    api: "En este módulo de API REST con Django explorarás los conceptos fundamentales de las APIs REST, como los métodos HTTP, los recursos, los endpoints y la autenticación. Aprenderás cómo diseñar una API RESTful siguiendo las mejores prácticas, manteniendo la coherencia y facilitando la interacción con otras aplicaciones y servicios. ",
    apiSecure: "En este módulo aprenderás a implementar pruebas automatizadas para verificar el correcto funcionamiento de tu código, así como a identificar y solucionar posibles vulnerabilidades y riesgos de seguridad en tu aplicación. Este módulo te dotará de las habilidades necesarias para garantizar la confiabilidad y protección de tus proyectos, ofreciendo una experiencia segura y libre de errores para los usuarios finales.",
    ciberSeguridad: "En este módulo aprenderás a implementar pruebas automatizadas para verificar el correcto funcionamiento de tu código, así como a identificar y solucionar posibles vulnerabilidades y riesgos de seguridad en tu aplicación. Este módulo te dotará de las habilidades necesarias para garantizar la confiabilidad y protección de tus proyectos, ofreciendo una experiencia segura y libre de errores para los usuarios finales.",
    appsMobiles: "En este módulo aprenderás a crear aplicaciones móviles multiplataforma utilizando React Native, lo que te permitirá desarrollar aplicaciones para iOS y Android con un solo código base. Aprenderás a utilizar componentes nativos, gestionar el estado de la aplicación y acceder a las funcionalidades del dispositivo móvil, como la cámara, la ubicación y las notificaciones push. Al finalizar, podrás crear aplicaciones móviles modernas y funcionales que se adapten a las necesidades de los usuarios.",
    employer: "En DojoFullStack confiamos en la calidad de nuestra formación y en tu potencial para destacar en el sector tech. Por eso, al finalizar el Bootcamp, recibirás asesoría personalizada 1 a 1 con un coach especializado que te ayudará a optimizar tu perfil, prepararte para entrevistas y desarrollar una estrategia efectiva de búsqueda laboral, con el objetivo de que estés mejor preparado para acceder a oportunidades reales en la industria."
}


class BootcampEnginier extends Component {
    constructor(props) {
        super(props);
        this.state = {
            Temario: "https://media.dojofullstack.com/FULLSTACK-2025-dojofullstack-v4m.pdf",
            langUS: false,
            isBeca50: false,
            Turnos: [
                {key: "noche", label: "Noche"},
                {key: "dia", label: "Mañana"},
            ],
            bootcampSlug: 'fullstack',
            bootcampSlugDescuento: 'fullstack',
            bootcampSlugPre: 'fullstack',
            bootcampSlug: 'fullstack',
            bootcampSlug2: 'fullstack',
            IsEspecial24h: false,
            FooterColor: 'linear-gradient(to right, slateblue, rgb(40, 2, 17))',
            FechaEspecial24h: '',
            timestamp24h: "",
            linkPayUSD: "",
            isPricePais: false,
            semibeca_activo: false,
            semibeca_img: "",
            isMount: false,
            beca: '',
            audio: '',
            isPlayed: false,
            pricingAPI: {},
            fecha_start_end: "",
            isPriceEspecial: false,
            PriceEspecialBody: "",
            PriceEspecialPreBody: "",
            timePrueba: "",
            DataFechas: [],
            mesesInicio: [],
            fechaLimite: "",
            showWasapInput: false,
            Eventos: {},
            selectWebinarFecha: 0,
            utc_offset: '-0500',
            Plan: 1,
            formaPago: 1,
            utc_dif: 0,
            select_mes: "",
            select_turno: "",
            select_modalidad: "",
            Email: "",
            Name: "",
            LastName: "",
            Phone: "",
            fechaSelect: "fecha_1",
            isOpenMett: false,
            isOpenSemiBeca: false,
            isOpenSuscribe: false,
            isOpen0: false,
            isOpen: false,
            isOpen2: false,
            isOpen3: false,
            isOpenResume: false,
            isOpenResumeFlex: false,
            countryCode: "US",
            price_cuota: "",
            price_cuota_2: "",
            price_cuota_22: "",
            price_completo: "",
            price_completo_regular: "",
            price_completo_2: "",
            price_completo_regular_2: "",
            price_mensual: "",
            price_preinscripcion: "",
            price_mensual_regular: "",
            titlePrice: "",
            price_ahorro: "",
            descuento: "",
            price_payment: "1",
            salario_fullstack_jr: "+$30,000 USD / ANUAL",
            salario_fullstack_md: "+$30,000 USD / ANUAL",
            salario_fullstack_sr: "+$60,000 USD / ANUAL",
            usa_salario_fullstack_jr: "+$30,000 USD / ANUAL",
            usa_salario_fullstack_md: "+$60,000 USD / ANUAL",
            usa_salario_fullstack_sr: "+$60,000 USD / ANUAL",
            isOpenCheckout: false,
            days: 0,
            mes: 1,
            hours: 0,
            minutes: 0,
            seconds: 0,
            enrollMes: "",
            enrollDay: "",
            photoIndex: 0,
            isOpenImg: false,
            MesAcceso: null,
            loadingEnroll: false,
            isCuota: 1 ,
            showMore: false,
            showMoreA: false,
            showMoreB: false,
            showMoreC: false,
            showMoreD: false,
            showMoreE: false,
            showMoreF: false,
            showMoreG: false,
            showMoreI: false,
            showPhoneField: false,
            VideoPitch: false,
            sendDataForm: false,
            isOpenShowPrueba: false,
            agendarActive: false,
            planPagoUSD: "",
            planPagoPE: "",
            isOpenPlanPay: false,
            DescuentoBody: "",
            price_mount: "",
            selectFecha: false,
            DescuentoBodyUSD: "",
            DescuentoBodyPEN: "",
            isOpenReunion: false,
            cuotaDolar: '',
            cuotaSoles: '',
            isOpenModalInfo: false,
            isModalWS: false,
            priceConversion: "",
            garantia: false,
            showButton: true,
            timeCounter: "",
            showDeadLine: false,
            isFlashEspecial: true,
            price_view_base: "",
            porcentajeDescuento: "",
            showWeb: true,
            showWebNow: false,
            showBtnWasi: false,
            showBtnTemario: false,
            showNotifPay: false,
            showPrice: false,
            showBecaParcial: false,
            linkBecaParcial: false,
            linkPayCard: "",
            isOpenBrochure: false,
            showPayal: false,
            fbclid_short_code: "",
            initialOptions: {
                clientId: "AZeHtz9ynRf6LBFEZCIwQcl-wGC6rVlfGKTH44LBcZ9BVs-INyQQ3VpFYAFWAdX2m2GjMhZBmTQ4Dw-C",
                currency: "USD",
                intent: "capture",
                locale: "es_MX",
        }
        };
        this.openModalEmail = this.openModalEmail.bind(this);
        this.openModalWebinar = this.openModalWebinar.bind(this);
        this.openModalCheckout = this.openModalCheckout.bind(this);
        // this.openModalSuscribe = this.openModalSuscribe.bind(this);
        this.openModalVid = this.openModalVid.bind(this);
        this.selectBoot = this.selectBoot.bind(this);
        this.openModal0 = this.openModal0.bind(this);
        this.openModal = this.openModal.bind(this);
        this.openModal2 = this.openModal2.bind(this);
        this.openModal3 = this.openModal3.bind(this);
        this.openModal4 = this.openModal4.bind(this);
        this.openModalPrueba = this.openModalPrueba(this);
        this.menuTrigger = this.menuTrigger.bind(this);
        this.CLoseMenuTrigger = this.CLoseMenuTrigger.bind(this);
        this.stickyHeader = this.stickyHeader.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.onSubmitBeca = this.onSubmitBeca.bind(this);
        this.onRenderOption = this.onRenderOption.bind(this);
        this.OpenWS = this.OpenWS.bind(this);
        this.GetLinkWS = this.GetLinkWS.bind(this);
        this.FechaEnroll = this.FechaEnroll.bind(this);
        this.setEmailValidate = this.setEmailValidate.bind(this);
        this.searchEvento = this.searchEvento.bind(this);
        this.DynamicCountry = this.DynamicCountry.bind(this);
        this.fetchPricingData = this.fetchPricingData.bind(this);
    this.getFbclid = this.getFbclid.bind(this);
    this.generarCodigoCorto = this.generarCodigoCorto.bind(this);
    this.eventPing = this.eventPing.bind(this);
    this.generarFBC = this.generarFBC.bind(this);


       //  this.subMetuTrigger = this.subMetuTrigger.bind(this);

    //    window.addEventListener('load', function() {
    //     document.title = 'Desarrollo Web Full Stack Developer Bootcamp | online en vivo | DojoFullStack';
    //     })

    }

 getFbclid() {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get("fbclid");
  }



  generarCodigoCorto(fbclid) {
    if (!fbclid) return null;
  
    // Simple hash a base36 + slice
    let hash = 0;
    for (let i = 0; i < fbclid.length; i++) {
      hash = fbclid.charCodeAt(i) + ((hash << 5) - hash);
    }
  
    // Convertir hash a base36 y tomar 5 caracteres únicos
    return Math.abs(hash).toString(36).substring(0, 4).toUpperCase();
  }



  generarFBC(fbclid) {
    if (!fbclid) return null;
    const timestamp = Date.now(); // tiempo UNIX en milisegundos
    return `fb.1.${timestamp}.${fbclid}`;
  }


    eventPing(fbclid_short_code, fbclid) {

      if (fbclid){
        const payload = {
          "event_name": "fbclid",
          "fbclid_short_code": fbclid_short_code,
          "fbclid": fbclid
       }
       axios.post("https://api.dojofullstack.com/api/v1/crm/event-fbclid", payload).then((res) => {
        //guardar fbclid_short_code en localstorage
        localStorage.setItem("fbclid_short_code", fbclid_short_code);
       })

      }
    
      };
  

    TrackEventConversion(){
        try {
            window.fbq('track', 'AddToCart', {
                value: this.state.price_mount,                 // Valor total de la compra
                currency: 'USD',               // Moneda utilizada (ISO 4217)
                content_type: 'product',       // Tipo de contenido
                content_ids: ['bootcamp'],  // ID del producto o identificador
                content_name: 'bootcamp'
            })

            // window.fbq("track", "Contact");
            window.gtag_report_conversion();
        } catch (error) {
            console.log(error);
        }
    }


    getFormattedDate() {
                const date = new Date();
            const day = date.getDate();
            const monthNames = [
                'Enero', 'Febrero', 'Marzo', 'Abril',
                'Mayo', 'Junio', 'Julio', 'Agosto',
                'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
            ];
            const month = monthNames[date.getMonth()];
            const year = date.getFullYear();

            return `${day} de ${month} ${year}`;
        }



    DynamicCountry(country='' ){


                this.sleep(1500).then(r => {
                        const timerBar = document.getElementById('counter-deadline');
                        const originalOffset = timerBar.offsetTop;
                        window.addEventListener('scroll', () => {
                            if (window.scrollY > originalOffset) {
                            timerBar.classList.add('sticky');
                            } else {
                            timerBar.classList.remove('sticky');
                            }
                        });
                })



        const isParameterPresent = (param) => {
            const urlParams = new URLSearchParams(window.location.search);
            return urlParams.has(param);
        }

        window.urlWasi = this.GetLinkWS();

        const newCountry = country || this.state.countryCode;

        if (country){
            
            const TemarioUSA = 'https://plataforma-dojopy-media.s3.us-east-1.amazonaws.com/FULLSTACK-2025-EN-VIVO-4m-usa_LIVE.pdf';


            this.setState({
              countryCode: country,
              pay_currency_code: "USD",
              initialOptions: {...this.state.initialOptions, locale: `es_${country}`},
          })


            
        }



        function getPaymentParameter(url) {
            // Crear un objeto URL a partir de la cadena de la URL
            const urlObj = new URL(url);
            // Obtener los parámetros de búsqueda
            const params = new URLSearchParams(urlObj.search);
            // Leer el valor del parámetro "payment"
            return params.get('payment') || params.get('pay');
        }


        function getDiscountParameter(url) {
            // Crear un objeto URL a partir de la cadena de la URL
            const urlObj = new URL(url);
            // Obtener los parámetros de búsqueda
            const params = new URLSearchParams(urlObj.search);
            // Leer el valor del parámetro "payment"
            return params.get('discount');
        }

        const discountActive = getDiscountParameter(window.location.href);

        if (discountActive){

            if (discountActive.includes("views")){
                toast.success("Solicita más información sobre el Bootcamp Full Stack Developer en vivo y en línea. ¡Estamos aquí para ayudarte!");
            
                this.sleep(5000).then(r => {
                    const texto = "Hola, me gustaría obtener más información sobre el bootcamp de desarrollador full stack.";
                    window.open(`https://api.whatsapp.com/send?phone=51936670597&text=${texto}`, '_self').focus();
                })


            } else {

                toast.success("¡Obtén ahora mismo un exclusivo código de descuento para el Bootcamp Full Stack Developer online!");
            
                this.sleep(3500).then(r => {
                    const texto = "Hola, tengo un código de descuento para el Bootcamp Full Stack Developer online. #CODE100OFF";
                    window.open(`https://api.whatsapp.com/send?phone=51936670597&text=${texto}`, '_self').focus();
                  })

            }

            
        

        }


        const paymentValue = getPaymentParameter(window.location.href);
        if (paymentValue !== null){
            // console.log(paymentValue);

            if (paymentValue.includes("beca")){
                this.setState({showBecaParcial: true});
            }
            
            const codes = this.state.pricingAPI["redirect"]["codes"];

            if (codes[paymentValue]){
                this.setState({linkBecaParcial: codes[paymentValue]});


                if (!this.state.showNotifPay){
                    toast.success("Un momento por favor, te estamos llevando al sistema de pago.");
                }

                this.sleep(1000).then(r => {
                    window.location.href = codes[paymentValue];
                  })
                  this.setState({showNotifPay: true});

            }
        }


        
        this.setState({
            linkPayUSD: this.state.pricingAPI[this.state.bootcampSlug].linkPayUSD || '',
            select_mes:  this.state.pricingAPI[this.state.bootcampSlug]['fechas'][0]['mes'],
            isPricePais: false,
            utc_offset: '-0500',
            utc_dif: 0,
            timestamp24h: this.state.pricingAPI[this.state.bootcampSlug]['timestamp24h'],
            semibeca_img: this.state.pricingAPI[this.state.bootcampSlug]['semibeca_img'],
            DataFechas: this.state.pricingAPI[this.state.bootcampSlug]['fechas'],
            mesesInicio: this.state.pricingAPI[this.state.bootcampSlug]['mesesInicio'],
            Turnos: this.state.pricingAPI[this.state.bootcampSlug]['turnos'],
            fechaLimite: this.state.pricingAPI[this.state.bootcampSlug]['fechaLimite'],
            isPriceEspecial: this.state.pricingAPI[this.state.bootcampSlug]['isPriceEspecial'],
            PriceEspecialBody: this.state.pricingAPI[this.state.bootcampSlug]['PriceEspecialBody'],
            PriceEspecialPreBody: this.state.pricingAPI[this.state.bootcampSlug]['PriceEspecialBody'],
            timePrueba: this.state.pricingAPI[this.state.bootcampSlug]['time_prueba'],
            FooterColor: this.state.pricingAPI[this.state.bootcampSlug]['FooterColor'],
            price_completo: this.state.pricingAPI[this.state.bootcampSlug]['price']['usd']['price_view_base'], //495
            price_completo_regular: this.state.pricingAPI[this.state.bootcampSlug]['price']['usd']['price_view_base_regular'],
            price_mensual: this.state.pricingAPI[this.state.bootcampSlug]['price']['usd']['price_view_final'],
            price_mensual_regular: this.state.pricingAPI[this.state.bootcampSlug]['price']['usd']['price_view_base_regular'],
            titlePrice: this.state.pricingAPI[this.state.bootcampSlug]['titlePrice'],
            titlePricePre: this.state.pricingAPI[this.state.bootcampSlug]['titlePrice'],
            price_payment: "1",
            planPagoUSD: this.state.pricingAPI[this.state.bootcampSlug]['planPagoUSD'],
            planPagoPE: this.state.pricingAPI[this.state.bootcampSlug]['planPagoPE'],
            DescuentoBody: this.state.pricingAPI[this.state.bootcampSlug]['DescuentoBody'],
            price_mount: this.state.pricingAPI[this.state.bootcampSlug]['price']['usd']['mount'],
            DescuentoBodyUSD: this.state.pricingAPI[this.state.bootcampSlug]['DescuentoBodyUSD'],
            DescuentoBodyPEN: this.state.pricingAPI[this.state.bootcampSlug]['DescuentoBodyPEN'],
            cuotaDolar: this.state.pricingAPI[this.state.bootcampSlug]['cuotaDolar'],
            cuotaSoles: this.state.pricingAPI[this.state.bootcampSlug]['cuotaSoles'],
            priceConversion: this.state.pricingAPI[this.state.bootcampSlug]["priceConversion"] || '',
            garantia: this.state.pricingAPI[this.state.bootcampSlug]["garantia"] || false,
            porcentajeDescuento: this.state.pricingAPI[this.state.bootcampSlug]?.porcentajeDescuento || '',
            fecha_inicio: this.state.pricingAPI[this.state.bootcampSlug]["fecha_inicio"] || false,
            redirect: this.state.pricingAPI["redirect"] || false,
            price_completo_2: this.state.pricingAPI[this.state.bootcampSlug]['price']['usd']['price_view_base'], //495
            price_completo_regular_2: this.state.pricingAPI[this.state.bootcampSlug]['price']['usd']['price_view_base_regular'],
        })

        

        try {
            if (this.state.pricingAPI[this.state.bootcampSlug].price[country]){
                this.setState({
                    isPricePais: true,
                    price_completo: this.state.pricingAPI[this.state.bootcampSlug].price[country].price_view_base,
                    price_completo_regular: this.state.pricingAPI[this.state.bootcampSlug].price[country].price_view_base_regular,
                    price_completo_2: this.state.pricingAPI[this.state.bootcampSlug]['price'][country]['price_view_base'],
                    price_completo_regular_2: this.state.pricingAPI[this.state.bootcampSlug]['price'][country]['price_view_base_regular']
                });

                if (country === 'PE') {
                    this.setState({linkPayUSD: this.state.pricingAPI[this.state.bootcampSlug].linkPayPeru || this.state.pricingAPI[this.state.bootcampSlug].linkPayUSD});
                }
            }
        } catch (error) {
            console.log('Log',error);
        }



        if (newCountry === 'PE') {
            this.setState({
                utc_offset: '-0500',
            });
        } else if (newCountry === 'MX') {
            this.setState({
                utc_dif: -1,
                utc_offset: '-0600',
                });
        } else if (newCountry === 'CR'){
            this.setState({utc_dif: -1, utc_offset: '-0600'});
        } else if (newCountry === 'CL'){
            this.setState({utc_dif: -1, utc_offset: '-0400'});
        } else if (newCountry === 'BO'){
            this.setState({
                utc_dif: -1,
                utc_offset: '-0400',
                });
        } else if (newCountry === 'CU'){
            this.setState({utc_dif: +1});
        } else if (newCountry === 'SV'){
            this.setState({utc_dif: -1, utc_offset: '-0600'});
        } else if (newCountry === 'GT'){
            this.setState({utc_dif: -1});
        } else if (newCountry === 'HN'){
            this.setState({utc_dif: -1, utc_offset: '-0600'});
        } else if (newCountry === 'NI'){
            this.setState({utc_dif: -1});
        } else if (newCountry === 'PY'){
            this.setState({utc_dif: +1, utc_offset: '-0300'});
        } else if (newCountry === 'PR'){
            this.setState({utc_dif: +1, utc_offset: '-0300'});
        } else if (newCountry === 'DO'){
            this.setState({utc_dif: +1});
        } else if (newCountry === 'UY'){
            this.setState({
                utc_dif: +2,
                utc_offset: '-0300'
            });
        } else if (newCountry === 'BR'){
            this.setState({
                utc_dif: +2,
                utc_offset: '-0300'
            });
        }

        if (newCountry === 'ES') {
            this.setState({
                utc_offset: '+0100',
            });
        }

    }


    sleep = (milliseconds) => {
        return new Promise(resolve => setTimeout(resolve, milliseconds))
    }

    OpenMeet(){
        if (this.state.Phone){
            window.open(`https://calendly.com/dojopy/bootcamp-fullstack?name=${this.state.Name}&email=${this.state.Email}&phone=${this.state.Phone}`, '_blank').focus();
        } else {
            window.open("https://calendly.com/dojopy/bootcamp-fullstack", '_blank').focus();
        }
    }


    GetLinkWS(){
        let texto = "Hola, me gustaría obtener más información sobre el bootcamp de desarrollador full stack.";
 
        if (window.type_device){
            return `https://api.whatsapp.com/send?phone=51936670597&text=${texto}`;
        } else {
            return `https://web.whatsapp.com/send?phone=51936670597&text=${texto}`;
        }
    }

    GetLinkWSReunion(){
        let texto = "Hola, me gustaría agendar una reunión informativa sobre el bootcamp Full Stack Developer.";
    
        if (window.type_device){
            return `https://api.whatsapp.com/send?phone=51936670597&text=${texto}`;
        } else {
            return `https://web.whatsapp.com/send?phone=51936670597&text=${texto}`;
        }
    }

    OpenWS(){
        const body = this.GetLinkWS();
        window.open(body, '_blank').focus();
        fbq("track", "contact");
    }

  onRenderOption(option, complete) {
    return (
      <li>
        <ReactCountryFlag
          countryCode={option.key}
          svg
          style={{
            width: "2em",
            height: "2em",
            padding: "1px",
          }}
          title="país"
        />{" "}
        {complete ? option.countryNumber : option.key}
      </li>
    );
  }



  onRenderSelection( selected, settings, deselect ){
    return 	(<span style={{ marginRight: 10, padding: 5 }}>
{ selected ?
        <span style={{"color": "#1f1f25"}}>
            <ReactCountryFlag
            countryCode={selected.key}
            svg
            style={{
                width: '2.3em',
                height: '2.3em',
                padding: '7px'
            }}
            title="país"
    />  {selected.countryNumber}
        </span>
        :
           <span style={{padding: 5}}>País</span>
    }
    
<i style={{ paddingLeft: 5, cursor: "pointer" }} onClick={ deselect } className="fa fa-window-close"></i>
</span>)
}


    FechaEnroll(e){
        let fecha_enroll = e.currentTarget.value;
        this.setState({fechaSelect: fecha_enroll});


        window.location.href = '#fechas';
    }


    onSubmit(e, brochure=false) {
        e.preventDefault();
        
        
        if (this.state.Email.trim() === "" || !this.state.Email.trim().includes("@") ) {
            toast.dark('¡Ups! El campo de Email es necesario para continuar.');
            return;
        }

        if (this.state.Phone.trim() === "") {
            toast.dark('¡Ups! El campo Celular es necesario para continuar.');
            return;
          }
  
        this.setState({loadingEnroll: true, sendDataForm: true});

          window.fbq('track', 'Lead', {
            content_name: 'Registro formulario Bootcamp',
            content_category: 'Full Stack Developer Online'
          });

        
          toast.success(`¡Hola ${this.state.Name}! 📄 Te estamos redirigiendo al brochure ahora mismo. Además, en breve recibirás toda la información personalizada por email y WhatsApp. Si tienes dudas, estamos a un mensaje de distancia 💬`);


        const timer = setTimeout(() => {
             this.setState({isOpenBrochure: false, isOpenSuscribe: false, isOpenMett: false, isOpenModalInfo : false, selectFecha: false, loadingEnroll: false});
            window.open(this.state.Temario, '_blank').focus();
        }, 1900); // 3 segundos


        //   ttq.track('CompleteRegistration', {
        //     content_name: 'Registro formulario Bootcamp',
        //     content_category: 'Full Stack Developer Online'
        //   });


//                     toast.success(
//   `¡Hola ${this.state.Name}! 📥 Tu brochure se está descargando.  
// Si necesitas ayuda, escríbenos por WhatsApp.`
// );

// if (brochure){
//         // enviar brochure por email
//         const timer = setTimeout(() => {
//              this.setState({isOpenBrochure: false, isOpenSuscribe: false, isOpenMett: false, isOpenModalInfo : false, selectFecha: false, loadingEnroll: false});
//             toast.success(`¡Hola ${this.state.Name}! 📩 Te enviamos el brochure por email y WhatsApp. Si tienes dudas, estamos a un mensaje de distancia 💬`);
//             window.open(this.state.Temario, '_blank').focus();
//         }, 1500); // 3 segundos
        
// }

// toast.success(`¡Hola ${this.state.Name}! 🎉 Tu solicitud de beca parcial ha sido recibida. Te contactaremos en las próximas 24 horas para confirmar si calificas. ¡Revisa tu email y WhatsApp! 📩💬`);


        localStorage.setItem('email', this.state.Email.trim());
        localStorage.setItem('phone', this.state.Phone.trim());

        if (this.state.Name.trim()){
            localStorage.setItem('name', this.state.Name.trim());
        }

        // const source = window.location.search.split('source=')[1] || 'home';

        axios.post('https://cprij4toee.execute-api.us-east-1.amazonaws.com/dev',
        {evento: false, lead: true, bootcamp: 'Web Full Stack Developer', email: this.state.Email, name: this.state.Name, country: this.state.countryCode,
            Token: "c3b4b89c",
            landing: 'home',
            source: window.location.search,
            phone: this.state.Phone
    },)
        .then(res => {




//             toast.success(
//   `¡Hola ${this.state.Name}! 🎉 Tu inscripción está casi lista. Ahora serás redirigido al pago para asegurar tu plaza. 
// Si necesitas ayuda, escríbenos por WhatsApp.`
// );


            this.setState({isOpenSuscribe: false, isModalWS: false, isOpenMett: false, isOpenModalInfo : false, selectFecha: false, loadingEnroll: false});
            // window.fbq("track", "Contact");
            // window.gtagSendEvent();
            // this.setState({isModalWS: true})
            // const timer = setTimeout(() => {
            //     const link = this.GetLinkWS();
            //     window.open(link, '_blank').focus();
            // }, 5000); // 3 segundos

            window.fbq('track', 'AddToCart', {
                value: this.state.price_mount,                 // Valor total de la compra
                currency: 'USD',               // Moneda utilizada (ISO 4217)
                content_type: 'product',       // Tipo de contenido
                content_ids: ['bootcamp'],  // ID del producto o identificador
                content_name: 'bootcamp'
              });

     
            //   document.querySelector('#fechas').scrollIntoView({ behavior: 'smooth' });
              

            // window.open(`https://media.dojofullstack.com/bootcamp/FULLSTACK-2025-dojofullstack-v17.pdf`, '_blank').focus();

            // window.Calendly.initPopupWidget({url: `https://calendly.com/dojofullstack/agendar?hide_event_type_details=1&hide_gdpr_banner=1&email=${this.state.Email}&name=${this.state.Name}`})

        })
    }




    onSubmitBeca(e) {
        e.preventDefault();
        if(this.state.Email === "" ){
            toast.warning('¡Ups! El campo de Email es necesario para continuar.');
            return;
        }
        // if(this.state.Phone === "" ){
        //     toast.warning('El campo WhatsApp es requerido, para ser atendido por un asesor.');
        //     return;
        // }
        this.setState({loadingEnroll: true, sendDataForm: true});

        localStorage.setItem('email', this.state.Email);
        localStorage.setItem('phone', this.state.Phone);

        // toast.success(`${this.state.Name} enviamos tus datos al equipo de Dojopy, gracias!`);
        // let cupon = window.location.search.split('ref=')[1];
        this.setState({isOpenSuscribe : false, isOpenSemiBeca: false, isOpenMett: false, loadingEnroll: false});

        axios.post('https://cprij4toee.execute-api.us-east-1.amazonaws.com/dev',
        {beca: true , lead: true, bootcamp: 'Web Full Stack Developer', email: this.state.Email, name: this.state.Name, phone: this.state.Phone, country: this.state.countryCode, fecha: this.state.selectWebinarFecha},)
        .then(res => {
            window.gtag_report_conversion();


            toast.success(`Hola!, "¡Gracias por aplicar! Hemos recibido tu solicitud y estamos emocionados de brindarte un descuento adicional. Nuestro equipo revisará tu solicitud y te enviaremos un código de descuento único en un plazo de 24 horas. ¡No olvides revisar tu bandeja de entrada! Si tienes alguna pregunta, no dudes en contactarnos. "`);
            // toast.success(`Hola ${this.state.Name}!, tengamos una breve sesión informativa para completar tu inscripción`);

        })
    }



    searchEvento(myArray, key){
        for (let i=0; i < myArray.length; i++) {
            if (myArray[i].key === key) {
                return myArray[i].value;
            }
        }
    }

    
    sendEventAddCart(){
        window.fbq('track', 'AddToCart', {
            value: this.state.price_mount,                 // Valor total de la compra
            currency: 'USD',               // Moneda utilizada (ISO 4217)
            content_type: 'product',       // Tipo de contenido
            content_ids: ['bootcamp'],  // ID del producto o identificador
            content_name: 'bootcamp'
          });
    }



renderCard(index, modIndex) {
    const item = data[modIndex];
    return (
        <div
        key={index}
        className="carousel-card"
        >
        <div
            className="carousel-card-inner"
            style={{backgroundImage: item.background , backgroundSize: "cover"}}
        >
            {item.title}
        </div>
        </div>
    );
    }

renderCard2(index, modIndex) {
    const item = data2[modIndex];
    return (
        <div
        key={index}
        className="carousel-card mx-2"
        >
        <div style={{width: "295px"}}>
           <div style={{"text-align":"center", "box-shadow": "4px 2px 5px 0px #8080805e", "border-radius": "30px", "padding": "19px", "background": "white"}}>
                <h4>
                {item.title}
                </h4>
                {/* agreg una imagen con un boxshadow suave genial */}
                <img style={{borderRadius: "33px", boxShadow: "0 4px 24px 0 rgba(140, 82, 255, 0.18), 0 1.5px 6px 0 rgba(44, 62, 80, 0.10)" }} alt={item.title} height="199px" src={item.background} />
            </div>
        </div>
        </div>
    );
    }


renderBeca() {
    return (
        <>

 {/* Start PRicing Table Area  */}
 <div className="col-12 mt-1" style={{paddingBottom: "13px", paddingRight: "15px", paddingLeft: "15px", maxWidth: "470px", marginRight: window.type_device ? "auto": "1px" }} >


<div className="rn-pricing" style={{boxShadow: "rgba(140, 82, 255, 0.9) 4px 4px 15px 3px", border: "none", background: "linear-gradient(135deg, #C56CD6 0%,#3425AF 100%)", borderRadius: "20px"}} >
    <div className="pricing-table-inner">

        <div className="pricing-header pb-0 mb-2 mt-1">
  
        
        <span style={{padding: "6px 10px", margin: "5px", "background-color": "tomato", "border-radius": "7px", "color": "white", "font-size": "20px", fontWeight: "bold"}}>
                {this.state.countryCode === 'PE' ? this.state.DescuentoBodyPEN: this.state.DescuentoBodyUSD}
        </span>


        <h3 className="text-white mt-1 mb-0">Monto Total con la Beca50</h3>
             
            <span style={{color: "white", display: "inline-block"}}>
                <del style={{color: "lightgray", fontSize: "25px"}}>
                &nbsp; {this.state.price_completo_regular} &nbsp;
                </del>
            </span>


            <h3 className="pricing" style={{marginBottom: "5px"}} >
            <span style={{color: "white", fontSize: "18px"}}>Ahora: </span>

            {this.renderPrice(this.state.price_completo)}
            </h3>


         

            <div className="slide-btn" style={{marginTop: "15px", textAlign: "center"}}>
                <a href="#empezar" >
                <button
                    onClick={() => {
                    window.fbq('track', 'AddToCart', {
                        value: this.state.price_mount,// Valor total de la compra
                        currency: 'USD',               // Moneda utilizada (ISO 4217)
                        content_type: 'product',       // Tipo de contenido
                        content_ids: ['bootcamp'],  // ID del producto o identificador
                        content_name: 'bootcamp'
                      });
                }}
                id="enroll_bootcamp_2"
                style={{border: "1px solid white", lineHeight: "28px", fontSize: "23px", marginBottom: "13px", padding: "15px 20px" }}
                className=" btn-efect">
                    <HiMiniPencilSquare className="mr-1" />

                Inscríbete Ahora

                 </button>
                </a>
             </div>



        </div>
    </div>


    


</div>
</div>
{/* End PRicing Table Area  */}


        </>
    )
}


renderPais(complete=false){
    return (
        <>
        <span style={{
            fontSize: "17px",
            fontWeight: "bold",
            position: "absolute",
            left: "15px",
            top: "-25px",
            zIndex: "1",
        }} > {true ? "Zona horaria:": "Time zone:"} </span>
            <Selectrix
        height={300}
        onRenderOption={(option) => this.onRenderOption(option, complete)}
        onRenderSelection={(option) => this.onRenderSelection(option, complete)}
        placeHolderInside={true}
        placeholder={"País"}
        customScrollbar={true}
        searchable={false}
        materialize={false}
        defaultValue={this.state.countryCode}
        options={KeyCountry}
        onChange={value => {
            // if (value.key === 'US'){ window.location.href = '/us'}
            this.DynamicCountry(value.key)}
        }
    />
        </>

    )
}




renderMes(){
    return (
        <>
        <span style={{
            fontSize: "17px",
            fontWeight: "bold",
            position: "absolute",
            left: "15px",
            top: "-25px",
            zIndex: "1",
        }} > {true ? "Mes:": "Month:"} </span>
        <Selectrix
        height={250}
        placeHolderInside={true}
        placeholder={true ? "Todos": "All" }
        customScrollbar={true}
        searchable={false}
        materialize={false}
        defaultValue={this.state.select_mes}
        options={this.state.mesesInicio.map((item) => ({key: item, label: item})) }
        onChange={value => this.setState({select_mes: value.key})}
    />
        </>

    )
}

renderTurno(){
    return (
        <>
        <span style={{
            fontSize: "17px",
            fontWeight: "bold",
            position: "absolute",
            left: "15px",
            top: "-25px",
            zIndex: "1",
        }} >{true ? "Turno": "Shift"}:</span>
        <Selectrix
        height={250}
        placeHolderInside={true}
        placeholder={true ? "Todos": "All" }
        customScrollbar={true}
        searchable={false}
        materialize={false}
        defaultValue={this.state.select_turno}
        options={this.state.Turnos}
        onChange={value => this.setState({select_turno: value.key})}
    />
        </>

    )
}


renderPrice(price,  prueba=false){
        return (
            <>
                <div className="row" style={{placeContent: "center", fontFamily: "'Poppins',sans-serif"}}>
                <div className="col-12">

                    <p style={{marginTop: '5px', fontFamily: "'Poppins',sans-serif", fontSize: window.type_device ? '39px': '45px', "color": prueba ? "#B8860B": "white", fontWeight: "bold", paddingTop: "7px", paddingBottom: "7px"}}>
                         {price} 
                    </p>
                </div>
                </div>
           
            </>
        )
}


renderInfoBootcamp(){
    return (
        <div>

        <p style={{marginBottom: window.type_device ? "7px": "12px", fontSize: "16px"}}>
        <span style={{"color":"slateblue", "fontSize": "25px"}}> <FiCheckCircle style={{fontSize: "21px", marginRight: "7px", color: "slateblue"}} /> </span>
        Acceso inmediato a clases en vivo y plataforma 100 % práctica.
        </p>
        <p style={{marginBottom: window.type_device ? "7px": "12px", fontSize: "16px"}}>
        <span style={{"color":"slateblue", "fontSize": "25px"}}> <FiCheckCircle style={{fontSize: "21px", marginRight: "7px", color: "slateblue"}} /> </span>
        Proyectos reales + Mentorías 1:1 con expertos en Frontend, Backend y DevOps.
        </p>

        <p style={{marginBottom: window.type_device ? "7px": "12px", fontSize: "16px"}}>
        <span style={{"color":"slateblue", "fontSize": "25px"}}> <FiCheckCircle style={{fontSize: "21px", marginRight: "7px", color: "slateblue"}} /> </span>
        Plan de estudios completo: HTML, CSS, JavaScript, Python, AWS y más.
        </p>
    
        <p style={{marginBottom: window.type_device ? "7px": "12px", fontSize: "16px"}}>
        <span style={{"color":"slateblue", "fontSize": "25px"}}> <FiCheckCircle style={{fontSize: "21px", marginRight: "7px", color: "slateblue"}} /> </span>
        Preparación Laboral Real y bolsa de vacantes exclusiva.
        </p>
        
     

        </div>
    )
}

renderPriceFooter(price){
        return (
            <>
                <span style={{fontSize: "17px", "color": "white", fontWeight: 500, paddingTop: "5px", paddingBottom: "5px"}}>
                    2 pagos de {price}
                </span>
                <ReactCountryFlag
                        countryCode={this.state.countryCode}
                        svg
                        style={{
                            width: '3.5em',
                            height: '3.5em',
                            padding: '9px'
                        }}
                        title="país"
                    />
            </>
        )
      }

      renderHorario(){
            if (this.state.countryCode === "PE" || this.state.countryCode === "EC" || this.state.countryCode === "CO") {
                return  <p style={{fontSize: "17px", fontWeight: 500}} className="mb-1">
                    <ReactCountryFlag
                countryCode={this.state.countryCode}
                svg
                style={{
                    width: '1.8em',
                    height: '1.8em',
                    padding: '1px'
                }} title="país" /> 7:00 PM a 09:00 PM</p>
            } else if (this.state.countryCode === "MX" || this.state.countryCode === "HN" || this.state.countryCode === "CR") {
                return  <p style={{fontSize: "17px", fontWeight: 500}} className="mb-1"><ReactCountryFlag
                countryCode={this.state.countryCode}
                svg
                style={{
                    width: '1.8em',
                    height: '1.8em',
                    padding: '1px'
                }} title="país" />6:00 PM a 08:00 PM</p>
            } else if (this.state.countryCode === "BO") {
                return  <p style={{fontSize: "17px", fontWeight: 500}} className="mb-1"><ReactCountryFlag
                countryCode={this.state.countryCode}
                svg
                style={{
                    width: '1.8em',
                    height: '1.8em',
                    padding: '1px'
                }} title="país" />8:00 PM a 10:00 PM</p>
            }  else {
                return  <p style={{fontSize: "17px", fontWeight: 500}} className="mb-1"><ReactCountryFlag
                countryCode={this.state.countryCode}
                svg
                style={{
                    width: '1.8em',
                    height: '1.8em',
                    padding: '1px'
                }} title="país" />7:00 PM a 09:00 PM</p>
            }
      }

      renderHorarioFinSemana(){
        if (this.state.utc_offset === "-0500") {
            return  <p style={{fontSize: "17px", fontWeight: 500}} className="mb-1"><ReactCountryFlag
                countryCode={this.state.countryCode}
                svg
                style={{
                    width: '2.5em',
                    height: '2.5em',
                    padding: '8px'
                }} title="país" />10:00 AM a 12:00M</p>
        } else if (this.state.utc_offset === "-0600"){
            return  <p style={{fontSize: "17px", fontWeight: 500}} className="mb-1"><ReactCountryFlag
                countryCode={this.state.countryCode}
                svg
                style={{
                    width: '2.5em',
                    height: '2.5em',
                    padding: '8px'
                }} title="país" />10:00 AM a 12:00M</p>
        } else if (this.state.utc_offset === "-0400"){
            return  <p style={{fontSize: "17px", fontWeight: 500}} className="mb-1"><ReactCountryFlag
                countryCode={this.state.countryCode}
                svg
                style={{
                    width: '2.5em',
                    height: '2.5em',
                    padding: '8px'
                }} title="país" />10:00 AM a 12:00M</p>
        } else if (this.state.utc_offset === "+0100"){
            return  <p style={{fontSize: "17px", fontWeight: 500}} className="mb-1"><ReactCountryFlag
                countryCode={this.state.countryCode}
                svg
                style={{
                    width: '2.5em',
                    height: '2.5em',
                    padding: '8px'
                }} title="país" />10:00 AM a 12:00M</p>
        } else {
            return  <p style={{fontSize: "17px", fontWeight: 500}} className="mb-1"><ReactCountryFlag
                countryCode={this.state.countryCode}
                svg
                style={{
                    width: '2.5em',
                    height: '2.5em',
                    padding: '8px'
                }} title="país" />10:00 AM a 12:00M</p>
        }

    }

    renderHorarioFinSemanaTarde(){
        if (this.state.utc_offset === "-0500") {
            return  <p style={{fontSize: "17px", fontWeight: 500}} className="mb-1">03:00 PM a 05:30 PM</p>
        } else if (this.state.utc_offset === "-0600"){
            return  <p style={{fontSize: "17px", fontWeight: 500}} className="mb-1">02:00 PM a 04:35 PM</p>
        } else if (this.state.utc_offset === "-0400"){
            return  <p style={{fontSize: "17px", fontWeight: 500}} className="mb-1">04:00 PM a 06:35 PM</p>
        } else if (this.state.utc_offset === "+0100"){
            return  <p style={{fontSize: "17px", fontWeight: 500}} className="mb-1">09:00 PM a 11:35 PM</p>
        } else {
            return  <p style={{fontSize: "17px", fontWeight: 500}} className="mb-1">03:00 PM a 05:35 PM</p>
        }
    }


    obtenerDiaActual() {
        try {
            const diasDeLaSemana = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
            const fechaActual = new Date();
            const diaActual = fechaActual.getDay(); // Obtiene el índice del día (0=domingo, 1=lunes, etc.)
            return diasDeLaSemana[diaActual]; // Devuelve el día correspondiente en texto
        } catch (error) {
            return ""
        }
    }


    renderFechaSelect(item, key){
        return (
            <div key={key} className="row row--35 align-items-center rn-address py-3" data-aos="fade-up"  style={{boxShadow: "#c6c9d8 8px 6px 15px 10px"}} >
            <div className="col-12 mb-1">
                <h2 style={{marginBottom: "0px", fontSize: window.type_device && "27px" }}>
                             <FaCalendarWeek className="mr-1" />  {this.state.fecha_inicio}

                </h2>

                <div style={{width: window.type_device ? "200px": "450px", height: "6px", backgroundColor: "#ffcb48", marginBottom: "20px", transform: "rotate(178deg)", marginTop: "-2px"}}></div>
                
           
                <div className="row">
                    <div className="col-lg-2 col-md-3 col-12  my-0">
                     <span style={{padding: "3px", marginLeft: "8px", "background-color": "tomato", "border-radius": "7px", "padding-left": "7px", "padding-right": "7px", "color": "white", "font-size": "18px"}}>
                                <span className="pulsar"></span> {!this.state.langUS ? "En vivo": "Live"}
                        </span>
                    </div>
               
                </div>
            </div>

            <div className="col-md-3 col-12 mt-2" style={{borderRight: !window.type_device ? "1px solid #121212" : "none" }}>
                <div> <h5 className="mb-2" ><b> {true ? "Duración": "Duration"} </b></h5> </div>
                <div> <p style={{fontSize: "17px"}}> Duración: 4 meses
                <span style={{display: "inline-block"}}></span>
                </p> </div>
           
            </div>

            <div className="col-md-3 col-12 mt-2" style={{marginTop: window.type_device ? "3px": "none", borderRight: !window.type_device ? "1px solid #121212" : "none" }}>
                <div> <h5 className="mb-2"><b> {true ? "Días": "Days"} </b></h5> </div>
                <div> <p style={{fontSize: "17px"}}> {item.dias} </p> </div>
            </div>

            <div className="col-md-3 col-12 mt-2" style={{marginTop: "none"}}>
            <div> <h5 className="mb-2">
                <b>
                Horario
                 {item.turno === 'dia' &&  <> (Mañana) <BsSun style={{height: "25px", width: "25px", color: "goldenrod", marginLeft: "3px", fontSize: "23px"}}/>  </>  }
                 {item.turno === 'tarde' && <> (Tarde) <BsCloudSunFill style={{height: "25px", width: "25px", color: "darkblue", marginLeft: "3px", fontSize: "23px"}} /> </>  }
                 {item.turno === 'noche' && <> (Noche) <MdModeNight style={{height: "25px", width: "25px", color: "darkblue", marginLeft: "3px", fontSize: "23px"}} /> </>   }
                </b>
                </h5> </div>
                <div className="row">
                    <div className="col-12">

                    {(item.turno == 'noche' || item.turno == 'night') && this.renderHorario() }
                    {item.turno == 'dia'  && this.renderHorarioFinSemana() }
                    {item.turno == 'tarde'  && this.renderHorarioFinSemanaTarde() }
                    </div>

                </div>
            </div>
            


<div className="col-12" style={{boxShadow: "none", padding: "8px"}}>
<a href={`#empezar`} >
<button onClick={this.sendEventAddCart} className="btn-efect-2" style={{border: "1px solid white", padding: "10px 25px", fontSize: '23px', textTransform: "none", fontFamily: "Poppins, sans-serif"}} >


    Solicitar mi beca parcial

</button>
</a>


</div>










        </div>
        )
      }


      renderFechas() {
        return (
            <div>

   <div className="row row--35 align-items-center rn-address py-3 mb-2 mb-5" data-aos="fade-up"  style={{boxShadow: "#c6c9d8 8px 6px 15px 10px"}} >
            <div className="col-12 mb-1">

                     <div className="row" style={{justifyContent: "space-between", alignItems: "center"}}>
                            <div className="">
                                <span style={{fontWeight: "bold", display: "inline-block", padding: "0.5rem 1rem", marginLeft: "7px", "background-color": "tomato", "border-radius": "33px", "color": "white", "font-size": "18px"}}>
                                    <span className="pulsar mr-1"></span> {!this.state.langUS ? "En vivo": "Live"}
                                </span>
                              </div>

                            <div className=" my-0">
                                 <span className="px-1" style={{fontWeight: "normal", fontSize: "15px", color: "#6b7280"}}>
                                   Próximo inicio
                                  </span>
                            </div>
                    </div>
                    

                <h2 className="mt-2" style={{marginBottom: "0px", fontSize: window.type_device && "27px" }}>
                    {this.state.fecha_inicio}
                </h2>

                <div style={{width: window.type_device ? "200px": "450px", height: "6px", backgroundColor: "#ffcb48", marginBottom: "20px", transform: "rotate(178deg)", marginTop: "-2px"}}></div>
                       <p className="my-0" style={{fontSize: "16px", color: "#6b7280"}}>
                    Interacción directa y feedback personalizado
                </p>
           
        
            </div>

      

            <div className="col-md-6 col-12 mt-2" style={{marginTop: window.type_device ? "3px": "none"}}>
                     <div> <p style={{fontSize: "16px"}}>
                    <FaCalendarWeek className="mr-1" /> <b> {this.state.fecha_inicio} </b>  - Fecha de inicio
                <span style={{display: "inline-block"}}></span>
                </p> </div>
                
                 <div> <p style={{fontSize: "16px"}}> 
                  <FaCheckCircle style={{fontSize: "19px"}} className="mr-1" /> 
                  <b> ⏰ 7:00 PM - 9:00 PM</b> <ReactCountryFlag countryCode={this.state.countryCode} svg style={{
                                                                                                            width: '2.3em',
                                                                                                            height: '2.3em',
                                                                                                            padding: '7px'
                                                                                                        }} title="país"/>
                    </p>
                    </div>

                     <div> <p style={{fontSize: "16px"}}> 
                  <FaCheckCircle style={{fontSize: "19px"}} className="mr-1" /> 
                  <b>  4 meses </b> <br/>
                - Martes y jueves
                    </p>
                    </div>

         


                        <div> <p style={{fontSize: "16px"}}> 
                  <FaCheckCircle style={{fontSize: "19px"}} className="mr-1" />  Basado en proyectos reales.
                    </p>
                    </div>
                         <div> <p style={{fontSize: "16px"}}> 
                  <FaCheckCircle style={{fontSize: "19px"}} className="mr-1" />  Sesiones grupales y mentorías con expertos.
                    </p>
                    </div>
                    
                    <div> <p style={{fontSize: "16px"}}> 
                  <FaCheckCircle style={{fontSize: "19px"}} className="mr-1" />  Acceso a Plataforma y comunidad exclusiva.
                    </p>
                    </div>

                    <div> <p style={{fontSize: "16px"}}> 
                  <FaCheckCircle style={{fontSize: "19px"}} className="mr-1" />  Preparación laboral y bolsa de vacantes.
                    </p>
                    </div>
                    
                         <div> <p style={{fontSize: "16px"}}>
                  <FaCheckCircle style={{fontSize: "19px"}} className="mr-1" />  Certificado internacional.
                    </p>
                    </div>


                           <div> <p style={{fontSize: "16px"}}> 
                  <FaCheckCircle style={{fontSize: "19px"}} className="mr-1" />  Accede de por vida a todos los recursos del bootcamp.
                    </p>
                    </div>
            </div>



<div className="col-12 mt-1" style={{boxShadow: "none", padding: "8px"}}>


<button onClick={this.sendEventAddCart} className="btn-efect-2" style={{border: "1px solid white", padding: "10px 25px", fontSize: '23px', textTransform: "none", fontFamily: "Poppins, sans-serif"}} >

                    Reservar plaza

</button>



</div>


        </div>

{/* 
     <div className="row row--35 align-items-center rn-address py-3 mb-2" data-aos="fade-up"  style={{boxShadow: "#c6c9d8 8px 6px 15px 10px"}} >
            <div className="col-12 mb-1">

                     <div className="row" style={{justifyContent: "space-between", alignItems: "center"}}>
                            <div className="">
                                <span style={{fontWeight: "bold", display: "inline-block", padding: "0.5rem 1rem", marginLeft: "7px", "background-color": "#d1fae5", "border-radius": "33px", "color": "#065f46", "font-size": "18px"}}>
                                  <MdOutlineVideoLabel className="mr-1" />  Asíncrono
                                </span>
                              </div>

                            <div className=" my-0">
                                 <span className="px-1" style={{fontWeight: "normal", fontSize: "15px", color: "#6b7280"}}>
                                   Acceso inmediato
                                  </span>
                            </div>
                    </div>
                    

                <h2 className="mt-2" style={{marginBottom: "0px", fontSize: window.type_device && "27px" }}>
                    Modalidad A Tu Ritmo
                </h2>

                <div style={{width: window.type_device ? "200px": "450px", height: "6px", backgroundColor: "#ffcb48", marginBottom: "20px", transform: "rotate(178deg)", marginTop: "-2px"}}></div>
                       <p className="my-0" style={{fontSize: "16px", color: "#6b7280"}}>
                    Aprende cuando quieras, donde quieras
                </p>
           
        
            </div>

        

            <div className="col-md-6 col-12 mt-2" style={{marginTop: window.type_device ? "3px": "none"}}>
                   <div> <p style={{fontSize: "16px"}}> <MdWatchLater style={{fontSize: "23px"}}  className="mr-1" />  <b>180 horas </b> 
                de contenido y recursos.
                <span style={{display: "inline-block"}}></span>
                </p> </div>

                <div> <p style={{fontSize: "16px"}}> 
                  <FaCheckCircle style={{fontSize: "19px"}} className="mr-1" />  Accede de por vida, sin límites de tiempo ni lugar.
                    </p>
                    </div>
                        <div> <p style={{fontSize: "16px"}}> 
                  <FaCheckCircle style={{fontSize: "19px"}} className="mr-1" />  Disponible 24/7 en todos los dispositivos
                    </p>
                    </div>
                         <div> <p style={{fontSize: "16px"}}> 
                  <FaCheckCircle style={{fontSize: "19px"}} className="mr-1" />  Recursos y materiales descargables
                    </p>
                    </div>
                    
                    <div> <p style={{fontSize: "16px"}}> 
                  <FaCheckCircle style={{fontSize: "19px"}} className="mr-1" />  Acceso a comunidad exclusiva
                    </p>
                    </div>

                    <div> <p style={{fontSize: "16px"}}> 
                  <FaCheckCircle style={{fontSize: "19px"}} className="mr-1" />  Soporte profesional y mentorías.
                    </p>
                    </div>
                    
                         <div> <p style={{fontSize: "16px"}}> 
                  <FaCheckCircle style={{fontSize: "19px"}} className="mr-1" />  Certificado oficial de finalización
                    </p>
                    </div>
            </div>



<div className="col-12 mt-1" style={{boxShadow: "none", padding: "8px"}}>
<a href={`/enroll/${this.state.bootcampSlug}/${this.state.countryCode}`}>

<button onClick={this.sendEventAddCart} className="btn-efect-2" style={{border: "1px solid white", padding: "10px 25px", fontSize: '23px', textTransform: "none", fontFamily: "Poppins, sans-serif"}} >

                    Comenzar ahora
</button>
</a>


</div>


        </div> */}







      {/* <div className="row row--35 align-items-center rn-address py-3" data-aos="fade-up"  style={{boxShadow: "#c6c9d8 8px 6px 15px 10px"}} >
            <div className="col-12 mb-1">
                <h2 style={{marginBottom: "0px", fontSize: window.type_device && "27px" }}>
                             <FaCalendarWeek className="mr-1" />  {this.state.fecha_inicio}

                </h2>

                <div style={{width: window.type_device ? "200px": "450px", height: "6px", backgroundColor: "#ffcb48", marginBottom: "20px", transform: "rotate(178deg)", marginTop: "-2px"}}></div>
                
           
                <div className="row">
                    <div className="col-lg-2 col-md-3 col-12  my-0">
                     <span style={{padding: "3px", marginLeft: "8px", "background-color": "tomato", "border-radius": "7px", "padding-left": "7px", "padding-right": "7px", "color": "white", "font-size": "18px"}}>
                                <span className="pulsar"></span> {!this.state.langUS ? "En vivo": "Live"}
                        </span>
                    </div>
               
                </div>
            </div>

            <div className="col-md-3 col-12 mt-2" style={{borderRight: !window.type_device ? "1px solid #121212" : "none" }}>
                <div> <h5 className="mb-2" ><b> {true ? "Duración": "Duration"} </b></h5> </div>
                <div> <p style={{fontSize: "17px"}}> 4 meses
                <span style={{display: "inline-block"}}></span>
                </p> </div>
           
            </div>

            <div className="col-md-3 col-12 mt-2" style={{marginTop: window.type_device ? "3px": "none", borderRight: !window.type_device ? "1px solid #121212" : "none" }}>
                <div> <h5 className="mb-2"><b> {true ? "Días": "Days"} </b></h5> </div>
                <div> <p style={{fontSize: "17px"}}> Martes y Jueves </p> </div>
            </div>

            <div className="col-md-3 col-12 mt-2" style={{marginTop: "none"}}>
            <div> <h5 className="mb-2">
                <b>
                Horario
                 {true && <> (Noche) <MdModeNight style={{height: "25px", width: "25px", color: "darkblue", marginLeft: "3px", fontSize: "23px"}} /> </>   }
                </b>
                </h5> </div>
                <div className="row">
                    <div className="col-12">

                    { this.renderHorario() }
                    </div>

                </div>
            </div>
            


<div className="col-12" style={{boxShadow: "none", padding: "8px"}}>
<a href={`#empezar`} >
<button onClick={this.sendEventAddCart} className="btn-efect-2" style={{border: "1px solid white", padding: "10px 25px", fontSize: '23px', textTransform: "none", fontFamily: "Poppins, sans-serif"}} >


    Continuar

</button>
</a>


</div>






        </div> */}

       
          </div>

        )}


    selectBoot(plan){
        this.setState({Plan: plan});
        window.location.href='#enroll';
    }

    openModalVid (){
        this.setState({isOpenVid: !this.state.isOpenVid});
    }
    openModal0 () {
        this.setState({isOpen0: !this.state.isOpen0});
    }
    openModalEmail (){
        this.setState({isOpenMett: !this.state.isOpenMett});
    }

    openModalWebinar (){
        this.setState({isOpenSuscribe: true});
    }

    openModalCheckout (){
        this.setState({isOpenCheckout: !this.state.isOpenCheckout});
        this.setState({price_payment: "1"});
        // if (type_bootcamp === 1){
        //     this.setState({price_payment: "95"});
        // } else {
        //     this.setState({price_payment: "175"});
        // }

    }

    // openModalSuscribe (e){
    //     // window.location.href = "/Inscripcion";
    //     // if (e){
    //     //     this.setState({fechaSelect: e.target.value});
    //     // }
    //     this.setState({isOpenSuscribe: !this.state.isOpenSuscribe});
    // }

    openModal () {
        this.setState({isOpen: !this.state.isOpen});
    }

    openModal2 () {
        this.setState({isOpen2: !this.state.isOpen2});
    }
    openModal3 () {
        this.setState({isOpen3: !this.state.isOpen3});
    }
    openModal4(){
        this.setState({isOpenResume: !this.state.isOpenResume});
    }

    openModalPrueba(){
        this.setState({isOpenShowPrueba: !this.state.isOpenShowPrueba});
    }

    menuTrigger() {
        document.querySelector('.header-wrapper').classList.toggle('menu-open');
    }
    CLoseMenuTrigger() {
        document.querySelector('.header-wrapper').classList.remove('menu-open');
    }
    stickyHeader () {}


    validateEmail = (email) => {
        return String(email)
          .toLowerCase()
          .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          );
      };

    setEmailValidate (email){
        this.setState({ Email: email});
        if (this.validateEmail(email)){
            this.setState({showPhoneField: true});
        }
    }



    render(){
        // const PostList = BlogContent.slice(0 , 5);

        window.addEventListener('scroll', function() {
            var value = window.scrollY;
            if (value > 100) {
                document.querySelector('.header--fixed').classList.add('sticky')
            }else{
                document.querySelector('.header--fixed').classList.remove('sticky')
            }
        });

        var elements = document.querySelectorAll('.has-droupdown > a');
        for(var i in elements) {
            if(elements.hasOwnProperty(i)) {
                elements[i].onclick = function() {
                    this.parentElement.querySelector('.submenu').classList.toggle("active");
                    this.classList.toggle("open");
                }
            }
        }

        const style = {
            marginTop: '12px',
            color: '#2F2F2F',
            border: '2px solid #2F2F2F'
          };

          const TypingAnimation =  React.memo(()=>{
            return true ?
            <Typical
            className={'my-tipical'}
            steps={['Conviértete en Full Stack Developer en solo 4 meses', 500, 'y accede a empleos tech con alta demanda laboral.']}
            loop={true}
            wrapper="h2"
                />:
                <Typical
                className={'my-tipical'}
                steps={['Create Full Stack Developer Platforms', 500, 'Get your dream job.', 500, 'The best Full Stack Developer Bootcamp in 5 months.']}
                loop={true}
                wrapper="h2"
                />
          },(props,prevProp)=> true ); // this line prevent re rendering

          const TypingAnimation2 =  ()=> {
            return <Typical
            steps={['Aprende online', 500 ,'con la guía de tu Mentor.', 1000]}
            loop={Infinity}
            wrapper="h2"/>
          }; // this line prevent re rendering

        
          const ButonsFechas = () => {
            return (
                <div data-aos="fade-right" className="col-12 col-md-6"
                style={{marginBottom: "10px",
                      paddingLeft: window.type_device ? "5px": "50px",
                       paddingRight: window.type_device ? "5px": "50px"}}
              >
                  <div style={{textAlign: "center", padding: "5px", borderRadius: "20px"}}>

           
             


                    {FECHAS_EVENTO.map((fecha, index) => (
                            <div className="my-3" key={index} >
                            <button  onClick={() => this.setState({selectFecha: true})}  className="btn-efect" style={{width: "100%", boxShadow: "2px 2px 5px 1px rgba(140, 82, 255, 0.9)"}}>
                                {fecha}
                            </button>
                            </div>
                    ))}
                

                  {/* <div className="my-3" >
                  <button  onClick={() => this.setState({selectFecha: true})}  className="btn-efect" style={{width: "100%"}}>
                    Viernes, 8 de diciembre, 7:00 PM
                  </button>
                  </div>

                  <div className="my-3" >
                  <button  onClick={() => this.setState({selectFecha: true})}  className="btn-efect" style={{width: "100%"}}>
                  Sábado, 9 de diciembre, 12:00M
                  </button>
                  </div> */}

                  </div>
      </div>
            )
          }


        return (
            <Fragment>

                <Helmet>
                    <title>
                        {true ? "Bootcamp Full Stack Developer | online en vivo | DojoFullStack": "Full Stack Developer Bootcamp | 100% live online | DojoFullStack"}
                           </title>
                    <meta name="description"
                        content="Conviértete en Full Stack Developer en nuestro Bootcamp de 4 meses online en vivo, domina el Frontend y el Backend de un sitio web usando HTML, CSS, JavaScript, React, Python y AWS, recibe el Programa de empleabilidad al finalizar. ¡Crea proyectos reales y aprende las mejores prácticas de programación en DojoFullStack!"
                        />
                    <meta
                        property="og:description"
                        content="Conviértete en Full Stack Developer en nuestro Bootcamp de 4 meses online en vivo, domina el Frontend y el Backend de un sitio web usando HTML, CSS, JavaScript, React, Python y AWS, recibe el Programa de empleabilidad al finalizar. ¡Crea proyectos reales y aprende las mejores prácticas de programación en DojoFullStack!"
                        />
                   <meta
                        name="twitter:description"
                        content="Conviértete en Full Stack Developer en nuestro Bootcamp de 4 meses online en vivo, domina el Frontend y el Backend de un sitio web usando HTML, CSS, JavaScript, React, Python y AWS, recibe el Programa de empleabilidad al finalizar. ¡Crea proyectos reales y aprende las mejores prácticas de programación en DojoFullStack!"
                    />
                </Helmet>

                {/* Start Header Area  */}
                <Header callbackOpenModal={() => this.setState({isOpenMett: true}) } bootcampSlug={this.state.bootcampSlug}  langES={this.state.countryCode === 'ES' ? true : false}  countryCode={this.state.countryCode} DynamicCountry={this.DynamicCountry} />
                {/* End Header Area  */}



                {/* Start Slider Area   */}

                <div className="slider-activation slider-creative-agency with-particles" id="home">

                { false &&
                <div className="frame-layout__particles">
                <Particle
                    init={this.customInit}
                    options={{
                        fullScreen: { enable: false },
                        fpsLimit: 120,
                        interactivity: {
                        events: {
                            onHover: {
                                enable: true,
                                mode: "repulse",
                            },
                            resize: true,
                        },
                        modes: {
                            push: {
                                quantity: 4,
                            },
                            repulse: {
                                distance: 200,
                                duration: 0.4,
                            },
                        },
                        },
                    particles: {
                        color: {
                            value: "#ffffff",
                        },
                        links: {
                            color: "#ffffff",
                            distance: 150,
                            enable: true,
                            opacity: 0.5,
                            width: 1,
                        },
                        collisions: {
                            enable: true,
                        },
                        fullScreen: { enable: false },
                        move: {
                            direction: "none",
                            enable: true,
                            outModes: {
                                default: "bounce",
                            },
                            random: false,
                            speed: 2,
                            straight: false,
                        },
                        number: {
                            density: {
                                enable: true,
                                area: 800,
                            },
                            value: 20,
                        },
                        opacity: {
                            value: 0.5,
                        },
                        shape: {
                            type: "circle",
                        },
                        size: {
                            value: { min: 1, max: 5 },
                        },
                    },
                }}

                />;

    </div>
    }


                    <div className="bg_image" style={{backgroundImage: 'linear-gradient(rgb(0 0 0 / 50%), rgb(91 18 237 / 95%)), url(/assets/images/banner-dojofullstack-2025.webp)', paddingBottom: window.location.pathname.includes("masterclass") && !this.state.showWeb ? "99px": "" }}>
                            




<div className="slide slide-style-2 slider-paralax d-flex align-items-center justify-content-center" style={{flexWrap: "wrap"}}>




<div className="container mt-0">






{(this.state.showWeb && this.state.fechaLimite) && (window.location.pathname.includes("beca-parcial")) &&

<div className="col-12 px-0">
<div className="d-inline-flex">

<a href="#empezar">
    <div id="counter-deadline" className="pt-1 pb-2 timer-bar " style={{backgroundColor: "tomato", marginTop: window.type_device ? "0px": "10px"}}> 
                {/* <h5 className="w-100 mt-2 mb-1 text-white text-center px-1" style={{fontSize: "17px"}} > 
                    {this.state.porcentajeDescuento}
                </h5> */}
                <div style={{display: "flex", flexDirection: window.type_device ? "column": "row", justifyContent: "center", alignItems: "center"}}>
                  <h5 className="my-1" style={{fontFamily: "'Poppins',sans-serif", fontSize: "16px", color: "white", textAlign: "center"}} >
⚡ Últimas <strong>5 becas</strong> con {this.state.porcentajeDescuento} ⚡
                </h5>
                <div style={{marginLeft: window.type_device ? "0px": "20px", marginRight: window.type_device ? "0px": "20px", lineHeight: "1.25rem"}}>
                        <FlipCountdown
                                    size={'small'}
                                    yearTitle='Year'
                                    dayTitle='Días'
                                    hourTitle='Horas'
                                    minuteTitle='Min'
                                    secondTitle='Segs'
                                    monthTitle=''
                                    hideYear
                                    hideMonth
                                    hideDay
                                    
                                    endAt={this.state.fechaLimite} // Date/Time
                                    onEnd={() => {
                                        window.location.href = "/";
                                    }}
                                    />
                 </div>    
             
                 </div>
              
            </div>
            </a>


</div>

</div>
}

{(this.state.showWeb && this.state.fechaLimite) && (!window.location.pathname.includes("beca-parcial")) &&

<div className="col-12 px-0">
<div className="d-inline-flex">


    <div onClick={() => {
                // this.setState({isOpenMett: true});
                const element = document.querySelector('#fechas');
            element.scrollIntoView({ behavior: 'smooth' });
                window.fbq('track', 'AddToCart', {
                    value: this.state.price_mount,                 // Valor total de la compra
                    currency: 'USD',               // Moneda utilizada (ISO 4217)
                    content_type: 'product',       // Tipo de contenido
                    content_ids: ['bootcamp'],  // ID del producto o identificador
                    content_name: 'bootcamp'
                });
            }}  id="counter-deadline" className="pt-1 pb-2 timer-bar " style={{backgroundColor: "tomato", marginTop: window.type_device ? "0px": "10px"}}> 
                {/* <h5 className="w-100 mt-2 mb-1 text-white text-center px-1" style={{fontSize: "17px"}} > 
                    {this.state.porcentajeDescuento}
                </h5> */}
                <div style={{display: "flex", flexDirection: window.type_device ? "column": "row", justifyContent: "center", alignItems: "center"}}>
                  <h5 className="my-1 p-1" style={{fontWeight: "bold", fontFamily: "'Poppins',sans-serif", fontSize: "15px", color: "white", textAlign: "center"}} >
🔥 Inscripciones cierran en:

                </h5>
                <div style={{marginLeft: window.type_device ? "0px": "20px", marginRight: window.type_device ? "0px": "20px", lineHeight: "1.25rem"}}>
                        <FlipCountdown
                                    size={'small'}
                                    yearTitle='Year'
                                    dayTitle='Días'
                                    hourTitle='Horas'
                                    minuteTitle='Min'
                                    secondTitle='Segs'
                                    monthTitle=''
                                    hideYear
                                    hideMonth
                                    endAt={this.state.fechaLimite} // Date/Time
                                    />
                 </div>    
             
                 </div>
              
            </div>
     


</div>

</div>
}
 
                                    <div className="row" style={{flexWrap: 'nowrap', marginTop:  !window.type_device || window.location.pathname.includes("beca-parcial") ? "50px": "50px", justifySelf: window.location.pathname.includes("masterclass") && !this.state.showWeb ? "center": ""  }}>

                                        <div className="col-12" style={{paddingLeft: window.type_device ? "": "50px", paddingRight: window.type_device ? "": "50px"}}>

                                                <div className="inner text-left" style={{"text-align-last": "left"}}>

                                                    {true &&
                                                    <>
                                                        <h1 className="title" style={{fontSize: window.type_device ? "": "61px", marginTop: window.type_device ? "10%": "19px", "text-align": "left", marginBottom: window.type_device ? "1px": "25px", lineHeight: "30px"}}>
                                                            BootCamp
                                                        </h1>
                                                    <h1 className="title" style={{"text-align": "left", marginBottom: "10px"}}>
                                                         <span className="mt-2 h1-dojopy title title-gradient">

{window.type_device ? <>
Developer Full Stack <br/> Web
</>:
<>
Developer <br/>Full Stack Web
</>
}
                                                            </span>
                                                    </h1>
                                                    </>
                                                    }
                                                 

                                           
                                            <>
                                           
                                                      <div className="row col-12 mb-3" style={{textAlign: "left", height: "60px"}}>
                                                    <TypingAnimation/>
                                                    </div>
                                                    <p className="description" style={{"padding-top": "9px", fontSize: "17px"}}>


                                                    <div className="row">

                                                        <div style={{"text-align-last": "right"}} className="col-1 mx-0 px-0"><FiCheck style={{"color": "yellow"}}/></div>
                                                        <div className="col pr-0" style={{fontSize: "17px", paddingBottom: "9px", textAlign: "left" }}>
                                                    <span style={{alignItems: "center", display: "inline-flex", padding: "2px", marginLeft: "7px", "background-color": "tomato", "border-radius": "7px", "padding-left": "5px", "padding-right": "5px", "color": "white", "font-size": "16px", fontWeight: "bold"}}>
                                                        <span className="pulsar mr-1"></span> {true ? "En vivo": "Live"}
                                                    </span>

                                            
                                                            
                                                        </div>
                                                    </div>


                                                    <div className="row">
                                                        <div style={{"text-align-last": "right"}} className="col-1 mx-0 px-0"><FiCheck style={{"color": "yellow"}}/></div>
                                                            <div className="col pr-0" style={{fontSize: "17px", paddingBottom: "9px", textAlign: "left" }}>
                                                            <CiCalendar className="mr-1" style={{fontSize: "25px"}} /> Duración: 4 meses
                                                         </div>
                                                    </div>

                                                    <div className="row">
                                                        <div style={{"text-align-last": "right"}} className="col-1 mx-0 px-0"><FiCheck style={{"color": "yellow"}}/></div>
                                                            <div className="col pr-0" style={{fontSize: "17px", paddingBottom: "9px", textAlign: "left" }}>
                                                            <GoRocket className="mr-1" style={{fontSize: "25px"}} /> Basado en proyectos
                                                         </div>
                                                    </div>
                                                    


                                          

                                                    <div className="row">
                                                        <div style={{"text-align-last": "right"}} className="col-1 mx-0 px-0"><FiCheck style={{"color": "yellow"}}/></div>
                                                        <div className="col pr-0" style={{fontSize: "17px", paddingBottom: "9px", textAlign: "left" }}>
                                                        <MdWorkOutline className="mr-1" style={{fontSize: "25px"}} /> Preparación Laboral Real

                                                         </div>
                                                    </div>
                                      



                                                    </p>
                                                     </>
                                            




{ this.state.showWeb &&  this.state.showPrice &&
<>


  <div className="d-flex" style={{gap: "9px", flexDirection: "column"}}>
        <div className="slide-btn mt-3">

            <button onClick={() => {
                // this.setState({isOpenMett: true});
                    const element = document.querySelector('#fechas');
                    // // Scroll hacia el elemento con smooth
                    element.scrollIntoView({ behavior: 'smooth' });
                    // Luego ajustamos hacia arriba con un pequeño delay
                    window.fbq('track', 'AddToCart', {
                        value: this.state.price_mount,                 // Valor total de la compra
                        currency: 'USD',               // Moneda utilizada (ISO 4217)
                        content_type: 'product',       // Tipo de contenido
                        content_ids: ['bootcamp'],  // ID del producto o identificador
                        content_name: 'bootcamp'
                    });

                } }
                className="btn-efect-2 mt-1 cta-button" style={{borderRadius: "19px", background: "linear-gradient(180deg, #9b37f2, #7a12d4)", fontWeight: 600, padding: "10px 25px", fontSize: '20px', textTransform: "none", fontFamily: "Poppins, sans-serif"}}
                >

                   <GoRocket className="mr-1" /> Empezar inscripción

             </button>
 

    </div>

</div>


 {/* <div className="d-flex" style={{gap: "9px", flexDirection: "column"}}>
        <div className="slide-btn mt-3">

            <button onClick={() => {
                this.setState({isOpenBrochure: true});
                    // const element = document.querySelector('#fechas');
                    // // Scroll hacia el elemento con smooth
                    // element.scrollIntoView({ behavior: 'smooth' });
                    // Luego ajustamos hacia arriba con un pequeño delay

                    window.fbq('track', 'AddToCart', {
                        value: this.state.price_mount,                 // Valor total de la compra
                        currency: 'USD',               // Moneda utilizada (ISO 4217)
                        content_type: 'product',       // Tipo de contenido
                        content_ids: ['bootcamp'],  // ID del producto o identificador
                        content_name: 'bootcamp'
                    });

                } }
                className="btn-efect-2 mt-1 cta-button" style={{borderRadius: "19px", background: "#1f1f25", fontWeight: 600, padding: "10px 25px", fontSize: '20px', textTransform: "none", fontFamily: "Poppins, sans-serif"}}
                >
                   <IoIosDocument className="mr-1" /> Descargar brochure

             </button>
    </div>
</div> */}


<div className="slide-btn mt-3">
<a  target="_blank" href={"https://api.whatsapp.com/send?phone=51936670597&text=Hola, me gustaría obtener más información sobre el bootcamp de desarrollador full stack. ".concat(this.state.fbclid_short_code ? `%0A%0AMi ticket de atención es: %23${this.state.fbclid_short_code}`: "")} >
<button onClick={() => {
    window.fbq('track', 'AddToCart', {
        value: this.state.price_mount,                 // Valor total de la compra
        currency: 'USD',               // Moneda utilizada (ISO 4217)
        content_type: 'product',       // Tipo de contenido
        content_ids: ['bootcamp'],  // ID del producto o identificador
        content_name: 'bootcamp'
      });

} }
className="btn-efect-2 mt-1" style={{background: "linear-gradient(to right, rgb(25, 135, 84), rgb(7, 94, 84))", fontWeight: 600, padding: "10px 25px", fontSize: '19px', textTransform: "none", fontFamily: "Poppins, sans-serif"}}
>
<FaWhatsapp style={{fontSize: "25px"}} className="mr-2" />
¿Tienes una pregunta?
</button>
</a>
</div> 

</>
    }









{ this.state.showWeb &&
                    <div className="mt-3 text-left">
                    <img alt="" height={"99px"} src="/assets/images/dojopy/dojofullstack_report.png" />
                
                    </div>
    }



                    </div>

                 

                                            </div>


           

                                        </div>
</div>
    







                                </div>
  
                            

                        </div>


                                         
                </div>
                                   
                {/* End Slider Area   */}









      {false && window.location.pathname.includes("masterclass") &&
<div className="container mt-0">
                    <div className="col-12 w-100 px-0 mx-0 col-md-7" style={{marginTop: "1px"}} >
                         {!this.state.showWeb &&
                               <h5 className="mt-0 mb-3 mx-3 text-white text-center" style={{fontWeight: "normal", marginBottom: "3px", fontSize: "16px"}}>
                        🎬 Clic sobre el streaming, para empezar.
                        </h5>  
                    }               
                        
                        <iframe style={{borderRadius: "8px", marginTop: this.state.showWeb ? "33px": "1px" }} id="iframe-video" allowFullScreen frameborder="0"  border="none" width={"100%"} height={"auto"}
                        src={`https://player.dojofullstack.com/?url=${VIDEO_VLS}`}></iframe>

{this.state.showWeb &&
<h3 className="mb-0 mt-3 text-white"
                     style={{fontWeight: "500", display: "inline-block", padding: "3px", "padding-left": "20px", "padding-right": "20px", "font-size": window.type_device ? "18px": "25px" }}>
<b>
✅ Si ya viste la masterclass, descubre nuestro Bootcamp Full Stack Developer y accede a un descuento especial antes de que termine el contador.
<br/>
¡Asegura tu lugar hoy mismo!

</b>
                    </h3>
}


                      </div>   
           </div>                
    }


              
{this.state.countryCode !== "US" &&  this.state.showWeb && 
<div className="about-wrapper" style={{paddingTop: window.type_device ? "20px": "29px", paddingBottom: "5px", background: "white" }}>
<div data-aos="fade-top"  className={window.type_device ? "container-fluid ": "container"}>

 <div className="d-flex mt-1 text-dark" style={{flexDirection: window.type_device ? "column": "row", gap: window.type_device ? "1px": "15px", justifyContent: "center", alignItems: "center"}}>

 <div className="d-flex mb-3 col-md-5" style={{borderRadius: "20px", border: "1px solid mediumpurple", padding: "5px", alignItems: "center"}}>
    <img className="ml-1" style={{borderRadius: "30px", marginRight: "5px"}} height="89px" src="/assets/images/dojopy/murk_news.webp" />
    <div className="ml-2 mt-2">
      <h5 style={{fontSize: "17px", color: "#1f1f25", fontStyle: "normal"}} className="my-0">Elon Musk
        <span style={{marginLeft: "5px", fontSize: "13px", color: "mediumseagreen"}}>CEO SpaceX & Twitter</span>
      </h5>
      <p style={{fontSize: "14px", fontStyle: "normal"}}>La vida es demasiado corta para ser pequeña. Tienes que hacer algo grande.</p>
    </div>
  </div>

<div className="d-flex mb-3 col-md-5" style={{borderRadius: "20px", border: "1px solid mediumpurple", padding: "5px", alignItems: "center"}}>
    <img className="ml-1" style={{borderRadius: "30px", marginRight: "5px"}} height="89px" src="/assets/images/dojopy/elonmusk_news.webp" />
    <div className="ml-2 mt-2">
      <h5 style={{fontSize: "17px", color: "#1f1f25", fontStyle: "normal"}} className="my-0">Mark Zuckerberg
        <span style={{marginLeft: "5px", fontSize: "13px", color: "mediumseagreen"}}>CEO Facebook</span>
      </h5>
      <p style={{fontSize: "14px", fontStyle: "normal"}}>
      El miedo a lo desconocido nos limita; arriesgarse es clave para conocer nuestras capacidades.
        </p>
    </div>
  </div>



</div>
</div>
</div>
    }



{this.state.showWeb && 
  <div data-aos="fade-up" className="about-area bg_color--5" id="about_dojopy" style={{marginTop: "20px", marginBottom: "30px"}}>
                    <div className="about-wrapper">
                        <div className="container">
                            <div className="row row--35 align-items-center">

                                <div className="col-12">
                                    <div className="about-inner inner">
                                        <div className="section-title">
                                            <h2 className="title">

                                                {window.type_device &&
                                                <>
                                                      Full Stack Developer
                                                </>}

                                                {!window.type_device &&
                                                <>
    Full Stack Developer
                                                </>}


                                            </h2>
                                            <p>

<b>
Dojofullstack es una startup educativa que impulsa a nuevos creadores del mundo tech, formando desarrolladores con enfoque práctico y mentalidad innovadora.


</b>
                                            </p>
<p>
Nacemos con la misión de potenciar el talento y responder a la creciente demanda de desarrolladores en todo el mundo.
</p>
<p>
Nuestro propósito es cerrar la brecha de habilidades, generar más oportunidades y formar a miles de personas que desean ser parte activa de la transformación digital y el avance tecnológico en las empresas.
</p>


                                          

                                        </div>

                                    <div className="row mt--30 rn-address" style={{boxShadow: "#c6c9d8 8px 6px 15px 1px"}} >
                                            <div className="col-lg-4 col-md-6 col-sm-12 col-12" style={{marginTop: window.type_device? "10px": "1px"}}>
                                                <div className="about-us-list">
                                                    <h3 className="title"><FiClock/> {true ? "Duración": "Duration"}</h3>
                                              
                                                      <p style={{fontSize: "17px"}}>
                                                    <span style={{"color":"slateblue", "fontSize": "18px"}}> <FiCheckCircle style={{fontSize: "21px", marginRight: "7px", color: "slateblue"}} /> </span>
                                                    <b> 4 meses</b>  <br/>
                                                    🕓 Horario flexible
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="col-lg-4 col-md-6 col-sm-12 col-12" style={{marginTop: window.type_device? "10px": "1px"}}>
                                                <div className="about-us-list">
                                                    <h3 className="title"><FiUser/>  {true ? "Modalidad": "Modality"} </h3>
                                                    <p style={{fontSize: "17px"}}>
                                                        
                                                    <span style={{"color":"slateblue", "fontSize": "18px"}}> <FiCheckCircle style={{fontSize: "21px", marginRight: "7px", color: "slateblue"}} /> </span>

                                                    <span style={{display: "inline-block", padding: "3px", marginLeft: "7px", "background-color": "tomato", "border-radius": "7px", "padding-left": "7px", "padding-right": "7px", "color": "white", "font-size": "18px"}}>
                                                        <span className="pulsar"></span> {true ? "En vivo": "Live"}
                                                    </span>
                                           
                                                      
                                                    </p>
                                                </div>
                                            </div>




                                            <div className="col-lg-4 col-md-6 col-sm-12 col-12" style={{marginTop: window.type_device? "10px": "1px"}}>
                                                <div className="about-us-list">
                                                    <h3 className="title"> {true ? "Nivel": "Requirements"} </h3>
                                                    <p style={{fontSize: "17px"}}>
                                                    <span style={{"color":"slateblue", "fontSize": "18px"}}> <FiCheckCircle style={{fontSize: "18px", marginRight: "7px", color: "slateblue"}} /> </span>
                                                    No necesitas experiencia previa. ¡Empieza desde cero y llega lejos!
                                                    </p>
                                                </div>
                                            </div>


                                              <div className="col-12 mt-3"  >
                                                <div className="about-us-list">
                                                    <h3 className="title"> Temario  </h3>
                                           

<a href={this.state.Temario} style={{textDecoration: "none"}} target="_blank">

<button
    onClick={() => {
    window.fbq('track', 'AddToCart', {
        value: this.state.price_mount,                 // Valor total de la compra
        currency: 'USD',               // Moneda utilizada (ISO 4217)
        content_type: 'product',       // Tipo de contenido
        content_ids: ['bootcamp'],  // ID del producto o identificador
        content_name: 'bootcamp'
      });
}}
    style={{
      textShadow: "none",
      cursor: "pointer",
      fontWeight: "bold",
      fontSize: "19px",
      padding: "10px 19px",
      borderRadius: "20px",
      background: "linear-gradient(180deg,#ffe26d,#f5c918)",
      color: "black",
      border: "none",
      outline: "none"
    }}
    className="btn-efect-live"
  >
    <IoIosDocument className="mr-2" />
        Ver Temario
  </button>
  </a>      
                                               

                                                </div>
                                            </div>

                                      


                                            <div className="col-12 mt-3"  >
                                                <h3 className="title"><FaGraduationCap/>  Certificación  </h3>
                                                <div className="row">
                                                <div className="about-us-list col-12 col-md-4"  >
                                                    <img onContextMenu={(e) => e.preventDefault()} alt="Certificado Web Full Stack Developer Developer" src={"/assets/images/dojopy/certify-2026-fullstack-dev.png"}></img>
                                                </div>
                                             
                                           
                                                </div>
                                            </div>

                                    </div>

                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

}




      

                {this.state.showWeb && 
    <div data-aos="fade-right" className="about-area ptb--120 bg_color--5" id="benefits" style={{marginTop: "-50px"}}>
                    <div className="about-wrapper">
                        <div className="container">
                            <div className="row row--35 align-items-center">

                                <div className="col-12">
                                    <div className="about-inner inner">
                                        <div className="section-title">
                                            <h2 className="title">
                                            ¿Te identificas con alguno de estos perfiles? 
                                            </h2>
                                    
                                        </div>


                                    {true ?
                                        <TouchCarousel
                                        component={Container2}
                                        cardSize={cardSize2}
                                        cardCount={data2.length}
                                        cardPadCount={cardPadCount}
                                        loop={true}
                                        autoplay={2e3}
                                        renderCard={this.renderCard2}
                                        /> :

                                        <div className="row mt--30">
                                        <div className="col-12 col-md-6 col-lg-3">
                                            <div style={{"text-align":"center", "box-shadow": "4px 2px 5px 0px #8080805e", "border-radius": "30px", "padding": "25px", "background": "white"}}>
                                                <h5>
                                               Impulsa tu cambio de carrera	
                                                </h5>
                                                <img alt="Quieres cambiar de carrera" height="150px" src="/assets/images/icons/change.webp"></img>
                                            </div>
                                        </div>
                                        <div className="col-12 col-md-6 col-lg-3">
                                            <div style={{"text-align":"center", "box-shadow": "4px 2px 5px 0px #8080805e", "border-radius": "30px", "padding": "25px", "background": "white"}}>
                                                <h5>
                                                Potencia tu CV con habilidades tech	
                                                </h5>
                                                <img alt="Mejora tu currículo con nuevas habilidades" height="150px" src="/assets/images/icons/curriculum.webp"></img>
                                            </div>
                                        </div>
                                        <div className="col-12 col-md-6 col-lg-3">
                                            <div style={{"text-align":"center", "box-shadow": "4px 2px 5px 0px #8080805e", "border-radius": "30px", "padding": "25px", "background": "white"}}>
                                                <h5>
                                                Emprende y lidera proyectos digitales	
                                                </h5>
                                                <img alt="Emprendedores y visionarios" height="150px" src="/assets/images/icons/idea.webp"></img>
                                            </div>
                                        </div>
                                        <div className="col-12 col-md-6 col-lg-3">
                                            <div style={{"text-align":"center", "box-shadow": "4px 2px 5px 0px #8080805e", "border-radius": "30px", "padding": "25px", "background": "white"}}>
                                                <h5>
                                                    Si eres principiante en programación	
                                                </h5>
                                                <img alt="Si aún no sabes sobre tecnologías web" height="150px" src="/assets/images/dojopy/web.webp"></img>
                                            </div>
                                        </div>

                                            <div className="col-12 col-md-6 col-lg-3">
                                            <div style={{"text-align":"center", "box-shadow": "4px 2px 5px 0px #8080805e", "border-radius": "30px", "padding": "25px", "background": "white"}}>
                                                <h5>
                                                   Genera más ingresos con una profesión rentable
                                                </h5>
                                                <img alt="Si aún no sabes sobre tecnologías web" height="150px" src="/assets/images/dojopy/dolar.png"></img>
                                            </div>
                                        </div>

                                    </div>
                                    }


                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
    }




{this.state.showWeb && 
    <div data-aos="fade-right" className="about-area ptb--120 bg_color--5" id="benefits" style={{marginTop: "-100px"}}>
                    <div className="about-wrapper">
                        <div className="container">
                            <div className="row row--35 align-items-center">

                                <div className="col-12">
                                    <div className="about-inner inner">
                                        <div className="section-title">
                                            <h2 className="title mb-0">
                                            ¿Qué es el Desarrollo Full Stack?
                                            </h2>

                                            <div style={{width: window.type_device ? "200px": "395px", height: "6px", backgroundColor: "#ffcb48", marginBottom: "17px", transform: "rotate(178deg)", marginTop: "-2px"}}></div>

                                        </div>
                                        <div>
                                            <p>
                                            ¿Imaginas tener la habilidad de crear aplicaciones web y móviles desde cero? ¡Conviértete en Full Stack Developer y domina el arte de diseñar experiencias digitales irresistibles! Aprenderás a manejar todo el proceso de desarrollo: desde el diseño visual y la lógica del servidor hasta la gestión de bases de datos. Con estas habilidades, no solo construirás sitios web y aplicaciones interactivas, sino que también abrirás la puerta a un mundo lleno de oportunidades tecnológicas y recompensas profesionales.

                                            </p>
   <p>
                        ¡El momento es ahora! La industria tecnológica está en auge, con más de 100,000,000 vacantes en TI por cubrir. Da el salto y sé parte de esta revolución digital. ¡Es tu oportunidad para destacar!
   </p>
                                         
                                        </div>

                               

                                    </div>
                                </div>

                   
                            </div>
                        </div>
                    </div>
                </div>
    }



{this.state.showWeb && 
    <div data-aos="fade-right" className="about-area ptb--120 bg_color--5" id="profile" style={{marginTop: "-100px"}}>
                    <div className="about-wrapper">
                        <div className="container">
                            <div className="row row--35 align-items-center">

                                <div className="col-12 col-md-9">
                                    <div className="about-inner inner">
                                        <div className="section-title">
                                            <h2 className="title">
                                            {true ? "Un vistazo a tu futuro perfil ": "A look at your future profile"}
                                            </h2>
                                            <h3 className="title mt-4">
                                             {true ? "¿Qué trabajos podré conseguir?": "prestigious position"}
                                            </h3>
                                        </div>
                                        <div>
                                        <span className="bg-white m-1" style={{padding: "5px 7px", border: "1px solid mediumpurple", display: "inline-block", borderRadius: "10px", fontSize: "18px"}}> {true ? "Full Stack Developer ": "Full Stack Developer developer"} </span>
                                        <span className="bg-white m-1" style={{padding: "5px 7px", border: "1px solid mediumpurple", display: "inline-block", borderRadius: "10px", fontSize: "18px"}}>{true ? "Desarrollador Frontend ": "Front End Developer"} </span>
                                        <span className="bg-white m-1" style={{padding: "5px 7px", border: "1px solid mediumpurple", display: "inline-block", borderRadius: "10px", fontSize: "18px"}}> {true ? "Desarrollador Backend": "Backend Developer"} </span>
                                        <span className="bg-white m-1" style={{padding: "5px 7px", border: "1px solid mediumpurple", display: "inline-block", borderRadius: "10px", fontSize: "18px"}}>{"Desarrollador de Apps"} </span>
                                        <span className="bg-white m-1" style={{padding: "5px 7px", border: "1px solid mediumpurple", display: "inline-block", borderRadius: "10px", fontSize: "18px"}}> {true ? "Desarrollador Cloud": "cloud developer"} </span>
                                        <span className="bg-white m-1" style={{padding: "5px 7px", border: "1px solid mediumpurple", display: "inline-block", borderRadius: "10px", fontSize: "18px"}}>  Programador Web </span>
                                        <span className="bg-white m-1" style={{padding: "5px 7px", border: "1px solid mediumpurple", display: "inline-block", borderRadius: "10px", fontSize: "18px"}}>  Analista Programador </span>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-12">
                                            <h3 className="title mt-4">
                                            {true ? "Perfil profesional al finalizar el Bootcamp": "Interesting activities"}
                                            </h3>
                                            <div>
                                                <p style={{fontSize: "17px", "margin-bottom": "10px"}}>
                                                    <span style={{"color":"slateblue", "fontSize": "20px"}}> <FiCheckCircle style={{fontSize: "21px", marginRight: "7px", color: "slateblue"}} /> </span>
                                                    Tendrás la capacidad de desarrollar, diseñar y prototipar interfaces Web y Apps modernas trabajando con  tecnologías de vanguardia,
                                                    lo cual te permitirá construir aplicaciones más complejas, dinámicas y escalables.
                                                </p>
                                               
                                                <p style={{fontSize: "17px", "margin-bottom": "10px"}}>
                                                    <span style={{"color":"slateblue", "fontSize": "20px"}}> <FiCheckCircle style={{fontSize: "21px", marginRight: "7px", color: "slateblue"}} /> </span>
                                                    Definir las funcionalidades requeridas y el alcance de las librerías externas de una aplicación Web.
                                                </p>
                                             
                                                <p style={{fontSize: "17px", "margin-bottom": "10px"}}>
                                                    <span style={{"color":"slateblue", "fontSize": "20px"}}> <FiCheckCircle style={{fontSize: "21px", marginRight: "7px", color: "slateblue"}} /> </span>
                                                    Construir interfaces Web fáciles de usar para el usuario.
                                                </p>

                                                <p style={{fontSize: "17px", "margin-bottom": "10px"}}>
                                                    <span style={{"color":"slateblue", "fontSize": "20px"}}> <FiCheckCircle style={{fontSize: "21px", marginRight: "7px", color: "slateblue"}} /> </span>
                                                    Desplegar e implementar aplicaciones Web en la nube.
                                                </p>

                                                <p style={{fontSize: "17px", "margin-bottom": "10px"}}>
                                                    <span style={{"color":"slateblue", "fontSize": "20px"}}> <FiCheckCircle style={{fontSize: "21px", marginRight: "7px", color: "slateblue"}} /> </span>
                                                    Desarrollar Software  para las empresas.
                                                </p>
                                                <p style={{fontSize: "17px", "margin-bottom": "10px"}}>
                                                    <span style={{"color":"slateblue", "fontSize": "20px"}}> <FiCheckCircle style={{fontSize: "21px", marginRight: "7px", color: "slateblue"}} /> </span>
                                                    Crear productos digitales geniales en equipo.
                                                </p>

                                                

                                            </div>
                                    </div>

                                    <div className="col-12 col-md-9">
                                            <h3 className="title mt-4">
                                             {true ? "Habilidades claves para el mercado laboral": "Key skills for the labor market"}
                                            </h3>
                                            <div>
                                            <TouchCarousel
                                                component={Container}
                                                cardSize={cardSize}
                                                cardCount={data.length}
                                                cardPadCount={cardPadCount}
                                                loop={true}
                                                autoplay={2e3}
                                                renderCard={this.renderCard}
                                                />
                                            </div>
                                    </div>


                                    <Tabs>


    {this.state.countryCode !== "US" &&
        <TabPanel>
            <div className="row">
            <div className="col-12">
            <h3 className="title mt-4">
            <FaLinkedin  className="mr-1"/> {true ? "Salario alto y perspectivas seguras": "High salary and secure prospects"}
            </h3>
            <p style={{fontSize: "13px"}}>{true ? "Estos salarios mensuales promedio están tomados de Glassdoor, el portal de empleo líder. Pero tú puedes ser mejor que el promedio.":
            "These average monthly salaries are taken from Indeed and Glassdoor, the leading job portal in the United States. But you can be better than average."} </p>
            
              <div className="row">
                    <div style={{boxShadow: "3px 2px 6px 0px #808080b0"}} className="p-3 m-2 bg-white col-10 col-md-6">
                        <h3 style={{fontWeight: "bold"}}>{true ? this.state.salario_fullstack_jr: "$70,000 / year"}</h3>
                        <p>{true ? "Full Stack Developer": "Junior Full Stack Developer Developer"}  <span className="text-primary d-inline-block"> {true ? "después del Bootcamp": "after bootcamp"}  </span> </p>
                    </div>

            <div style={{boxShadow: "3px 2px 6px 0px #808080b0"}} className="p-3 m-2 bg-white col-10 col-md-6">
                        <h3 style={{fontWeight: "bold"}}>{true ? this.state.salario_fullstack_sr: "$70,000 / year"}</h3>
                        <p>{true ? "Full Stack Developer Sr.": "Junior Full Stack Developer Developer"}  <span className="text-primary d-inline-block"> {true ? "Senior Exp.": "after bootcamp"}  </span> </p>
                    </div>
                    

                    <div  className="m-1 col-12 col-md-3">
                        <img alt="El sector de la programacion web está prosperando" src="/assets/images/dojopy/top-thrending-2025.png"/>
                    </div>
            </div>
         
        </div>
 
            </div>

        </TabPanel>
    }
        <TabPanel>
            <div className="row">

        <div className="col-12">
            <h3 className="title mt-4">
            {true ? "Salario alto y perspectivas seguras": "High salary and secure prospects"}
            </h3>
            <p style={{fontSize: "13px"}}>{true ? "Estos salarios mensuales promedio están tomados de Glassdoor, el portal de empleo líder en Estados Unidos. Pero tú puedes ser mejor que el promedio.":
            "These average monthly salaries are taken from Indeed and Glassdoor, the leading job portal in the United States. But you can be better than average."} </p>
              <div className="row">
                    <div style={{boxShadow: "3px 2px 6px 0px #808080b0"}} className="p-3 m-2 bg-white col-10 col-md-6">
                        <h3 style={{fontWeight: "500"}}>{true ? this.state.salario_fullstack_jr: "$70,000 / year"}</h3>
                        <p>{true ? "Full Stack Developer": "Junior Full Stack Developer Developer"}  <span className="text-primary d-inline-block"> {true ? "después del Bootcamp": "after bootcamp"}  </span> </p>
                    </div>

                    <div  className="m-1 col-12 col-md-3">
                        <img alt="El sector de la programacion web está prosperando" src="/assets/images/dojopy/top-thrending-2025.png"/>
                    </div>
            </div>
         
        
        </div>
    
        </div>
        </TabPanel>
    </Tabs>


                            </div>
                </div>
            </div>
        </div>

            }





{false && 
          <div data-aos="fade-right" className="about-area ptb--30 bg_color--5">
                    <div className="about-wrapper">
                        <div className="container">
                            <div className="row row--35 align-items-center">
                            <div className="text-center col-12">
                                <h3 className="title"> {true ? "Tu portafolio de proyectos": "Your portfolio of projects"}</h3>
                            </div>

                                <div className="col-md-4 col-6">

                                    <div className="thumbnail zoom">
                                        <img alt="proyecto web personal" style={{maxHeight: "470px", maxWidth: "470px", transition: "0.2s"}} className="w-100" src="/assets/images/dojopy/project1.webp"/>
                                        <p style={{padding: "13px"}}>{true ? "Web Personal": "Personal website"} </p>
                                    </div>
                                </div>

                                <div className="col-md-4 col-6">
                                    <div className="thumbnail zoom">
                                        <img alt="proyecto Web para negocios" style={{maxHeight: "470px", maxWidth: "470px", transition: "0.2s"}} className="w-100" src={true ? "/assets/images/dojopy/project2.webp" : "/assets/images/dojopy/doctor-web-us.webp"} />
                                        <p style={{padding: "13px"}}>{true ? "Web para empresas": "Website for companies"} </p>
                                    </div>
                                </div>



                                <div className="col-md-4 col-12">
                                    <div className="thumbnail zoom">
                                        <img  alt="proyecto Web de Pedidos inspirada en Rappi" style={{maxHeight: "470px", maxWidth: "470px", transition: "0.2s"}} className="w-100" src={true ? "/assets/images/dojopy/project4.webp": "/assets/images/dojopy/amazon_project.png"}/>
                                        <p style={{padding: "13px"}}>{true ? <>Web de Pedidos inspirada en <b>Rappi.com</b> </>: <>Commerce website inspired by <b>Amazon.com</b> </>} </p>
                                    </div>
                                </div>

                            </div>




                        </div>
                    </div>
                </div>

    }





{this.state.showWeb && 
   <div data-aos="fade-right" className="about-area ptb--10 bg_color--5"  style={{marginTop: "1px", color: "#1f1f25"}}>
                    <div className="about-wrapper">
                        <div className="container">
                            <div className="row row--35 align-items-center">
                            <div className="text-center col-12">
                         

                                                            <div className="section-title">
                                <h2 className="title text-black mb-1" style={{padding: "5px"}}>
                                ¿Cómo funciona el Bootcamp?
                                    </h2>

                                                            </div>

                            </div>
                               <div className="p-1">


           {/* <div class="modalities-selector">
                <div class="modality-tab" data-modality="fulltime">
                    <span>🚀</span> Online en Vivo
                </div>
                <div class="modality-tab" data-modality="parttime">
                    <span>⚡</span> Part-Time
                </div>
            </div> */}

<p style={{fontSize: "18px"}}>
<span style={{"color":"goldenrod", "fontSize": "20px"}}> <FiCheckCircle style={{fontSize: "29px", marginRight: "7px", color: "goldenrod"}} /> </span>  
<b>Online en Vivo <br/> (horarios programados): </b>
</p>
<ul>
    <li><b>Interacción directa y estructurada para maximizar tu aprendizaje:</b> </li>
    <li><b> Clases grupales semanales</b>  con instructor experto en tiempo real</li>
    <li><b> Ejercicios prácticos </b> cada semana para reforzar conceptos.</li>
    <li><b> Asesorías personalizadas</b>  en vivo para resolver dudas específicas</li>
</ul>




                                   {/* <p>
                                   {true ? <>
                                    Cada semana tendrás <b>2 encuentros grupales en vivo</b> con el Instructor, al final de cada semana hay actividades prácticas, no te preocupes si te trabas en las actividades siempre tendrás asesorías personalizadas.
                                   <br/>
                                   En DojoFullStack proponemos un nuevo modelo educativo que incluye entornos de aprendizaje sincrónicoss con un enfoque que vincula la teoría y la práctica, mediante un aprendizaje activo.
                                   </>: <>
                                   Each week you will have <b>2 live group meetings</b> with the Instructor, at the end of each week there are practical activities, don't worry if you get stuck in the activities you will always have personalized advice.
                                    <br/>
                                    At DojoFullStack we propose a new educational model that includes synchronous and asynchronous learning environments with an approach that links theory and practice, through active learning.
                                   </> }
                                    </p> */}

                                    <div className="row mt--30">
                                        <div className="col-12 col-md-6 col-lg-3 mt-3">
                                            <div style={{"text-align":"center", "box-shadow": "4px 2px 5px 0px #8080805e", "border-radius": "30px", "padding": "25px", "background": "white"}}>
                                                <h4>
                                                {true ? "Conéctate a tu primera sesión ": "Connect to your first session"}

                                                            <span style={{padding: "3px", marginLeft: "7px", "background-color": "tomato", "border-radius": "7px", "padding-left": "7px", "padding-right": "7px", "color": "white", "font-size": "18px"}}>
                                                            <span className="pulsar"></span> {true ? "En vivo": "Live"}
                                                            </span>
                                                </h4>
                                                <img alt="Conéctate a tu primera sesión en vivo" height="190px" src="/assets/images/dojopy/live_zoom.webp" />
                                            </div>
                                        </div>
                                        <div className="col-12 col-md-6 col-lg-3 mt-3">
                                            <div style={{"text-align":"center", "box-shadow": "4px 2px 5px 0px #8080805e", "border-radius": "30px", "padding": "25px", "background": "white"}}>
                                                <h4>
                                                {true ? "Actividades asíncronas en la Plataforma.": "Practice with new challenges and activities every week"}
                                                </h4>
                                                <img style={{borderRadius: "20px"}}  alt="Practica con nuevos retos y actividades cada semana" height="159px" src="/assets/images/dojopy/plataform_2026_elear.png" />
                                            </div>
                                        </div>
                                        <div className="col-12 col-md-6 col-lg-3 mt-3">
                                            <div style={{"text-align":"center", "box-shadow": "4px 2px 5px 0px #8080805e", "border-radius": "30px", "padding": "25px", "background": "white"}}>
                                                <h4>
                                                Mentorías 1:1
                                                </h4>
                                                <img alt="Recibe asesoría personalizada 1 a 1" height="135px" src="/assets/images/dojopy/live-mentoring-1-1.png" />
                                            </div>
                                        </div>
                                        <div className="col-12 col-md-6 col-lg-3 mt-3">
                                            <div style={{"text-align":"center", "box-shadow": "4px 2px 5px 0px #8080805e", "border-radius": "30px", "padding": "25px", "background": "white"}}>
                                                <h4>
                                                Comparte tus proyectos,
                                                así todos aprenden más
                                                </h4>
                                                <img style={{borderRadius: "20px"}} alt="Presenta y comparte tus proyectos." height="139px" src="/assets/images/dojopy/project_social_news.png"></img>
                                            </div>
                                        </div>
                                    </div>
                               </div>

                            </div>
                        </div>
                    </div>
                </div>

}
             

                {window.location.pathname.includes("beca-parcial") ? <>
                     <div className="mb-2 mt-3" style={{paddingTop: "37px"}}  >
                </div>
                </>:
                <>
                   <div className="mb-2 mt-3" style={{paddingTop: "37px"}}  >
                </div>
                </>
                }










{this.state.showWeb && 
                <div data-aos="fade-right" className="about-area ptb--60 bg_color--5" id="frontend">
                    <div className="about-wrapper">
                        <div className="container">
                            <div className="row row--35 align-items-center">

                                <div className="col-12 mt-3 mb-3">
                                    <div className="about-inner inner">
                                        <div className="section-title">
                                            <h3 className="title pb-3">{true ? "¿Cuáles serán los Módulos?": "Main modules"}</h3>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-5">
                                    <div className="thumbnail">
                                        <img height={window.type_device ? "197px": "350px"} src="/assets/images/dojopy/coder_frontend.webp" alt="primer módulo web frontend"/>
                                    </div>
                                </div>
                                <div className="col-lg-7">
                                    <div className="about-inner inner">
                                        <div className="section-title">
                                 
                                            <h2 className="title mb-0">Web Frontend</h2>
                                            <div style={{width: window.type_device ? "200px": "395px", height: "6px", backgroundColor: "#ffcb48", marginBottom: "17px", transform: "rotate(178deg)", marginTop: "-2px"}}></div>

                                            <p>
                                                <b> {true ? "Conviértete en quien crea las interfaces que los usuarios aman.": "Become the one who creates the interfaces that users love."} </b>
                                            </p>

                                            {!this.state.showMoreC &&
                                            <div className="col-12 text-left">
                                                <button
                                                onClick={() => this.setState({showMoreC: true}) }
                                                type="submit"
                                                name="submit"
                                                id="mc-embedded-subscribe-"
                                                style={{ marginTop: "5px", marginBottom: "5px", fontSize: "18px",
                                                "border-radius": "20px",
                                                "border": "2px solid #6a5acd",
                                                "padding": "9px 20px"

                                            }}
                                                >
                                                 {true ? "Mostrar más": "Show more"} <br/>
                                                <AiOutlineDown style={{padding: "5px", fontSize: "30px"}}/>
                                                </button>
                                            </div>}
                                            </div>

                            {this.state.showMoreC &&
                            <>
                            <p>
                            Cada vez más empresas buscan desarrolladores frontend capaces de comprender y aportar aplicaciones web con interfaces de usuario amigables y modulares para lograr un desarrollo ágil y una usabilidad adecuada. <br/>

Este perfil se especializa en diseñar y construir todo aquello que se ve y con lo que una persona interactúa al entrar a una aplicación web: botones, imágenes, formularios, etc. Es una habilidad fundamental para garantizar impacto en la experiencia de los usuarios con los productos digitales. <br/>

En este programa aprenderás desde los fundamentos de la programación hasta el lanzamiento de aplicaciones web con las últimas tecnologías del mercado, como ReactJS.
                                            </p>
                                    <div className="row mt--30">
                                            <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                                                <div className="about-us-list">
                                                    <h4 className="title"><FiCheck style={{"color": "slateblue"}}/> HTML</h4>

                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                                                <div className="about-us-list">
                                                    <h4 className="title"><FiCheck style={{"color": "slateblue"}}/> CSS/SASS</h4>
                                                </div>
                                            </div>

                                            <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                                                <div className="about-us-list">
                                                    <h4 className="title"><FiCheck style={{"color": "slateblue"}}/> Javascript</h4>

                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                                                <div className="about-us-list">
                                                    <h4 className="title"><FiCheck style={{"color": "slateblue"}}/> React JS</h4>

                                                </div>
                                            </div>
                                        </div>

                                        </>}
                                    </div>


                                </div>
                            </div>
                        </div>
                    </div>
                </div>

}



{this.state.showWeb && 
                <div data-aos="fade-left"  className="about-area ptb--60 bg_color--5" id="git_github">
                    <div className="about-wrapper">
                        <div className="container">
                            <div className="row row--35 align-items-center">
                                <div className="col-lg-5">
                                    <div className="thumbnail">
                                        <img height={window.type_device ? "197px": "350px"} src="/assets/images/dojopy/git_github_coder.webp" alt="segundo módulo Git"/>
                                    </div>
                                </div>
                                <div className="col-lg-7">
                                    <div className="about-inner inner">
                                        <div className="section-title">
                               
                                            <h2 className="title mb-0">Git & Github</h2>
                                            <div style={{width: window.type_device ? "200px": "395px", height: "6px", backgroundColor: "#ffcb48", marginBottom: "17px", transform: "rotate(178deg)", marginTop: "-2px"}}></div>

                                            <p>
Aprende todas las herramientas necesarias para dominar el mundo de la programación colaborativa. Aprenderás las bases y conceptos esenciales que necesitas para trabajar en proyectos profesionales, ya sea en una empresa, conjunto de desarrolladores. Con este módulo aprenderás todo lo necesario para involucrarte en cualquier grupo de desarrolladores.
                                            </p>

                                        </div>
                {true &&
                <>

                                    <div className="row mt--30">
                                            <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                                                <div className="about-us-list">
                                                <h4 className="title"><FiCheck style={{"color": "slateblue"}}/> Git</h4>
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                                                <div className="about-us-list">
                                                <h4 className="title"><FiCheck style={{"color": "slateblue"}}/> Github</h4>
                                                </div>
                                            </div>
                                         
                                        </div>
                                        </>}

                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
}


{this.state.showWeb && 
                <div data-aos="fade-left"  className="about-area ptb--60 bg_color--5" id="WEB_DEployment">
                    <div className="about-wrapper">
                        <div className="container">
                            <div className="row row--35 align-items-center">
                                <div className="col-lg-5">
                                    <div className="thumbnail">
                                        <img className="w-80" height={window.type_device ? "197px": "350px"} src="/assets/images/dojopy/web_deplyment_coder.webp" alt="tercer módulo"/>
                                    </div>
                                </div>
                                <div className="col-lg-7">
                                    <div className="about-inner inner">
                                        <div className="section-title">
                                         
                                            <h2 className="title mb-0">{true ? "Deployment": ""} </h2>
                                            <div style={{width: window.type_device ? "200px": "395px", height: "6px", backgroundColor: "#ffcb48", marginBottom: "17px", transform: "rotate(178deg)", marginTop: "-2px"}}></div>

                                            <p>
                                         <b>
                                         En este módulo dominarás el despliegue de aplicaciones completas en la nube: aprenderás a publicar tu proyecto en Vercel, Netlify y AWS Amplify, configurar dominios TLD, activar certificados SSL y proteger tu aplicación en cuestión de minutos.
                                            </b>  </p>

                                        </div>

                                  

            {true &&
                <>
                                     
                                    <div className="row mt--30">
                                            <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                                                <div className="about-us-list">
                                                <h4 className="title"><FiCheck style={{"color": "slateblue"}}/> Vercel & Netlify  </h4>
                                                </div>
                                            </div>
                                               <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                                                <div className="about-us-list">
                                                <h4 className="title"><FiCheck style={{"color": "slateblue"}}/>AWS Amplify </h4>
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                                                <div className="about-us-list">
                                                <h4 className="title"><FiCheck style={{"color": "slateblue"}}/> SSL & Dominios TLD </h4>
                                                </div>
                                            </div>

                                               <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                                                <div className="about-us-list">
                                                <h4 className="title"><FiCheck style={{"color": "slateblue"}}/> WAF Security </h4>
                                                </div>
                                            </div>
                                       
                                        </div>
                                        </>}

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
    }


{this.state.showWeb && 
                <div data-aos="fade-left"  className="about-area ptb--60 bg_color--5" id="backend">
                    <div className="about-wrapper">
                        <div className="container">
                            <div className="row row--35 align-items-center">
                                <div className="col-lg-5">
                                    <div className="thumbnail">
                                        <img height={window.type_device ? "197px": "350px"} src="/assets/images/dojopy/module-6.png" alt="segundo módulo web Backend"/>
                                    </div>
                                </div>
                                <div className="col-lg-7">
                                    <div className="about-inner inner">
                                        <div className="section-title">
                               
                                            <h2 className="title mb-0">Backend </h2>
                                            <div style={{width: window.type_device ? "200px": "395px", height: "6px", backgroundColor: "#ffcb48", marginBottom: "17px", transform: "rotate(178deg)", marginTop: "-2px"}}></div>

                                            <p>
                                                <b>{true ? "Conviértete en quien crea la lógica detrás de todas las aplicaciones web": "Become the one who creates the logic behind all web applications"} .</b>
                                            </p>

                                        </div>


                                        {!this.state.showMoreD &&
                                            <div className="col-12 text-left">
                                                <button
                                                onClick={() => this.setState({showMoreD: true}) }
                                                type="submit"
                                                name="submit"
                                                id="mc-embedded-subscribe-"
                                                style={{ marginTop: "5px", marginBottom: "5px", fontSize: "18px",
                                                "border-radius": "20px",
                                                "border": "2px solid #6a5acd",
                                                "padding": "9px 20px"

                                            }}
                                                >
                                                {true ? "Mostrar más": "Show more"} <br/>
                                                <AiOutlineDown style={{padding: "5px", fontSize: "30px"}}/>
                                                </button>
                                            </div>}

                {this.state.showMoreD &&
                <>


                                            <p>
        Cada vez más empresas buscan desarrolladores backend capaces de comprender y crear aplicaciones web que brinden todo lo que estas necesiten para
        dar respuesta a sus usuarios.<br/>

        Este perfil se especializa en la creación de APIs, bases de datos y arquitecturas escalables. Es decir, en todo aquello que
        no se ve, pero que es fundamental para el funcionamiento de las aplicaciones y sitios web que usamos todos los días.<br/>

        En este bootcamp aprenderás desde los fundamentos de la programación hasta el lanzamiento de aplicaciones web sólidas haciendo uso de las últimas tecnologías
        de la industria.
                                            </p>


                                    <div className="row mt--30">
                                            <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                                                <div className="about-us-list">
                                                <h4 className="title"><FiCheck style={{"color": "slateblue"}}/> Node JS</h4>
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                                                <div className="about-us-list">
                                                <h4 className="title"><FiCheck style={{"color": "slateblue"}}/> Python</h4>
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                                                <div className="about-us-list">
                                                <h4 className="title"><FiCheck style={{"color": "slateblue"}}/> REST / RESTfull / APIs</h4>
                                                </div>
                                            </div>
                                    
                                            <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                                                <div className="about-us-list">
                                                <h4 className="title"><FiCheck style={{"color": "slateblue"}}/> Autenticación JWT</h4>
                                                </div>
                                            </div>

                                            <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                                                <div className="about-us-list">
                                                <h4 className="title"><FiCheck style={{"color": "slateblue"}}/> Bases de Datos Relacionales y NoSQL</h4>
                                                </div>
                                            </div>

                                             <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                                                <div className="about-us-list">
                                                <h4 className="title"><FiCheck style={{"color": "slateblue"}}/>  Cloud Databases</h4>
                                                </div>
                                            </div>

                                        </div>
                                        </>}

                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
}



{false && 
                <div data-aos="fade-left"  className="about-area ptb--60 bg_color--5" id="db">
                    <div className="about-wrapper">
                        <div className="container">
                            <div className="row row--35 align-items-center">
                                <div className="col-lg-5">
                                    <div className="thumbnail">
                                        <img className="w-80" height={window.type_device ? "197px": "350px"} src="/assets/images/dojopy/module-8.png" alt="tercer módulo bases de datos"/>
                                    </div>
                                </div>
                                <div className="col-lg-7">
                                    <div className="about-inner inner">
                                        <div className="section-title">
                                         
                                            <h2 className="title mb-0">{true ? "BASES DE DATOS": "DATABASES"} </h2>
                                            <div style={{width: window.type_device ? "200px": "395px", height: "6px", backgroundColor: "#ffcb48", marginBottom: "17px", transform: "rotate(178deg)", marginTop: "-2px"}}></div>

                                            <p>
                                         <b>
                                         Construye tus propios modelos de bases de datos con las mejores prácticas desde cero
                                            </b>  </p>

                                        </div>

                                        {!this.state.showMoreE &&
                                            <div className="col-12 text-left">
                                                <button
                                                onClick={() => this.setState({showMoreE: true}) }
                                                type="submit"
                                                name="submit"
                                                id="mc-embedded-subscribe-"
                                                style={{ marginTop: "5px", marginBottom: "5px", fontSize: "18px",
                                                "border-radius": "20px",
                                                "border": "2px solid #6a5acd",
                                                "padding": "9px 20px"

                                            }}
                                                >
                                                {true ? "Mostrar más": "Show more"} <br/>
                                                <AiOutlineDown style={{padding: "5px", fontSize: "30px"}}/>
                                                </button>
                                            </div>}

            {this.state.showMoreE &&
                <>

                                            <p>
        Antes de utilizar cualquier tecnología para bases de datos debes entender los fundamentos de diseño y modelado
         requeridos para que tengas la mejor arquitectura posible.

                                            </p>
                                    <div className="row mt--30">
                                            <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                                                <div className="about-us-list">
                                                <h4 className="title"><FiCheck style={{"color": "slateblue"}}/> Fundamentos</h4>
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                                                <div className="about-us-list">
                                                <h4 className="title"><FiCheck style={{"color": "slateblue"}}/> Bases de Datos Relacionales (PostgreSQL)</h4>
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                                                <div className="about-us-list">
                                                <h4 className="title"><FiCheck style={{"color": "slateblue"}}/> Bases de Datos no Relacionales (mongoDB/Mongoose)</h4>
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                                                <div className="about-us-list">
                                                <h4 className="title"><FiCheck style={{"color": "slateblue"}}/> Cloud Databases</h4>
                                                </div>
                                            </div>
                                        </div>
                                        </>}

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
    }





{this.state.showWeb && 
    <div data-aos="fade-left"  className="about-area ptb--60 bg_color--5" id="">
                    <div className="about-wrapper">
                        <div className="container">
                            <div className="row row--35 align-items-center">
                                <div className="col-lg-5">
                                    <div className="thumbnail">
                                        <img className="w-80" height={window.type_device ? "250px": "390px"} src="/assets/images/dojopy/BOOTCAMP-apps-r.png" alt=""/>
                                    </div>
                                </div>
                                <div className="col-lg-7">
                                    <div className="about-inner inner">
                                        <div className="section-title">
                                                          
                                                          
                                            <h2 className="title mb-0">
                                                Apps Móviles y Multiplataforma
                                            </h2>
                                            <div style={{width: window.type_device ? "200px": "395px", height: "6px", backgroundColor: "#ffcb48", marginBottom: "17px", transform: "rotate(178deg)", marginTop: "-2px"}}></div>
                                            <p>
                                        <b>
                                        🚀 ¡Crea apps increíbles con React Native! Aprende a desarrollar aplicaciones móviles multiplataforma para iOS y Android con una sola base de código. Diseña experiencias rápidas y modernas mientras optimizas tiempo y recursos. ¡El futuro del desarrollo móvil está en tus manos! 🌟
                                    
                                        </b>  </p>


                                        </div>
              
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
    }




{this.state.showWeb && 
    <div data-aos="fade-left"  className="about-area ptb--60 bg_color--5" id="">
                    <div className="about-wrapper">
                        <div className="container">
                            <div className="row row--35 align-items-center">
                                <div className="col-lg-5">
                                    <div className="thumbnail">
                                        <img className="w-80" height={window.type_device ? "197px": "350px"} src="/assets/images/dojopy/module-9.png" alt="Desplieque en Amazon Web Services"/>
                                    </div>
                                </div>
                                <div className="col-lg-7">
                                    <div className="about-inner inner">
                                        <div className="section-title">
                                                          
                                                          
                                            <h2 className="title mb-0">{true ? "Cloud AWS": "DEPLOYMENT IN THE AWS CLOUD"}</h2>
                                            <div style={{width: window.type_device ? "200px": "395px", height: "6px", backgroundColor: "#ffcb48", marginBottom: "17px", transform: "rotate(178deg)", marginTop: "-2px"}}></div>
                                            <p>
                                        <b>{true ? "Sube tus aplicaciones web en la moderna arquitectura de AWS.": "Upload your web applications on the modern architecture of AWS."}  </b>  </p>

                                        {!this.state.showMoreF &&
                                            <div className="col-12 text-left">
                                                <button
                                                onClick={() => this.setState({showMoreF: true}) }
                                                type="submit"
                                                name="submit"
                                                id="mc-embedded-subscribe-"
                                                style={{ marginTop: "5px", marginBottom: "5px", fontSize: "18px",
                                                "border-radius": "20px",
                                                "border": "2px solid #6a5acd",
                                                "padding": "9px 20px"

                                            }}
                                                >
                                                {true ? "Mostrar más": "Show more"} <br/>
                                                <AiOutlineDown style={{padding: "5px", fontSize: "30px"}}/>
                                                </button>
                                            </div>}

                                        </div>

                {this.state.showMoreF &&
                <>
                                        <p>
        AWS es una de las principales plataformas de servicios de computación
        en la nube a nivel mundial, AWS proporciona un amplio conjunto de servicios de
        infraestructura tal como potencia de cómputo, opciones de almacenamiento, redes y bases de datos ofertados
        con una utilidad bajo demanda, disponibles en cuestión de segundos y pagando solo por lo que utiliza. <br/>
                                            </p>

                                    <div className="row mt--30">
                                            <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                                                <div className="about-us-list">
                                                <h4 className="title"><FiCheck style={{"color": "slateblue"}}/> Bases de datos</h4>
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                                                <div className="about-us-list">
                                                <h4 className="title"><FiCheck style={{"color": "slateblue"}}/> Servidor privado</h4>
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                                                <div className="about-us-list">
                                                <h4 className="title"><FiCheck style={{"color": "slateblue"}}/> Almacenamiento</h4>
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                                                <div className="about-us-list">
                                                <h4 className="title"><FiCheck style={{"color": "slateblue"}}/> Arquitectura Serverless</h4>
                                                </div>
                                            </div>
                                        </div>
                                    </>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
    }


{false && this.state.showWeb && 
    <div data-aos="fade-left"  className="about-area ptb--60 bg_color--5" id="">
                    <div className="about-wrapper">
                        <div className="container">
                            <div className="row row--35 align-items-center">
                                <div className="col-lg-5">
                                    <div className="thumbnail">
                                        <img  height={window.type_device ? "200px": "350px"} src="/assets/images/dojopy/cibersecurity-program.webp" alt="Desplieque en Amazon Web Services"/>
                                    </div>
                                </div>
                                <div className="col-lg-7">
                                    <div className="about-inner inner">
                                        <div className="section-title">
                                                          
                                            <h2 className="title mb-0">{true ? "Ciberseguridad": ""}</h2>
                                            <div style={{width: window.type_device ? "200px": "395px", height: "6px", backgroundColor: "#ffcb48", marginBottom: "17px", transform: "rotate(178deg)", marginTop: "-2px"}}></div>
                                            <p>
                                        <b>{true ? "Domina la Seguridad Digital para detener a los hackers": "Upload your web applications on the modern architecture of AWS."}  </b>  </p>

                                        {!this.state.showMoreF &&
                                            <div className="col-12 text-left">
                                                <button
                                                onClick={() => this.setState({showMoreF: true}) }
                                                type="submit"
                                                name="submit"
                                                id="mc-embedded-subscribe-"
                                                style={{ marginTop: "5px", marginBottom: "5px", fontSize: "18px",
                                                "border-radius": "20px",
                                                "border": "2px solid #6a5acd",
                                                "padding": "9px 20px"

                                            }}
                                                >
                                                {true ? "Mostrar más": "Show more"} <br/>
                                                <AiOutlineDown style={{padding: "5px", fontSize: "30px"}}/>
                                                </button>
                                            </div>}

                                        </div>

                {this.state.showMoreF  &&
                <>
                                        <p>
En este programa Ciberseguridad, aprenderás todo lo esencial sobre ciberseguridad ofensiva y defensiva para salvaguardar cualquier tipo de activo digital.
                                            </p>

                                    <div className="row mt--30">
                                            <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                                                <div className="about-us-list">
                                                <h4 className="title"><FiCheck style={{"color": "slateblue"}}/>🔐 Hacking Ético y Pruebas de Penetración  </h4>
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                                                <div className="about-us-list">
                                                <h4 className="title"><FiCheck style={{"color": "slateblue"}}/> 🛡️ Seguridad en Redes y Protocolos
</h4>
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                                                <div className="about-us-list">
                                                <h4 className="title"><FiCheck style={{"color": "slateblue"}}/> ⚙️ Análisis de Vulnerabilidades y Hardening de Sistemas
</h4>
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                                                <div className="about-us-list">
                                                <h4 className="title"><FiCheck style={{"color": "slateblue"}}/> 📊 Respuesta ante Incidentes y Forense Digital</h4>
                                                </div>
                                            </div>
                                        </div>
                                    </>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
    }


{this.state.showWeb && 
    <div data-aos="fade-left"  className="about-area ptb--60 bg_color--5" id="">
                    <div className="about-wrapper">
                        <div className="container">
                            <div className="row row--35 align-items-center">
                                <div className="col-lg-5">
                                    <div className="thumbnail">
                                        <img height={window.type_device ? "197px": "350px"} src="/assets/images/dojopy/project-fullstack-web.webp" alt="proyecto startups"/>
                                    </div>
                                </div>
                                <div className="col-lg-7">
                                    <div className="about-inner inner">
                                        <div className="section-title">
                                            <span style={{padding: "3px", marginLeft: "7px", "background-color": "tomato", "border-radius": "7px", "padding-left": "7px", "padding-right": "7px", "color": "white", "font-size": "18px"}}>
                                                            <span className="pulsar"></span> {true ? "En vivo": "Live"}
                                                            </span>
                                            <h2 className="title mb-0">{true ? "Desarrollo de Proyectos": "Full Stack Developer PROJECT"} </h2>
                                            <div style={{width: window.type_device ? "200px": "395px", height: "6px", backgroundColor: "#ffcb48", marginBottom: "17px", transform: "rotate(178deg)", marginTop: "-2px"}}></div>
                                      
                                      
                           

                                         <p>
        Aplicaciones web desarrolladas de principio a fin, integrando frontend, backend, bases de datos, autenticación, pasarelas de pago y despliegue en la nube.

                                            </p>
                                        </div>


                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
    }





{ false &&
 <div className="about-area ptb--60 bg_color--5" id="platform">
                    <div className="about-wrapper">
                        <div className="container">
                            <div className="row row--35 align-items-center">
                                <div className="col-lg-5">
                                    <div className="thumbnail">
                                        <img height="290px" src="/assets/images/dojopy/viajes_study.webp" alt=""/>
                                    </div>
                                </div>
                                <div className="col-lg-7">
                                    <div className="about-inner inner">
                                        <div className="section-title">
                                     
                                            <h2 className="title" style={{textTransform: "uppercase"}}>
                                               Viaje de Estudios a EE. UU.
                                            </h2>
                                            <div style={{width: window.type_device ? "197px": "395px", height: "6px", backgroundColor: "#ffcb48", marginBottom: "17px", transform: "rotate(178deg)", marginTop: "-2px"}}></div>

                                            <span style={{lineHeight: "21px", display: 'inline-block', padding: "5px",marginLeft: "5px", "background-color": "slateblue", "border-radius": "7px", "padding-left": "7px", "padding-right": "7px", "color": "white", "font-size": "18px"}}>
                                                Sorteos cada temporada
                                                </span>

                                          
                                            <p>
                                        Gana un viaje todo pagado para visitar las principales empresas tecnológicas (Microsoft, Oracle, IBM, Cisco) y startups innovadoras. Además, realizamos sorteos cada temporada para que más estudiantes tengan la oportunidad de vivir esta experiencia única: conocer la cultura tech de EE. UU. y conectar con profesionales de la industria.
                                            </p>

                                          
                                          
                                </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
    }



{false && 
 <div className="about-area ptb--60 bg_color--5" id="platform">
                    <div className="about-wrapper">
                        <div className="container">
                            <div className="row row--35 align-items-center">
                                <div className="col-lg-5">
                                    <div className="thumbnail">
                                        <img height="300px" src="/assets/images/dojopy/banner_ingles.webp" alt="ROGRAMA DE EMPLEO y ACELERACIÓN LABORAL"/>
                                    </div>
                                </div>
                                <div className="col-lg-7">
                                    <div className="about-inner inner">
                                        <div className="section-title">
                                     
                                            <h2 className="title" style={{textTransform: ""}}>
                                               Ingles para Devs
                                            </h2>

                                            <span style={{lineHeight: "21px", display: 'inline-block', padding: "5px",marginLeft: "5px", "background-color": "slateblue", "border-radius": "7px", "padding-left": "7px", "padding-right": "7px", "color": "white", "font-size": "18px"}}>
                                                Programa Optativo
                                                </span>

                                            <div style={{width: window.type_device ? "197px": "395px", height: "6px", backgroundColor: "#ffcb48", marginBottom: "17px", transform: "rotate(178deg)", marginTop: "-2px"}}></div>
                                          
                                            <p>
Mejora tu inglés técnico con clases dinámicas, talleres y grupos de conversación. Comunica mejor, accede a más oportunidades y prepárate para el mercado global. ¡Únete ahora!

                                            <br/> <br/>
                                            <b>
                                            🚀 Con este programa, también tendrás la oportunidad de trabajar para empresas de Estados Unidos y multiplicar tu salario hasta 5 veces.

                                            </b>

                                            </p>

                                          
                                          
                                </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
    }






{ this.state.showWeb && 
 <div className="about-area ptb--60 bg_color--5" id="">
                    <div className="about-wrapper">
                        <div className="container">
                            <div className="row row--35 align-items-center">
                                <div className="col-lg-5">
                                    <div className="thumbnail">
                                        <img height="297px" src="/assets/images/dojopy/TALENTO_search.webp" alt="PROGRAMA DE EMPLEO y ACELERACIÓN LABORAL"/>
                                    </div>
                                </div>
                                <div className="col-lg-7">
                                    <div className="about-inner inner">
                                        <div className="section-title">
                                     
                                            <h2 className="title" style={{textTransform: "uppercase"}}>
                                               {true ? "Preparación Laboral Real": "EMPLOYMENT PROGRAM"}
                                            </h2>


                                    <div style={{width: window.type_device ? "197px": "395px", height: "6px", backgroundColor: "#ffcb48", marginBottom: "17px", transform: "rotate(178deg)", marginTop: "-2px"}}></div>
                                  
                                   <p>En DojoFullStack, creemos firmemente en la calidad de nuestra formación y en el potencial de nuestros estudiantes. Por ello, al completar el Bootcamp, tendrás acceso a una <b>asesoría personalizada 1 a 1</b> con un coach especializado en empleabilidad.</p> <p>Este acompañamiento incluye la <b>optimización de tu perfil profesional</b>, preparación para entrevistas y apoyo en tu estrategia de búsqueda laboral. Nuestro objetivo es que estés <b>mejor preparado para acceder a oportunidades en el sector tech</b>, con las herramientas y el respaldo necesario para destacar en el mercado.</p>
                                          
                                </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
    }


{this.state.showWeb && 
                <Plataforma langUS={this.state.langUS} />
}



{this.state.showWeb && 
                <div data-aos="fade-right" className="about-area ptb--20 " id="methodology">
                    <div className="about-wrapper">
                        <div className="container">
                            <div className="row row--35 align-items-center">


                                 {window.type_device ? (
                                        <div className="col-12" style={{textAlign: "-webkit-center", marginLeft: "-45px", marginBottom: "-40px"}}>
                                            <ReactPlayer
                                            muted={true}
                                            loop={true}
                                            url={"/assets/video/demo_lite_1.mp4"}
                                            playing={true}
                                            width={400}
                                            height={250}
                                                />
                                        </div>
                                    ):(
                                        <div className="col-12" style={{textAlign: "-webkit-center"}}>
                                        <ReactPlayer
                                        muted={true}
                                        loop={true}
                                        url={"/assets/video/demo_lite_1.mp4"}
                                        playing={true}
                                        width={520}
                                        />
                                        </div>
                                    )}


                                <div className="col-12" style={{textAlign: "-webkit-center", paddingTop: "30px"}}>
                                    <div className="about-inner inner">
                                        <div className="section-title" style={{height: "103px"}}>
                                        {window.type_device ? (
                                            <h2>Aprende online 
                                                 <span style={{lineHeight: "17px", display: 'inline-block', padding: "3px",marginLeft: "7px", "background-color": "tomato", "border-radius": "7px", "padding-left": "7px", "padding-right": "7px", "color": "white", "font-size": "16px"}}>
                                                            <span className="pulsar"></span> En vivo
                                                            </span>
                                         
                                                 </h2>
                                        ): (
                                            <TypingAnimation2/>
                                        )}

                                        </div>

                                        <h4 style={{fontSize: "18px"}}>
                                             En DojoFullStack proponemos un nuevo modelo educativo que incluye entornos de aprendizaje sincrónicoss con un enfoque que vincula la teoría y la práctica, mediante un aprendizaje activo.
                                            </h4>


                                    </div>
                                </div>

                            </div>

                        </div>

                    </div>
                </div>
    }





                <div>
            </div>





    {/* Start Team Area  */}
    { this.state.showWeb &&
    <div data-aos="fade-up" className="rn-team-area ptb--10 bg_color--1" id="modules">
        <div className="container" style={{"maxWidth": "900px"}}>
            <div className="row">
                <div className="col-12">
                    <div className="text-center mb--30">
                        <h3 className="title">
                        {true ? "El Bootcamp está formado por los siguientes módulos":
                            "The Bootcamp is made up of the following modules"}
                            </h3>
                                    <div className="mx-auto mt-1" style={{width: window.type_device ? "197px": "200px", height: "6px", backgroundColor: "#ffcb48", marginBottom: "17px", transform: "rotate(178deg)", marginTop: "-2px"}}></div>


 {/* <a href={this.state.Temario} target="_blank" rel="noopener noreferrer" style={{color: "#1f1f25", textDecoration: "none"}}>    
  <button
    onClick={() => {
    window.fbq('track', 'AddToCart', {
        value: this.state.price_mount,                 // Valor total de la compra
        currency: 'USD',               // Moneda utilizada (ISO 4217)
        content_type: 'product',       // Tipo de contenido
        content_ids: ['bootcamp'],  // ID del producto o identificador
        content_name: 'bootcamp'
      });
}}
    style={{
      textShadow: "none",
      cursor: "pointer",
      fontWeight: "bold",
      fontSize: "19px",
      padding: "10px 19px",
      borderRadius: "20px",
      background: "linear-gradient(180deg,#ffe26d,#f5c918)",
      color: "black",
      border: "none",
      outline: "none"
    }}
    className="btn-efect-live"
  >
    <IoIosDocument className="mr-2" />
        Ver Brochure
  </button>
</a> */}

                    </div>
                    <div>
                <AccordionWrapper>
                    <AccordionItem  index={0} title={true ? "Fundamentos del Desarrollo y Programación": "Fundamentals of Web Development"} description={true ? InfoAcordeon.web: InfoAcordeonUS.web}></AccordionItem>
                    <AccordionItem  index={1} title={true ? "Git & Github": "Git & Github"} description={true ? InfoAcordeon.git: InfoAcordeonUS.git}></AccordionItem>
                    <AccordionItem  index={2} title={"Web Deployment"} description={InfoAcordeon.web_deploy}></AccordionItem>
                    <AccordionItem index={3} title={true ? "JavaScript": "JavaScript"} description={true ? InfoAcordeon.js: InfoAcordeonUS.js}></AccordionItem>
                    <AccordionItem index={4} title={true ? "Frontend con React JS": "Frontend with ReactJS"} description={true ? InfoAcordeon.react: InfoAcordeonUS.react}></AccordionItem>
                    <AccordionItem index={5} title={true ? "Bases de Datos": "Databases"} description={true ? InfoAcordeon.database: InfoAcordeonUS.database}></AccordionItem>
                    <AccordionItem index={6} title={true ? "Backend con Python y Django": "Backend with Python and Django"} description={true ? InfoAcordeon.python: InfoAcordeonUS.python}></AccordionItem>
                    <AccordionItem index={7} title={true ? "API REST": "API REST"} description={true ? InfoAcordeon.api: InfoAcordeonUS.api}></AccordionItem>
                    <AccordionItem index={8} title={true ? "Testing & Seguridad": "Testing & Security"} description={true ? InfoAcordeon.apiSecure: InfoAcordeonUS.apiSecure}></AccordionItem>
                    <AccordionItem index={9} title={true ? "Servicios en la nube con Amazon Web Services": "Deployment in the AWS cloud"} description={true ? InfoAcordeon.deploy_aws: InfoAcordeonUS.deploy_aws}></AccordionItem>
                    <AccordionItem index={10} title={true ? "Proyectos Full Stack Developer": "Full Stack Developer Project"} description={true ? InfoAcordeon.project: InfoAcordeonUS.project}></AccordionItem>
                    <AccordionItem index={12} title={true ? "Apps Multiplataforma": "Full Stack Developer Project"} description={true ? InfoAcordeon.appsMobiles: InfoAcordeonUS.project}></AccordionItem>
                    <AccordionItem index={13} title={true ? "Empleabilidad": "Employability"} description={true ? InfoAcordeon.employer: InfoAcordeonUS.employer}></AccordionItem>
                </AccordionWrapper>
                    </div>

                   
                </div>
            </div>

        </div>



    </div>
    }
    {/* End Team Area  */}













{this.state.showWeb && 
    <>
     <div style={{marginTop: "20px"}} className="section-title service-style--3 text-center mb--25 mb_sm--0 text-center">
                    <h2 className="title">{true ? "Testimonios": "Testimonials"} </h2>
                </div>

                <div className="rn-testimonial-area bg_color--1 ptb--80">
                    <div className="container">
                        <TestimonialOne langUS={this.state.langUS}  country={this.state.countryCode} />



    
                        <div className="mt-3" style={{backgroundColor: "white", padding: "0", textAlign: "left"}}>
                        {/* <div className="d-flex my-3" style={{flexDirection: "column", borderRadius: "15px", boxShadow: "5px 2px 9px 9px #dee2e6", padding: "5px", alignItems: "center"}}>
                            <div className="d-flex mb-2">
                            <img className="ml-1" style={{borderRadius: "30px", marginRight: "5px"}} height="65px"
                            src="/assets/images/dojopy/harold-face.png" 
                            />
                            <div className="ml-2 mt-2">
                              <h5 style={{fontStyle: "italic"}} className="my-0">Harold F.
                              <FaFacebookSquare style={{marginLeft: "5px", fontSize: "18px", color: "#1877F2"}}/>
                        
                                <span style={{marginLeft: "5px", fontSize: "13px", color: "gray"}}></span>
                              </h5>
                              <p className="my-0"><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/></p>
                        
                            </div>
                            </div>
                          
                            <div style={{maxWidth: "500px"}}>
                                <video autoPlay width={"100%"} controls muted src="/assets/video/testimonios-2025.mp4"></video>
                              </div>
                          </div> */}

                        <div className="d-flex my-3" style={{borderRadius: "15px", boxShadow: "5px 2px 9px 9px #dee2e6", padding: "5px", alignItems: "flex-start"}}>
                            <img className="ml-1" style={{borderRadius: "30px", marginRight: "5px"}} height="65px"
                            src="/assets/images/dojopy/019209102.png" 
                            />
                            <div className="ml-2 mt-2">
                              <h5 style={{fontStyle: "italic"}} className="my-0">Javier L.
                              <FaFacebookSquare style={{marginLeft: "5px", fontSize: "20px", color: "#1877F2"}}/>
                        
                                <span style={{marginLeft: "5px", fontSize: "13px", color: "gray"}}></span>
                              </h5>
                              <p className="my-0"><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/></p>
                        
                              <p style={{fontSize: "11px", fontStyle: "italic"}}>
                              "Como estudiante de informática, sentía que me faltaba experiencia práctica para destacar en el mercado laboral. Gracias al bootcamp, pude desarrollar proyectos reales y adquirir habilidades actuales que no enseñan en la universidad. Ahora, mientras termino mis estudios, ya trabajo como Full Stack Developer Developer en una empresa de tecnología, ganando más de $4,000/mes. ¡El bootcamp fue el complemento perfecto para mi carrera!"
                        
                              <br/>
                              <b>
                              – Javier L., estudiante de informática y Desarrollador en una empresa de tecnología.
                        
                              </b>
                              </p>
                            </div>
                          </div>
                        
                          <div className="d-flex my-3" style={{borderRadius: "15px", boxShadow: "5px 2px 9px 9px #dee2e6", padding: "5px", alignItems: "flex-start"}}>
                          <img className="ml-1" style={{borderRadius: "30px", marginRight: "5px"}} height="65px"
                            src="/assets/images/team/faces/face_3.webp" 
                            />
                            <div className="ml-2 mt-2">
                              <h5 style={{fontStyle: "italic"}} className="my-0">Bladimir G.
                                <FaFacebookSquare style={{marginLeft: "5px", fontSize: "20px", color: "#1877F2"}}/>
                                <span style={{marginLeft: "5px", fontSize: "13px", color: "gray"}}></span>
                              </h5>
                              <p className="my-0"><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/></p>
                              
                              <p style={{fontSize: "11px", fontStyle: "italic"}}>
                              "Decidí inscribirme en el bootcamp Full Stack Developer y fue la mejor decisión de mi vida. Ahora tengo la oportunidad de trabajar con importantes empresas y mis ingresos han mejorado significativamente ¡Gracias Dojofullstack, por brindarme una educación de calidad!"
                              <br/>
                              <b>
                                 – Bladimir G., ex principiante y ahora Developer en una empresa internacional.
                              </b>
                              </p>
                            </div>
                          </div>
                        
                        
                          <div className="d-flex my-3" style={{borderRadius: "15px", boxShadow: "5px 2px 9px 9px #dee2e6", padding: "5px", alignItems: "flex-start"}}>
                          <img className="ml-1" style={{borderRadius: "30px", marginRight: "5px"}} height="65px"
                            src="/assets/images/team/faces/face_4.webp" 
                            />
                            <div className="ml-2 mt-2">
                              <h5 style={{fontStyle: "italic"}} className="my-0">Victor R.
                              <FaFacebookSquare style={{marginLeft: "5px", fontSize: "20px", color: "#1877F2"}}/>
                        
                                <span style={{marginLeft: "5px", fontSize: "13px", color: "gray"}}></span>
                              </h5>
                              <p className="my-0"><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/></p>
                        
                              <p style={{fontSize: "11px", fontStyle: "italic"}}>
                              "Cuando seguí esta ruta, pasé de vender ropa en línea a ganar $3,000/mes como Developer Full Stack Developer."
                              <br/>
                              <b>
                                 – Victor R., ex principiante y ahora Developer en una empresa internacional.
                              </b>
                              </p>
                            </div>
                          </div>
                        
                        
                        
                        
                        
                          <div className="d-flex my-3" style={{borderRadius: "15px", boxShadow: "5px 2px 9px 9px #dee2e6", padding: "5px", alignItems: "flex-start"}}>
                          <img className="ml-1" style={{borderRadius: "30px", marginRight: "5px"}} height="65px"
                            src="/assets/images/team/faces/face_1.webp" 
                            />
                            <div className="ml-2 mt-2">
                              <h5 style={{fontStyle: "italic"}} className="my-0">Laura M.
                              <FaFacebookSquare style={{marginLeft: "5px", fontSize: "20px", color: "#1877F2"}}/>
                        
                                <span style={{marginLeft: "5px", fontSize: "13px", color: "gray"}}></span>
                              </h5>
                              <p className="my-0"><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/></p>
                        
                              <p style={{fontSize: "11px", fontStyle: "italic"}}>
                              "Soy mamá de dos niños y trabajaba como profesora de primaria.
                        A los 30 años, pensé que era tarde para cambiar de carrera…
                        ¡Hoy trabajo como Full Stack Developer Developer para una empresa alemana
                        y gano $3,800/mes desde casa! Lo mejor: veo crecer a mis hijos
                        mientras diseño aplicaciones educativas que usan miles de alumnos."
                        
                              <br/>
                              <b>
                                 – Laura M., egresada del programa en 4 meses.
                        
                              </b>
                              </p>
                            </div>
                          </div>
                        
                        
                        
                          <div className="d-flex my-3" style={{borderRadius: "15px", boxShadow: "5px 2px 9px 9px #dee2e6", padding: "5px", alignItems: "flex-start"}}>
                          <img className="ml-1" style={{borderRadius: "30px", marginRight: "5px"}} height="65px"
                            src="/assets/images/dojopy/01920912.png" 
                            />
                            <div className="ml-2 mt-2">
                              <h5 style={{fontStyle: "italic"}} className="my-0">Maria Sanchez
                              <FaFacebookSquare style={{marginLeft: "5px", fontSize: "20px", color: "#1877F2"}}/>
                        
                                <span style={{marginLeft: "5px", fontSize: "13px", color: "gray"}}></span>
                              </h5>
                              <p className="my-0"><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/></p>
                        
                              <p style={{fontSize: "11px", fontStyle: "italic"}}>
                              Siempre pensé que una carrera en tecnología estaba fuera de mi alcance. Sin embargo, el bootcamp no solo me enseñó habilidades técnicas, sino también cómo aplicarlas en el mundo real. Ahora trabajo para una empresa de tecnología educativa y gano más de $2,300/mes. Lo mejor es que puedo trabajar remotamente y pasar tiempo de calidad con mi hijo.
                        
                              <br/>
                              <b>
                                 – Maria Sanchez., egresada del programa en 4 meses.
                        
                              </b>
                              </p>
                            </div>
                          </div>
                          
                          
                             <div className="mt-4 text-center">
                    <img alt="" height={window.type_device ? "80px": "89px"} src="/assets/images/dojopy/truspilot.png" />
                    <img alt="" height={window.type_device ? "80px": "89px"} src="/assets/images/dojopy/dojofullstack_report.png" />
                    <span style={{display: "inline-block", marginLeft: "5px", color: "white", "font-size": "13px", "paddingTop": "20px", fontStyle: "italic"}}>  
                    Excelencia Asegurada en la Formación </span>
                    </div>

                          </div>
              


                    </div>


                    
                </div>
    </>
    }











          

                {/* <Modal show={this.state.isOpen2} size="md" onHide={this.openModal2} style={{zIndex: "9999999999"}} >
                <span style={{textAlign: "left", "color":"slateblue"}}> <IoCloseCircleOutline onClick={() => this.openModal2()} style={{ cursor: "pointer", fontSize: "35px", marginLeft: "12px", marginTop: "12px", color: "slateblue"}} /> </span>

                    <Modal.Body>
                    <div className="about-inner inner">
                        <div className="section-title">
                            <p>
No te preocupes. Nuestros programas son aptos para principiantes y no requieren ningún conocimiento previo ni hay limite de edad.
Además, no estarás solo. Nuestro equipo estará a tu lado para guiarte en el proceso, ayudarte a establecer objetivos y a tener éxito.
                            </p>
                            <p>
                                <b>Instalar Zoom:</b>
                                <img style={{borderRadius: "10px"}} alt="canal zoom" height="55px" src="/assets/images/dojopy/zoom_.webp"></img>
                            </p>
                    </div>
                    </div>
                    </Modal.Body>
                    <Modal.Footer style={{"justify-content": "center"}}>
                    <button className="rn-btn" onClick={this.openModal2}>{true ? "Cerrar": "Close"}</button>
                    </Modal.Footer>
                </Modal> */}


     

    

                <Modal show={this.state.isOpen2} size="md" onHide={this.openModal2} style={{zIndex: "9999999999"}} >
                <span style={{textAlign: "left", "color":"slateblue"}}> <IoCloseCircleOutline onClick={() => this.openModal2()} style={{ cursor: "pointer", fontSize: "39px", marginLeft: "12px", marginTop: "12px", color: "slateblue"}} /> </span>

                    <Modal.Body>
                    <div className="about-inner inner pt-3">
                        <div className="section-title">

                            <h3 class="title text-black px-0 my-0 text-center" style={{fontSize: window.type_device ? "30px": "37px", lineHeight: "1.4"}}>
                              Únete a la <br/> Masterclass  Gratuita
                             </h3>
                             <div className=" mx-auto" style={{width: window.type_device ? "197px": "395px", height: "6px", backgroundColor: "gold", marginBottom: "17px", transform: "rotate(178deg)", marginTop: "-2px"}}></div>

                            <p style={{fontSize: window.type_device ? "17px": "18px", textAlign: "left"}}>
                                <b style={{display: "inline-block"}}> ¿Quieres trabajar en tecnología pero no sabes por dónde empezar? </b>
                                En nuestro Masterclass "De Cero a Desarrollador Full Stack Developer" descubrirás:
                            </p>
                            <ul >
                                <li style={{fontSize: window.type_device ? "16px": "17px" }}>✅ Cómo iniciar en programación sin experiencia previa</li>
                                <li style={{fontSize: window.type_device ? "16px": "17px" }}>✅ El paso a paso para crear tu primera aplicación web y móvil desde cero.</li>
                                <li style={{fontSize: window.type_device ? "16px": "17px" }}>✅ <b> Un descuento exclusivo, disponible por tiempo limitado. </b>  </li>
                            </ul>

<div style={{justifySelf: "center", textAlign: "center", marginTop: "13px"}}>
<a target="_blank" href={"/masterclass" + window.location.search} style={{textDecoration: "none", color: "white", textAlign: "center"}}>
  <button
    // onClick={() => document.querySelector('#registro').scrollIntoView({ behavior: 'smooth' })}
    style={{
      textShadow: "none",
      cursor: "pointer",
      fontWeight: "bold",
      fontSize: "20px",
      padding: "10px 19px",
      borderRadius: "20px",
      background: "linear-gradient(180deg,#ffe26d,#f5c918)",
      color: "black",
      border: "none",
      outline: "none"
    }}
    className="btn-efect-live"
  >
    <AiOutlineRight className="mr-2" />
    Ir a la Masterclass
  </button>
  </a>

    <h3
                  className="my-0 text-center"
                       style={{borderRadius: "9px", color: "black", fontWeight: "normal", display: "block", padding: "10px", "padding-left": "15px", "padding-right": "15px", "font-size": window.type_device ? "15px": "16px" }}>
                     <FaFilm className="mr-2" />
     Acceso exclusivo solo por hoy
                      </h3>
</div>

                       
                    </div>
                    </div>
                    </Modal.Body>
            
                </Modal>



                <Modal show={this.state.isOpenSuscribe} size="xl" onHide={() => this.setState({isOpenSuscribe: false, selectFecha: false})} style={{top:  window.type_device ? "1%": "15%", zIndex: "999999"}}>

                <span style={{marginLeft: "5px", marginTop: "5px", textAlign: "left", "color":"slateblue"}}> <IoCloseCircleOutline onClick={() => this.setState({isOpenSuscribe: false, selectFecha: false}) } style={{ cursor: "pointer", fontSize: "41px", marginLeft: "12px", marginRight: "12px", marginTop: "12px", color: "slateblue"}} /> </span>

                <Modal.Body className="body-evento">

                <div className="inner">
                    <div className="contact-form--1">
                            <div className="row">
                                <div className="col-12 col-md-7 px-2">
                                <h3 className="mb-1 text-center" style={{fontSize: window.type_device ? "26px": "39px"}}>
                                   Empieza tu inscripción al Bootcamp Full Stack Developer
                                </h3>

                                <div className="mx-auto" style={{width: window.type_device ? "190px": "290px", height: "6px", backgroundColor: "#ffcb48", marginBottom: "17px", transform: "rotate(178deg)", marginTop: "-2px"}}></div>
                                    <>
                                    <h5 className="my-2" style={{fontWeight: "500", fontSize: window.type_device ? "17px": "18px"}}>
                                    Inscríbete ahora y accede inmediatamente al Bootcamp.
</h5>

                                    {!window.type_device && this.renderInfoBootcamp()}


                                    {/* formulario */}
                                    {window.type_device &&
                                    <>
<div data-aos="fade-right" className="col-12 col-md-6 px-1" style={{marginBottom: "25px"}}>
                <div style={{textAlign: "center", padding: "5px", boxShadow: "rgba(50, 27, 98, 0.47) 6px 5px 15px 0px", border: "", borderRadius: "20px" }}>

            <form onSubmit={this.onSubmit} className="px-1" style={{paddingTop: "10px", paddingBottom: "10px" }}>

 <div className="section-title mt-3 mb-1 d-flex">
    <h3 className="title mb-2" style={{paddingLeft:  window.type_device ? "1px" : "9px"}}>
      Datos de Inscripción
    </h3>
</div> 
        <label className="col-12 text-left font-weight-bold" htmlFor="nameDojo">
            <span style={{fontSize: "15px", color: "black", fontWeight: "600"}}>
            Nombre:
            </span>
            <input
            id='nameDojo'
            style={{background: "white", marginBottom: "7px"}}
            type="text"
            name="name"
            value={this.state.Name}
            onChange={(e) => this.setState({ Name: e.target.value})}
            placeholder= {"👋 Hola! ¿Cuál es tu nombre?"}
            />
        </label>

           <label className="mb-2 col-12 text-left font-weight-bold" htmlFor="item02">
            <span style={{fontSize: "15px", color: "black", fontWeight: "600"}}>
            Email:
            </span>
                <input
                    style={{background: "white", marginBottom: "3px"}}
                    type="email"
                    name="email"
                    id="item02"
                    value={this.state.Email}
                    onChange={(e)=>{this.setState({Email: e.target.value});}}
                    placeholder="📧 ¿Cuál es tu Email?"
                    />
            </label> 


<div className="text-left mt-1" >
    <b style={{fontSize: "14px", marginLeft: "16px", color: "black", fontWeight: "600"}}>
        WhatsApp:
    </b>
</div>

<div className="d-flex justify-content-center mx-2">

<div className="mx-2 mt-2">
    <Selectrix
    className="pais-inscription"
    height={300}
    onRenderOption={this.onRenderOption}
    onRenderSelection={this.onRenderSelection}
    placeHolderInside={true}
    placeholder={"País"}
    customScrollbar={true}
    searchable={false}
    materialize={false}
    defaultValue={this.state.countryCode}
    options={KeyCountry}
    onChange={(value) => {
        // console.log("value.key", value.key);
        this.setState({"countryCode": value.key});
        if (this.state.Email){
            localStorage.setItem('email', this.state.Email);
        }
        if (this.state.Name){
            localStorage.setItem('name', this.state.Name);
        }
        if (this.state.Phone){
            localStorage.setItem('phone', this.state.Phone);
        }
    } }
    />

</div>

<div style={{width: "80%"}}>
<label htmlFor="Phone">
    
    <input
    style={{background: "white"}}
    type="tel"
    name="phone"
    id="Phone"
    value={this.state.Phone}
    onChange={(e) => {
        this.setState({ Phone: e.target.value });
    }}
    placeholder="987654321"
    />
 </label>
</div>

</div>  

 


<button
    id="submit-contacto"
    className="btn-efect"
    type="submit" name="submit-contacto"  style={{padding: "10px 20px", fontFamily: "'Poppins',sans-serif", width: "100%", fontSize: "23px", display: "block", margin: "auto", textTransform: "capitalize"}}>




{!this.state.loadingEnroll  && <b style={{fontSize: "23px"}}>
Empezar inscripción
    </b> }

{this.state.loadingEnroll  &&
                <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
                style={{fontSize: "20px", marginRight: "8px"}}
                />
}

</button>


   
   
<div className="row mt-3">
                    <div className="col-12 mx-3" style={{color: "gray", fontSize: "13px", textAlign: "left"}}>
                    <label htmlFor="checkNotify" style={{float: "left"}}>
                        <input
                            style={{width: 13, float: "left", marginTop: "-10px", marginRight: "5px", marginBottom: "1px"}}
                            defaultChecked={true}
                            type="checkbox"
                            name="checkNotify"
                            id="checkNotify"
                        />
                        <span>🔒 Protegemos tu información.</span>
                    </label>
                    </div>
                </div>


            </form>
                    </div>
            

        </div>
                                    </>
                                    }

                           {window.type_device && this.renderInfoBootcamp()}

                                 
                                    </>
                                </div>

     {/* formulario */}
{!window.type_device &&
<>
                                <div className="col-12 col-md-5" style={{paddingTop: "20px"}}>
                           
                    <div data-aos="fade-right" className="col-12 px-1" style={{marginBottom: "25px"}}>
                <div style={{textAlign: "center", padding: "5px", boxShadow: "rgba(50, 27, 98, 0.47) 6px 5px 15px 0px", border: "", borderRadius: "20px" }}>

            <form onSubmit={this.onSubmit} className="px-1" style={{paddingTop: "10px", paddingBottom: "10px" }}>

 <div className="section-title mt-3 mb-1 d-flex">
    <h3 className="title mb-2" style={{paddingLeft:  window.type_device ? "1px" : "9px"}}>
      Datos de Inscripción
    </h3>
</div> 

        <label className="col-12 text-left font-weight-bold" htmlFor="nameDojo">
            <span style={{fontSize: "15px", color: "black", fontWeight: "600"}}>
            Nombre:
            </span>
            <input
            id='nameDojo'
            style={{background: "white", marginBottom: "7px"}}
            type="text"
            name="name"
            value={this.state.Name}
            onChange={(e) => this.setState({ Name: e.target.value})}
            placeholder= {"👋 Hola! ¿Cuál es tu nombre?"}
            />
        </label>

           <label className="mb-2 col-12 text-left font-weight-bold" htmlFor="item02">
            <span style={{fontSize: "15px", color: "black", fontWeight: "600"}}>
            Email:
            </span>
                <input
                    style={{background: "white", marginBottom: "3px"}}
                    type="email"
                    name="email"
                    id="item02"
                    value={this.state.Email}
                    onChange={(e)=>{this.setState({Email: e.target.value});}}
                    placeholder="📧 ¿Cuál es tu Email?"
                    />
            </label> 

<div className="text-left mt-1" >
    <b style={{fontSize: "14px", marginLeft: "16px", color: "black", fontWeight: "600"}}>
        WhatsApp (para coordinar la llamada):
    </b>
</div>

<div className="d-flex justify-content-center mx-2">

<div className="mx-2 mt-2">
    <Selectrix
    className="pais-inscription"
    height={300}
    onRenderOption={this.onRenderOption}
    onRenderSelection={this.onRenderSelection}
    placeHolderInside={true}
    placeholder={"País"}
    customScrollbar={true}
    searchable={false}
    materialize={false}
    defaultValue={this.state.countryCode}
    options={KeyCountry}
    onChange={(value) => {
        // console.log("value.key", value.key);
        this.setState({"countryCode": value.key});
        if (this.state.Email){
            localStorage.setItem('email', this.state.Email);
        }
        if (this.state.Name){
            localStorage.setItem('name', this.state.Name);
        }
        if (this.state.Phone){
            localStorage.setItem('phone', this.state.Phone);
        }
    } }
    />

</div>
<div>
<label htmlFor="Phone">
    
    <input
    style={{background: "white"}}
    type="text"
    name="phone"
    id="Phone"
    value={this.state.Phone}
    onChange={(e) => {
        this.setState({ Phone: e.target.value });
    }}
    placeholder="N.º Celular"
    />
 </label>
</div>
</div> 




<button
    id="submit-contacto"
    className="btn-efect"
    type="submit" name="submit-contacto"  style={{padding: "10px 20px", fontFamily: "'Poppins',sans-serif", width: "100%", fontSize: "23px", display: "block", margin: "auto", textTransform: "capitalize"}}>




{!this.state.loadingEnroll  && <b style={{fontSize: "23px"}}>
Empezar inscripción
    </b> }

{this.state.loadingEnroll  &&
                <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
                style={{fontSize: "20px", marginRight: "8px"}}
                />
}

</button>


   
   
<div className="row mt-3">
                    <div className="col-12 mx-3" style={{color: "gray", fontSize: "14px", textAlign: "left"}}>
                    <label htmlFor="checkNotify" style={{float: "left"}}>
                        <input
                            style={{width: 15, float: "left", marginTop: "-10px", marginRight: "5px", marginBottom: "1px"}}
                            defaultChecked={true}
                            type="checkbox"
                            name="checkNotify"
                            id="checkNotify"
                        />
                        <span>🔒 Protegemos tu información.</span>
                    </label>
                    </div>
                </div>


            </form>
                    </div>
            

        </div>
        
                                   
                                </div>
 </>
                                    }

                                </div>
                        </div>
                        
                        </div>


                    </Modal.Body>

                </Modal>




        <Modal show={this.state.isOpenMett} size="xl" onHide={() => this.setState({isOpenMett: false, selectFecha: false})} style={{top:  window.type_device ? "1%": "15%", zIndex: "999999"}}>

                <span style={{marginLeft: "5px", marginTop: "5px", textAlign: "left", "color":"slateblue"}}> <IoCloseCircleOutline onClick={() => this.setState({isOpenMett: false, selectFecha: false}) } style={{ cursor: "pointer", fontSize: "41px", marginLeft: "12px", marginRight: "12px", marginTop: "12px", color: "slateblue"}} /> </span>

                <Modal.Body className="body-evento">

                <div className="inner">
                    <div className="contact-form--1">
                            <div className="row">
                                <div className="col-12 col-md-7 px-2">
                                <h3 className="mb-1 text-center" style={{fontSize: window.type_device ? "30px": "39px"}}>
                                   Solicita tu <br/> Beca Parcial
                                </h3>

                                <div className="mx-auto" style={{width: window.type_device ? "190px": "290px", height: "6px", backgroundColor: "#ffcb48", marginBottom: "17px", transform: "rotate(178deg)", marginTop: "-2px"}}></div>
                                    <>
                                    <h5 className="my-2" style={{fontWeight: "500", fontSize: window.type_device ? "16px": "17px"}}>
Conviértete en Full Stack Developer con nuestra metodología práctica y mentalidad innovadora.  <br/>
<b>Solicita tu beca parcial ahora y accede al programa con un 70% de descuento.  </b>

</h5>

   



                                    {/* formulario */}
                                    {window.type_device &&
                                    <>
<div data-aos="fade-right" className="col-12 col-md-6 px-1" style={{marginBottom: "25px"}}>
                <div style={{textAlign: "center", padding: "5px", boxShadow: "rgba(50, 27, 98, 0.47) 6px 5px 15px 0px", border: "", borderRadius: "20px" }}>

            <form onSubmit={(e)  => this.onSubmit(e, false )} className="px-1" style={{paddingTop: "10px", paddingBottom: "10px" }}>

 {/* <div className="section-title mt-3 mb-1 d-flex">
    <h3 className="title mb-2" style={{paddingLeft:  window.type_device ? "1px" : "9px"}}>
      Datos de Inscripción
    </h3>
</div>  */}
        <label className="col-12 text-left font-weight-bold" htmlFor="nameDojo">
            <span style={{fontSize: "15px", color: "black", fontWeight: "600"}}>
            Nombre:
            </span>
            <input
            id='nameDojo'
            style={{background: "white", marginBottom: "7px"}}
            type="text"
            name="name"
            value={this.state.Name}
            onChange={(e) => this.setState({ Name: e.target.value})}
            placeholder= {"👋 Hola! ¿Cuál es tu nombre?"}
            />
        </label>

           <label className="mb-2 col-12 text-left font-weight-bold" htmlFor="item02">
            <span style={{fontSize: "15px", color: "black", fontWeight: "600"}}>
            Email:
            </span>
                <input
                    style={{background: "white", marginBottom: "3px"}}
                    type="email"
                    name="email"
                    id="item02"
                    value={this.state.Email}
                    onChange={(e)=>{this.setState({Email: e.target.value});}}
                    placeholder="📧 ¿Cuál es tu Email?"
                    />
            </label> 


<div className="text-left mt-1" >
    <b style={{fontSize: "15px", marginLeft: "16px", color: "black", fontWeight: "600"}}>
        WhatsApp:
    </b>
</div>

<div className="d-flex justify-content-center mx-2">

<div className="mx-2 mt-2">
    <Selectrix
    className="pais-inscription"
    height={300}
    onRenderOption={this.onRenderOption}
    onRenderSelection={this.onRenderSelection}
    placeHolderInside={true}
    placeholder={"País"}
    customScrollbar={true}
    searchable={false}
    materialize={false}
    defaultValue={this.state.countryCode}
    options={KeyCountry}
    onChange={(value) => {
        // console.log("value.key", value.key);
        this.setState({"countryCode": value.key});
        if (this.state.Email){
            localStorage.setItem('email', this.state.Email);
        }
        if (this.state.Name){
            localStorage.setItem('name', this.state.Name);
        }
        if (this.state.Phone){
            localStorage.setItem('phone', this.state.Phone);
        }
    } }
    />

</div>

<div style={{width: "80%"}}>
<label htmlFor="Phone">
    
    <input
    style={{background: "white"}}
    type="tel"
    name="phone"
    id="Phone"
    value={this.state.Phone}
    onChange={(e) => {
        this.setState({ Phone: e.target.value });
    }}
    placeholder="987654321"
    />
 </label>
</div>

</div>  





<button
    id="submit-contacto"

    type="submit" name="submit-contacto"
style={{
      textShadow: "none",
      cursor: "pointer",
      fontWeight: "bold",
      fontSize: "19px",
      padding: "10px 19px",
      borderRadius: "20px",
      color: "white",
      border: "none",
      outline: "none"
    }}
    className="cta-button"
    >



{!this.state.loadingEnroll  && <b style={{fontSize: "23px"}}>
    
 Solicitar mi beca parcial
    </b> }

{this.state.loadingEnroll  &&
                <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
                style={{fontSize: "20px", marginRight: "8px"}}
                />
}

</button>


   
   
<div className="row mt-3">
                    <div className="col-12 mx-3" style={{color: "gray", fontSize: "13px", textAlign: "left"}}>
                    <label htmlFor="checkNotify" style={{float: "left"}}>
                        <input
                            style={{width: 13, float: "left", marginTop: "-10px", marginRight: "5px", marginBottom: "1px"}}
                            defaultChecked={true}
                            type="checkbox"
                            name="checkNotify"
                            id="checkNotify"
                        />
                        <span>🔒 Protegemos tu información.</span>
                    </label>
                    </div>
                </div>

    <div class="benefits-list">
          
                <p style={{marginBottom: "3px", fontSize: "14px"}}>✓ Roadmap personalizado para tu carrera tech </p>
                <p style={{marginBottom: "3px", fontSize: "14px"}}>✓ Metodología práctica con proyectos reales</p>
                <p style={{marginBottom: "3px", fontSize: "14px"}}>✓ Oportunidades laborales y salario esperado</p>
                <p style={{marginBottom: "3px", fontSize: "14px"}}>✓ Acceso a nuestra comunidad de desarrolladores</p>
                <p style={{marginBottom: "3px", fontSize: "14px"}}>✓ Mentorías 1:1 con expertos de la industria</p>
      
        </div>

            </form>
                    </div>
            

        </div>
                                    </>
                                    }

                                 
                                    </>
                                </div>

     {/* formulario */}
{!window.type_device &&
<>
                                <div className="col-12 col-md-5" style={{paddingTop: "20px"}}>
                           
                    <div data-aos="fade-right" className="col-12 px-1" style={{marginBottom: "25px"}}>
                <div style={{textAlign: "center", padding: "5px", boxShadow: "rgba(50, 27, 98, 0.47) 6px 5px 15px 0px", border: "", borderRadius: "20px" }}>

            <form onSubmit={(e)  => this.onSubmit(e, false ) } className="px-1" style={{paddingTop: "10px", paddingBottom: "10px" }}>



        <label className="col-12 text-left font-weight-bold" htmlFor="nameDojo">
            <span style={{fontSize: "15px", color: "black", fontWeight: "600"}}>
            Nombre:
            </span>
            <input
            id='nameDojo'
            style={{background: "white", marginBottom: "7px"}}
            type="text"
            name="name"
            value={this.state.Name}
            onChange={(e) => this.setState({ Name: e.target.value})}
            placeholder= {"👋 Hola! ¿Cuál es tu nombre?"}
            />
        </label>

           <label className="mb-2 col-12 text-left font-weight-bold" htmlFor="item02">
            <span style={{fontSize: "15px", color: "black", fontWeight: "600"}}>
            Email:
            </span>
                <input
                    style={{background: "white", marginBottom: "3px"}}
                    type="email"
                    name="email"
                    id="item02"
                    value={this.state.Email}
                    onChange={(e)=>{this.setState({Email: e.target.value});}}
                    placeholder="📧 ¿Cuál es tu Email?"
                    />
            </label> 

<div className="text-left mt-1" >
    <b style={{fontSize: "14px", marginLeft: "16px", color: "black", fontWeight: "600"}}>
        WhatsApp:
    </b>
</div>

<div className="d-flex justify-content-center mx-2">

<div className="mx-2 mt-2">
    <Selectrix
    className="pais-inscription"
    height={300}
    onRenderOption={this.onRenderOption}
    onRenderSelection={this.onRenderSelection}
    placeHolderInside={true}
    placeholder={"País"}
    customScrollbar={true}
    searchable={false}
    materialize={false}
    defaultValue={this.state.countryCode}
    options={KeyCountry}
    onChange={(value) => {
        // console.log("value.key", value.key);
        this.setState({"countryCode": value.key});
        if (this.state.Email){
            localStorage.setItem('email', this.state.Email);
        }
        if (this.state.Name){
            localStorage.setItem('name', this.state.Name);
        }
        if (this.state.Phone){
            localStorage.setItem('phone', this.state.Phone);
        }
    } }
    />

</div>
<div>
<label htmlFor="Phone">
    
    <input
    style={{background: "white"}}
    type="text"
    name="phone"
    id="Phone"
    value={this.state.Phone}
    onChange={(e) => {
        this.setState({ Phone: e.target.value });
    }}
    placeholder="N.º Celular"
    />
 </label>
</div>
</div> 



<button
    id="submit-contacto"

    type="submit" name="submit-contacto"
    style={{
      textShadow: "none",
      cursor: "pointer",
      fontWeight: "bold",
      fontSize: "19px",
      padding: "10px 19px",
      borderRadius: "20px",
      background: "linear-gradient(180deg, #9b37f2, #7a12d4)",
      color: "white",
      border: "none",
      outline: "none"
    }}
    className="btn-efect-live"
    
     >


{!this.state.loadingEnroll  && <b style={{fontSize: "23px"}}>
    
Solicitar mi beca parcial
    </b> }

{this.state.loadingEnroll  &&
                <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
                style={{fontSize: "20px", marginRight: "8px"}}
                />
}

</button>


   
   
<div className="row mt-3">
                    <div className="col-12 mx-3" style={{color: "gray", fontSize: "14px", textAlign: "left"}}>
                    <label htmlFor="checkNotify" style={{float: "left"}}>
                        <input
                            style={{width: 15, float: "left", marginTop: "-10px", marginRight: "5px", marginBottom: "1px"}}
                            defaultChecked={true}
                            type="checkbox"
                            name="checkNotify"
                            id="checkNotify"
                        />
                        <span>🔒 Protegemos tu información.</span>
                    </label>
                    </div>
                </div>

    <div class="benefits-list">
                <p style={{marginBottom: "3px", fontSize: "14px"}}>✓ Roadmap personalizado para tu carrera tech </p>
                <p style={{marginBottom: "3px", fontSize: "14px"}}>✓ Metodología práctica con proyectos reales</p>
                <p style={{marginBottom: "3px", fontSize: "14px"}}>✓ Oportunidades laborales y salario esperado</p>
                <p style={{marginBottom: "3px", fontSize: "14px"}}>✓ Acceso a nuestra comunidad de desarrolladores</p>
                <p style={{marginBottom: "3px", fontSize: "14px"}}>✓ Mentorías 1:1 con expertos de la industria</p>
      
        </div>

            </form>
                    </div>
            

        </div>
        
                                   
                                </div>
 </>
                                    }

                                </div>
                        </div>
                        
                        </div>


                    </Modal.Body>

                </Modal>





        <Modal show={this.state.isOpenBrochure} size="xl" onHide={() => this.setState({isOpenBrochure: false, selectFecha: false})} style={{top:  window.type_device ? "1%": "15%", zIndex: "999999"}}>

                <span style={{marginLeft: "5px", marginTop: "5px", textAlign: "left", "color":"slateblue"}}> <IoCloseCircleOutline onClick={() => this.setState({isOpenBrochure: false, selectFecha: false}) } style={{ cursor: "pointer", fontSize: "41px", marginLeft: "12px", marginRight: "12px", marginTop: "12px", color: "slateblue"}} /> </span>

                <Modal.Body className="body-evento">

                <div className="inner">
                    <div className="contact-form--1">
                            <div className="row">
                                <div className="col-12 col-md-7 px-2">
                                <h3 className="mb-1 text-center" style={{fontSize: window.type_device ? "26px": "39px"}}>
                                   Descarga el Brochure del Bootcamp Full Stack Developer
                                </h3>

                                <div className="mx-auto" style={{width: window.type_device ? "190px": "290px", height: "6px", backgroundColor: "#ffcb48", marginBottom: "17px", transform: "rotate(178deg)", marginTop: "-2px"}}></div>
                                    <>
                                    <h5 className="my-2" style={{fontWeight: "500", fontSize: window.type_device ? "16px": "17px"}}>
                                    Descubre cómo convertirte en Full Stack Developer en tiempo récord con nuestro enfoque práctico y mentalidad innovadora.



</h5>

   



                                    {/* formulario */}
                                    {window.type_device &&
                                    <>
<div data-aos="fade-right" className="col-12 col-md-6 px-1" style={{marginBottom: "25px"}}>
                <div style={{textAlign: "center", padding: "5px", boxShadow: "rgba(50, 27, 98, 0.47) 6px 5px 15px 0px", border: "", borderRadius: "20px" }}>

            <form onSubmit={(e)  => this.onSubmit(e, true )} className="px-1" style={{paddingTop: "10px", paddingBottom: "10px" }}>

 {/* <div className="section-title mt-3 mb-1 d-flex">
    <h3 className="title mb-2" style={{paddingLeft:  window.type_device ? "1px" : "9px"}}>
      Datos de Inscripción
    </h3>
</div>  */}
        <label className="col-12 text-left font-weight-bold" htmlFor="nameDojo">
            <span style={{fontSize: "15px", color: "black", fontWeight: "600"}}>
            Nombre:
            </span>
            <input
            id='nameDojo'
            style={{background: "white", marginBottom: "7px"}}
            type="text"
            name="name"
            value={this.state.Name}
            onChange={(e) => this.setState({ Name: e.target.value})}
            placeholder= {"👋 Hola! ¿Cuál es tu nombre?"}
            />
        </label>

           <label className="mb-2 col-12 text-left font-weight-bold" htmlFor="item02">
            <span style={{fontSize: "15px", color: "black", fontWeight: "600"}}>
            Email:
            </span>
                <input
                    style={{background: "white", marginBottom: "3px"}}
                    type="email"
                    name="email"
                    id="item02"
                    value={this.state.Email}
                    onChange={(e)=>{this.setState({Email: e.target.value});}}
                    placeholder="📧 ¿Cuál es tu Email?"
                    />
            </label> 


<div className="text-left mt-1" >
    <b style={{fontSize: "15px", marginLeft: "16px", color: "black", fontWeight: "600"}}>
        WhatsApp:
    </b>
</div>

<div className="d-flex justify-content-center mx-2">

<div className="mx-2 mt-2">
    <Selectrix
    className="pais-inscription"
    height={300}
    onRenderOption={this.onRenderOption}
    onRenderSelection={this.onRenderSelection}
    placeHolderInside={true}
    placeholder={"País"}
    customScrollbar={true}
    searchable={false}
    materialize={false}
    defaultValue={this.state.countryCode}
    options={KeyCountry}
    onChange={(value) => {
        // console.log("value.key", value.key);
        this.setState({"countryCode": value.key});
        if (this.state.Email){
            localStorage.setItem('email', this.state.Email);
        }
        if (this.state.Name){
            localStorage.setItem('name', this.state.Name);
        }
        if (this.state.Phone){
            localStorage.setItem('phone', this.state.Phone);
        }
    } }
    />

</div>

<div style={{width: "80%"}}>
<label htmlFor="Phone">
    
    <input
    style={{background: "white"}}
    type="tel"
    name="phone"
    id="Phone"
    value={this.state.Phone}
    onChange={(e) => {
        this.setState({ Phone: e.target.value });
    }}
    placeholder="987654321"
    />
 </label>
</div>

</div>  





<button
    id="submit-contacto"

    type="submit" name="submit-contacto"
style={{
      textShadow: "none",
      cursor: "pointer",
      fontWeight: "bold",
      fontSize: "19px",
      padding: "10px 19px",
      borderRadius: "20px",
      color: "white",
      border: "none",
      outline: "none",
      background: "#1f1f25"
    }}
    className="cta-button"
    >



{!this.state.loadingEnroll  && <b style={{fontSize: "23px"}}>
    
 Descargar Brochure
    </b> }

{this.state.loadingEnroll  &&
                <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
                style={{fontSize: "20px", marginRight: "8px"}}
                />
}

</button>


   
   
<div className="row mt-3">
                    <div className="col-12 mx-3" style={{color: "gray", fontSize: "13px", textAlign: "left"}}>
                    <label htmlFor="checkNotify" style={{float: "left"}}>
                        <input
                            style={{width: 13, float: "left", marginTop: "-10px", marginRight: "5px", marginBottom: "1px"}}
                            defaultChecked={true}
                            type="checkbox"
                            name="checkNotify"
                            id="checkNotify"
                        />
                        <span>🔒 Protegemos tu información.</span>
                    </label>
                    </div>
                </div>

    <div class="benefits-list">
          
                <p style={{marginBottom: "3px", fontSize: "14px"}}>✓ Roadmap personalizado para tu carrera tech </p>
                <p style={{marginBottom: "3px", fontSize: "14px"}}>✓ Metodología práctica con proyectos reales</p>
                <p style={{marginBottom: "3px", fontSize: "14px"}}>✓ Oportunidades laborales y salario esperado</p>
                <p style={{marginBottom: "3px", fontSize: "14px"}}>✓ Acceso a nuestra comunidad de desarrolladores</p>
                <p style={{marginBottom: "3px", fontSize: "14px"}}>✓ Mentorías 1:1 con expertos de la industria</p>
      
        </div>

            </form>
                    </div>
            

        </div>
                                    </>
                                    }

                                 
                                    </>
                                </div>

     {/* formulario */}
{!window.type_device &&
<>
                                <div className="col-12 col-md-5" style={{paddingTop: "20px"}}>
                           
                    <div data-aos="fade-right" className="col-12 px-1" style={{marginBottom: "25px"}}>
                <div style={{textAlign: "center", padding: "5px", boxShadow: "rgba(50, 27, 98, 0.47) 6px 5px 15px 0px", border: "", borderRadius: "20px" }}>

            <form onSubmit={(e)  => this.onSubmit(e, true ) } className="px-1" style={{paddingTop: "10px", paddingBottom: "10px" }}>



        <label className="col-12 text-left font-weight-bold" htmlFor="nameDojo">
            <span style={{fontSize: "15px", color: "black", fontWeight: "600"}}>
            Nombre:
            </span>
            <input
            id='nameDojo'
            style={{background: "white", marginBottom: "7px"}}
            type="text"
            name="name"
            value={this.state.Name}
            onChange={(e) => this.setState({ Name: e.target.value})}
            placeholder= {"👋 Hola! ¿Cuál es tu nombre?"}
            />
        </label>

           <label className="mb-2 col-12 text-left font-weight-bold" htmlFor="item02">
            <span style={{fontSize: "15px", color: "black", fontWeight: "600"}}>
            Email:
            </span>
                <input
                    style={{background: "white", marginBottom: "3px"}}
                    type="email"
                    name="email"
                    id="item02"
                    value={this.state.Email}
                    onChange={(e)=>{this.setState({Email: e.target.value});}}
                    placeholder="📧 ¿Cuál es tu Email?"
                    />
            </label> 

<div className="text-left mt-1" >
    <b style={{fontSize: "14px", marginLeft: "16px", color: "black", fontWeight: "600"}}>
        WhatsApp:
    </b>
</div>

<div className="d-flex justify-content-center mx-2">

<div className="mx-2 mt-2">
    <Selectrix
    className="pais-inscription"
    height={300}
    onRenderOption={this.onRenderOption}
    onRenderSelection={this.onRenderSelection}
    placeHolderInside={true}
    placeholder={"País"}
    customScrollbar={true}
    searchable={false}
    materialize={false}
    defaultValue={this.state.countryCode}
    options={KeyCountry}
    onChange={(value) => {
        // console.log("value.key", value.key);
        this.setState({"countryCode": value.key});
        if (this.state.Email){
            localStorage.setItem('email', this.state.Email);
        }
        if (this.state.Name){
            localStorage.setItem('name', this.state.Name);
        }
        if (this.state.Phone){
            localStorage.setItem('phone', this.state.Phone);
        }
    } }
    />

</div>
<div>
<label htmlFor="Phone">
    
    <input
    style={{background: "white"}}
    type="text"
    name="phone"
    id="Phone"
    value={this.state.Phone}
    onChange={(e) => {
        this.setState({ Phone: e.target.value });
    }}
    placeholder="N.º Celular"
    />
 </label>
</div>
</div> 




<button
    id="submit-contacto"

    type="submit" name="submit-contacto"
    style={{
      textShadow: "none",
      cursor: "pointer",
      fontWeight: "bold",
      fontSize: "19px",
      padding: "10px 19px",
      borderRadius: "20px",
      background: "#1f1f25",
      color: "white",
      border: "none",
      outline: "none"
    }}
    className="btn-efect-live"
    
     >


{!this.state.loadingEnroll  && <b style={{fontSize: "23px"}}>
    
Descargar Brochure
    </b> }

{this.state.loadingEnroll  &&
                <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
                style={{fontSize: "20px", marginRight: "8px"}}
                />
}

</button>


   
   
<div className="row mt-3">
                    <div className="col-12 mx-3" style={{color: "gray", fontSize: "14px", textAlign: "left"}}>
                    <label htmlFor="checkNotify" style={{float: "left"}}>
                        <input
                            style={{width: 15, float: "left", marginTop: "-10px", marginRight: "5px", marginBottom: "1px"}}
                            defaultChecked={true}
                            type="checkbox"
                            name="checkNotify"
                            id="checkNotify"
                        />
                        <span>🔒 Protegemos tu información.</span>
                    </label>
                    </div>
                </div>

    <div class="benefits-list">
          
                <p style={{marginBottom: "3px", fontSize: "14px"}}>✓ Roadmap personalizado para tu carrera tech </p>
                <p style={{marginBottom: "3px", fontSize: "14px"}}>✓ Metodología práctica con proyectos reales</p>
                <p style={{marginBottom: "3px", fontSize: "14px"}}>✓ Oportunidades laborales y salario esperado</p>
                <p style={{marginBottom: "3px", fontSize: "14px"}}>✓ Acceso a nuestra comunidad de desarrolladores</p>
                <p style={{marginBottom: "3px", fontSize: "14px"}}>✓ Mentorías 1:1 con expertos de la industria</p>
      
        </div>

            </form>
                    </div>
            

        </div>
        
                                   
                                </div>
 </>
                                    }

                                </div>
                        </div>
                        
                        </div>


                    </Modal.Body>

                </Modal>

{this.state.showWeb && 

                <div className="rn-brand-area bg_color--1 ptb--10">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12 px-0">


                        <div class="section-title mb--25 mb_sm--0 text-center">
                            <h3 class="title text-dark" style={{lineHeight: "normal"}}>
                            NUESTROS GRADUADOS TRABAJAN EN CONOCIDAS EMPRESAS INTERNACIONALES
                             </h3>

                             <div className="d-flex justify-content-center">
                              <img className="col-12 col-md-6 w-100 img-fluid px-0" src="/assets/images/dojopy/brands_2025.png" alt="" srcset="" />
                             </div>
                        </div>

                            </div>
                        </div>
                    </div>
                </div>
    }





{this.state.showWeb && 

<div className="rn-testimonial-area bg_color--1 ptb--40" style={{"padding": "10px"}}>
    <div className="container">
            <div className="rn-testimonial-area bg_color--1 ptb--80" style={{"padding-bottom": "30px"}}>
                    <div className="container">
                        <TestimonialTree langUS={this.state.langUS} />
                    </div>
                </div>
    </div>
</div>
    }





{this.state.showWeb && 

  <div className="rn-team-area ptb--40 bg_color--1" id="team" data-aos="fade-right" >
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="section-title service-style--3 text-center mb--25 mb_sm--0">
                                        <h2 className="title">{true ? "Nuestro Equipo": "Our team"} </h2>
                                        <p>{true ? "Nos apasiona la tecnológica y los desafíos de este mundo cambiante.": "We are passionate about technology and the challenges of this changing world."}  </p>
                                    </div>
                                </div>
                            </div>
                            <div className="row" style={{justifyContent: "center"}}>
                                <TeamFull column="col-3 col-md-1" />
                            </div>
                        </div>
                </div>
    }




{this.state.showWeb && 
                <div data-aos="fade-right" className="about-area ptb--20 bg_color--5" id="fechas">

                <div className="about-wrapper" style={{paddingTop: "20px"}} >
                <div className="container px-0">

                            <div className="section-title mb-3">
                            <h2 className="title text-center mb-1" style={{paddingBottom: "1px" }}>
                                Fecha de inicio
                            </h2>
                            {/* <p className="text-center" style={{fontSize: "16px"}}>Diseñado para adaptarse a tu estilo de vida y objetivos profesionales</p> */}
                        
                            </div>

                        <div className="col-12">
                          <a href={"#empezar"} style={{textDecoration: "none", color: "black"}}>
                        {this.renderFechas()}
                        </a>
                        </div>

                    </div>
                    </div>
                    </div>
    }



{this.state.showWeb &&

                <div className="rn-pricing-table-area ptb--40 bg_color--5" data-aos="fade-right" id="empezar">

<div className="container px-0" >
<div className="row" style={{justifyContent: "center", textAlign: "-webkit-center"}}>


<div className="col-12 mt-1 px-0" style={{paddingBottom: "13px", paddingRight: "15px", paddingLeft: "15px", maxWidth: "490px", marginRight: window.type_device ? "auto": "1px" }} >

<div  onClick={ () => window.fbq('track', 'AddToCart', {
                value: this.state.price_mount,                 // Valor total de la compra
                currency: 'USD',               // Moneda utilizada (ISO 4217)
                content_type: 'product',       // Tipo de contenido
                content_ids: ['bootcamp'],  // ID del producto o identificador
                content_name: 'bootcamp'
            })}   className="rn-pricing"
            style={{boxShadow: "rgba(50, 27, 98, 0.47) 6px 5px 15px 0px", border: "none", background: "#1f1f25", borderRadius: "20px"}} >
    <div className="pricing-table-inner">

        <div className="pricing-header pb-0 mb-2 mt-1">

{window.location.pathname.includes("beca-parcial") && <div class="badge-oferta">
    
    🔥 Solo por 24h: {this.state.porcentajeDescuento}
    </div>}
                

        <h2 className="text-white p-0 m-0" style={{fontSize: window.type_device ? "29px": "33px"}}>Bootcamp
          </h2>

                  
        <h2 className="text-white" style={{fontSize: window.type_device ? "33px": "45"}}>
            Full Stack Developer</h2>
        <div className="mx-auto mt-1" style={{width: window.type_device ? "190px": "190px", height: "6px", backgroundColor: "#ffcb48", marginBottom: "17px", transform: "rotate(178deg)", marginTop: "-2px"}}></div>

  
        <hr style={{borderTop:  "1px solid gray"}} />

       



            {/* <span style={{color: "white", fontSize: "18px"}}>Antes: </span> */}

  
            <span style={{color: "gray", display: "inline-block"}}>
            <del style={{color: "gray", fontSize: "23px"}}>
                &nbsp; {this.state.price_completo_regular_2} &nbsp;
            </del>
            </span>
   


            {/* { window.location.pathname.includes("beca-parcial")  && this.state.countryCode === "PE" &&
                <span style={{color: "gray", display: "inline-block"}}>
                <del style={{color: "gray", fontSize: "23px"}}>
                    &nbsp; S/497 al mes &nbsp;
                </del>
                </span>
            }

            { window.location.pathname.includes("beca-parcial")  && this.state.countryCode !== "PE" &&
                <span style={{color: "gray", display: "inline-block"}}>
                <del style={{color: "gray", fontSize: "23px"}}>
                    &nbsp; $147 USD al mes &nbsp;
                </del>
                </span>
            } */}




            {this.state.porcentajeDescuento &&
                <div style={{display: "inline-block", fontSize: "13px", marginLeft: "5px"}} className="discount-badge inline-block"> {this.state.porcentajeDescuento} </div>
            }



            <h3 className="pricing" style={{margin: "5px"}} >
                  
            {this.renderPrice(this.state.price_completo_2)}


            </h3>

     
        <div className="text-white my-3" style={{fontSize: "18px", fontWeight: "normal"}}>
            <p className="mb-1"><b style={{fontSize: "18px"}}> Un solo pago de {this.state.price_completo_2} para toda tu carrera.  </b>  </p>
          
        </div>   

      {/* <div className="text-white my-3" style={{fontSize: "18px", fontWeight: "normal"}}>
            <p className="mb-1"><b style={{fontSize: "18px"}}>3 mensualidades de {this.state.price_completo_2}  </b>  </p>
           <span style={{marginTop: "3px", fontSize: "17px"}}><FiCheck className="mr-1"/> 
            🔐 Reserva tu plaza ahora con la primera mensualidad </span><br/>
        </div>   */}

 


           {/* <div className="slide-btn" style={{marginTop: "20px", textAlign: "center"}}>
                <a href={`/enroll/${this.state.bootcampSlug}/${this.state.countryCode}`}>
                <button
                onClick={() => {
                    window.fbq('track', 'AddToCart', {
        value: this.state.price_mount,                 // Valor total de la compra
        currency: 'USD',               // Moneda utilizada (ISO 4217)
        content_type: 'product',       // Tipo de contenido
        content_ids: ['bootcamp'],  // ID del producto o identificador
        content_name: 'bootcamp'
      });
} }
                id="enroll_bootcamp_2"
                style={{fontFamily: "'Poppins',sans-serif",  lineHeight: "28px", fontSize: "20px", marginBottom: "13px", padding: "15px 30px", textTransform: "uppercase", border: "1px solid white", borderRadius: "10px"  }}
                className="btn-efect-2 boton-bombeo">
                    <GoRocket style={{color: "mediumspringgreen", fontSize: "22px", marginRight: "10px"}}/>
                    Empezar inscripción
                 </button>
                    </a>
        </div> */}
   



 <a href={this.state.linkPayUSD} target="_blank" style={{textDecoration: "none", color: "white"}}>
 <div className="mt-2 text-center">
                  
                  <button className="btn-efect" style={{backgroundColor: "#1f1f25", fontFamily: "Poppins, sans-serif", fontSize: "23px", margin: "5px", fontWeight: "bold", textTransform: "none", cursor: "pointer"}}
                      onClick={(e) => console.log("add cart")}
                  >
                    <IoCard className="mr-2" />
                    
                    {!window.location.pathname.includes("suscripcion") ? "Pagar con Tarjeta": "Suscribirse Ahora"}
                       
                  </button>
              </div>
</a>  

    {this.state.showPayal && this.state.countryCode !== 'PE' &&
                  <button id="comprar-paypal-button" style={{height: "99px", border: "none", width: window.type_device ? "100%": "370px", marginTop: "9px", marginBottom: "1px", alignSelf: "center", placeSelf: "center"}}>
                    <PayPalScriptProvider options={this.state.initialOptions} style={{height: "200px"}}>
                  

                    {window.location.pathname.includes("suscripcion") ?
                        <PayPalButtons
                            style={{ layout: "horizontal", label: "subscribe" }}
                            createSubscription={(data, actions) => {
                            // Reemplaza 'P-XXXXXXXXXX' por el ID de tu plan de suscripción creado en PayPal
                            return actions.subscription.create({
                                plan_id: "P-94D96700AX2739101NBGSLDA"
                            });
                            }}
                            onApprove={(data, actions) => {
                            // data.subscriptionID contiene el ID de la suscripción aprobada
                            window.location.href = `/payment-success?session_id=${data.subscriptionID}`;
                            }}
                        /> :
                             <PayPalButtons
                                    style={{ layout: "horizontal", label: "pay" }} // Cambia a 'vertical' para mejor disposición
                                createOrder={(data, actions) => {
                                    return actions.order.create({
                                        purchase_units: [
                                            {
                                                amount: {
                                                    currency_code: "USD",
                                                    value: this.state.price_mount,
                                                },
                                            },
                                        ],
                                    });
                                }}
                                onApprove={(data, actions) => {
                                    return actions.order.capture().then((details) => {
                                        window.location.href = `/payment-success?session_id=${Math.floor(Date.now() / 1000)}&mount=${this.state.price_mount}`;
                                        // const name = details.payer.name.given_name;
                                        // console.log(`Transaction completed by ${name}`);
                                    });
                                }}
                            />
                    }
                    </PayPalScriptProvider>
                </button>
          } 

             



        </div>

            <div className="p-1 text-left mt-0 text-white">

        <div class="guarantee">
            <div class="guarantee-text">
                🛡️ Garantía de satisfacción de 30 días o te devolvemos tu dinero.
            </div>
        </div>


    <h4 className="text-white py-0 mt-2">
        {!this.state.langUS ? "Métodos de pago: ": "Payment Methods:"}
    </h4>
    <p className="text-white my-1">
        Paga con tarjeta de débito o crédito.
         <br/>
    {this.state.countryCode !== 'PE' &&
        "El precio es en dólares americanos (USD)"
        }
    </p>


    <div style={{marginTop: "5px"}} className="section-title service-style--3 text-left mb--20 mb_sm--0 ">
<img height="70px" className="ayudar" src="/assets/images/dojopy/payment-card.png" alt="métodos de pago"/>


</div>


    </div>

    </div>
</div>

</div>


                            </div>


<div style={{marginTop: "20px"}} className="section-title service-style--3 text-left">
            

                    <div className="about-us-list row mt-1 guarantee"  >
                                <div className="col-12 col-md-1 text-left mb-3">
                                     <img width={window.type_device ? "55px": "55px" }  className="" src="/assets/images/dojopy/garantia-cash.png" style={{cursor: "pointer"}}/>
                                </div>
                                <div className="col-12 col-md-11 px-0 ">
                                    <h4 className="title" style={{fontWeight: "normal", textAlign: window.type_device ? "left": "left", fontSize: "16px"}}>
Le ofrecemos una garantía de satisfacción de 30 días: si nuestro Bootcamp Full Stack Developer no cumple sus expectativas, le devolvemos el 100 % de su inversión, sin cláusulas ocultas.
                                    </h4>
                                </div>

                            </div>


                        <h5 className="title text-black mt-2" style={{fontSize: "18px"}}>

                        {this.state.langUS ? "Once our support team has verified the payment, you will get:": "Una vez que nuestro equipo de soporte haya verificado el pago, obtendrás:"}

                                
                            </h5>
                        <p>
                            <ul>
                                <li>
                                {this.state.langUS ? "Get your credentials and access the Live Online Bootcamp Platform.": "Obtén tus credenciales y accede a la Plataforma del Bootcamp Online en Vivo."}
                                </li>
                                <li>
                                {this.state.langUS ? "Become part of our exclusive private members community and connect with other passionate people like you.": "Forma parte de nuestra exclusiva comunidad privada de miembros y conecta con otros apasionados como tú."}
                                </li>

                                <li>
                                {this.state.langUS ? "Enjoy the personalized support of an assigned mentor, always ready to guide and support you on your path.": "Disfruta del respaldo personalizado de un mentor asignado, siempre listo para guiarte y apoyarte en tu camino."}
                                </li>
                              
                            </ul>

                        
                             </p>

                        <p className="mt-4">
                        {this.state.langUS ? "If you have any questions, please write to us via WhatsApp or email.": "Si tienes alguna duda, escríbenos por WhatsApp o correo electrónico."}
                        </p>





                    </div>
                    
<div className="slide-btn my-4" style={{justifySelf: "center", textAlign: "center"}}>
<a  target="_blank" href={"https://api.whatsapp.com/send?phone=51936670597&text=Hola, me gustaría obtener más información sobre el bootcamp de desarrollador full stack. ".concat(this.state.fbclid_short_code ? `%0A%0AMi ticket de atención es: %23${this.state.fbclid_short_code}`: "")}>
<button onClick={() => {
    window.fbq('track', 'AddToCart', {
        value: this.state.price_mount,                 // Valor total de la compra
        currency: 'USD',               // Moneda utilizada (ISO 4217)
        content_type: 'product',       // Tipo de contenido
        content_ids: ['bootcamp'],  // ID del producto o identificador
        content_name: 'bootcamp'
      });

} }
className="btn-efect-2 mt-2" style={{background: "linear-gradient(to right, rgb(25, 135, 84), rgb(7, 94, 84))", fontWeight: 600, padding: "10px 25px", fontSize: '20px', textTransform: "none", fontFamily: "Poppins, sans-serif"}}
>
<FaWhatsapp style={{fontSize: "25px"}} className="mr-2" />
¿Tienes una pregunta?
</button>
</a>
</div>

                            
                    




                        </div>
                    </div>
                   
    }






{this.state.showWeb && 
    <PreguntasEmpleo langUS={this.state.langUS} bootcampSlug={this.state.bootcampSlug} />
    }






{this.state.showPrice && this.state.showWeb && this.state.price_completo_2 &&

      <div 
         onClick={() => {
            const element = document.querySelector('#fechas');
            element.scrollIntoView({ behavior: 'smooth' });
         window.fbq('track', 'AddToCart', {
        value: this.state.price_mount,                 // Valor total de la compra
        currency: 'USD',               // Moneda utilizada (ISO 4217)
        content_type: 'product',       // Tipo de contenido
        content_ids: ['bootcamp'],  // ID del producto o identificador
        content_name: 'bootcamp'
      });
}}
      className="floating-button-container btn-efect-live px-2" style={{borderRadius: 0, backgroundColor: "white", width: "100%"}}>

        <div className="floating-button" style={{gap: window.type_device ? "1px": "30px", padding: "1px", width: "100%", display: "flex", justifyContent: window.type_device ? "space-between": "center" } }>

<div>
    <div className="price-info">
             <div className="old-price"> <del> {this.state.price_completo_regular_2} </del> </div>
            {this.state.porcentajeDescuento &&  <div className="discount-badge"> {this.state.porcentajeDescuento}  </div> }
        </div>
         <div className="new-price mb-1">
            {this.state.price_completo_2}
            </div>

    </div> 

<div className="price-container" style={{justifyContent: window.type_device ? "center": "center", gap: window.type_device ? "": "30px"}}>
  


    <div className="d-flex" style={{flexDirection: "column", alignSelf: "center"}}>

            <button
            onClick={() => {
                const element = document.querySelector('#fechas');
            element.scrollIntoView({ behavior: 'smooth' });
                window.fbq('track', 'AddToCart', {
                    value: this.state.price_mount,                 // Valor total de la compra
                    currency: 'USD',               // Moneda utilizada (ISO 4217)
                    content_type: 'product',       // Tipo de contenido
                    content_ids: ['bootcamp'],  // ID del producto o identificador
                    content_name: 'bootcamp'
                });
            }}
            className="cta-button">
             Únete al Bootcamp
            </button> 
          
      
    
    </div>

</div>


        </div>

        </div>
} 


{/* 
      <div 
         onClick={() => {
            this.setState({isOpenMett: true});
            // const element = document.querySelector('#fechas');
            //      element.scrollIntoView({ behavior: 'smooth' });
         window.fbq('track', 'AddToCart', {
        value: this.state.price_mount,                 // Valor total de la compra
        currency: 'USD',               // Moneda utilizada (ISO 4217)
        content_type: 'product',       // Tipo de contenido
        content_ids: ['bootcamp'],  // ID del producto o identificador
        content_name: 'bootcamp'
      });
}}
      className="floating-button-container btn-efect-live" style={{borderRadius: 0, backgroundColor: "white", width: "100%"}}>

        <div className="floating-button" style={{padding: "1px", width: "100%" } }>

<div className="price-container" style={{width: "100%", justifyContent: window.type_device ? "center": "center", gap: window.type_device ? "": "30px"}}>

    <div className="d-flex" style={{flexDirection: "column", alignSelf: "center"}}>

            <button
                onClick={() => {
                this.setState({isOpenMett: true});
                window.fbq('track', 'AddToCart', {
                    value: this.state.price_mount,                 // Valor total de la compra
                    currency: 'USD',               // Moneda utilizada (ISO 4217)
                    content_type: 'product',       // Tipo de contenido
                    content_ids: ['bootcamp'],  // ID del producto o identificador
                    content_name: 'bootcamp'
                });
            }}
                className="cta-button" style={{ color: "white"}}>
                <GoRocket className="mr-1" />  Acceder a Beca Parcial
            </button> 
    
    </div>

</div>

        </div>

        </div> */}





{this.state.showWeb && 
                 <FooterTwo langUS={this.state.langUS} fbclid_short_code={this.state.fbclid_short_code} />
    }
                 
            </Fragment>
        )
    }




    runtDiscountHot(country){
        console.log("module runDiscountFlash!");

        const getCookieValue = (name) => {
            const value = `; ${document.cookie}`;
            const parts = value.split(`; ${name}=`);
            if (parts.length === 2) return parts.pop().split(';').shift();
        }

        const discount60mValue = getCookieValue(`discount-temporal-${this.state.bootcampSlugDescuento}`);
        const discount24hValue = getCookieValue(`discount-reboot-${this.state.bootcampSlugDescuento}`);

        if (discount60mValue){
            console.log("DESCUENTO ACTIVO!");
            const discount60mDate = new Date(parseInt(discount60mValue, 10));
            // console.log(discount60mDate);
            this.setState({timeCounter: discount60mDate})
            return;
        }


        if ( !discount60mValue && !discount24hValue){
            console.log("CREANDO DESCUENTO!");

            const fechaActual = new Date();
            const fechaActual2 = new Date();
    
            const minutes = 60*24;
            const houresReboot = 48;
    
            fechaActual.setTime(fechaActual.getTime() +  (minutes * 60 * 1000) );
            fechaActual2.setTime(fechaActual2.getTime() +  (houresReboot * 60 * 60 * 1000) );
    
            document.cookie = `discount-temporal-${this.state.bootcampSlugDescuento}=${fechaActual.getTime()};expires=${fechaActual.toUTCString() }; path=/`;
            document.cookie = `discount-reboot-${this.state.bootcampSlugDescuento}=${fechaActual2.getTime()};expires=${fechaActual2.toUTCString() }; path=/`;
            this.setState({timeCounter: fechaActual})
        } else if (!discount60mValue && discount24hValue){
            console.log("FINALIZO EL DESCUENTO!");
            this.setState({showDeadLine: false});
        }
       
    }

    

    componentDidMount() {




        if (window.location.pathname.includes("beca-parcial")){
            this.setState({bootcampSlug: "fullstack-descuento", bootcampSlugDescuento: "fullstack-descuento"});
        }


        if (window.location.pathname.includes("beca-parcial")){
            this.setState({bootcampSlug: "fullstack-descuento", bootcampSlugDescuento: "fullstack-descuento"});
        }
   

        // if (window.location.pathname.includes("masterclass")){
        //     this.setState({showWeb: false, bootcampSlug: "fullstack-descuento", bootcampSlugDescuento: "fullstack-descuento"});


        //         // Esperar 9 minutos para mostrar el botón de WhatsApp
        //         this.sleep(60000*10).then(r => {
                    
        //             window.fbq('track', 'ViewContent');

        //             this.setState({showWeb: true});
        //             document.getElementById('whatsapp').style.display='block';
        //                 const timerBar = document.getElementById('counter-deadline');
        //             const originalOffset = timerBar.offsetTop;
        //             window.addEventListener('scroll', () => {
        //             if (window.scrollY > originalOffset) {
        //             timerBar.classList.add('sticky');
        //             } else {
        //             timerBar.classList.remove('sticky');
        //             }
        //             });
        //         })

        //         //demo
        //         // this.sleep(7000).then(r => {
        //         //     this.setState({showWeb: true});
        //         //     document.getElementById('whatsapp').style.display='block';

        //         //     const timerBar = document.getElementById('counter-deadline');
        //         //     const originalOffset = timerBar.offsetTop;
        //         //     window.addEventListener('scroll', () => {
        //         //     if (window.scrollY > originalOffset) {
        //         //     timerBar.classList.add('sticky');
        //         //     } else {
        //         //     timerBar.classList.remove('sticky');
        //         //     }
        //         //     });
        //         // })


        // }

        this.fechEventping();
        this.fetchPricingData();


        this.sleep(6000).then(r => {
            document.getElementById('whatsapp').style.display='block';
        })

    }


    async fechEventping(){
        const fbclid = this.getFbclid();
        if (fbclid){
            const fbclidFormateado = this.generarFBC(fbclid);
            console.log("fbclid", fbclidFormateado);
            const codigoCorto = this.generarCodigoCorto(fbclid);
            console.log("codigoCorto", codigoCorto);
            this.setState({"fbclid_short_code": codigoCorto});
            this.eventPing(codigoCorto, fbclidFormateado);
        }
    
    }

    async fetchPricingData() {

        const pathdata = window.location.pathname;
        // console.log('pathdata', pathdata);
        const url = new URL(window.location.href);
        const session_id = url.searchParams.get('session_id');
        const invoice_id = url.searchParams.get('invoice_id');
        const checkout_mount = url.searchParams.get('mount');
    

        if (pathdata.includes("payment-success")){
            // console.log("enviar evento pixel pago completado");

            if (session_id || invoice_id){
                console.log("Log ADS: session_id", session_id || invoice_id, parseInt(checkout_mount) || 497);
                window.fbq('track', 'Purchase', {
                    value: parseInt(checkout_mount) || 197,   // Valor total de la compra
                    currency: 'USD',               // Moneda utilizada (ISO 4217)
                    content_type: 'product',       // Tipo de contenido
                    content_ids: ['bootcamp'],  // ID del producto o identificador
                    content_name: 'bootcamp',
                    eventID: session_id || invoice_id,
                });
            }

        window.fbq('track', 'Lead', {
            content_name: 'Purchase Bootcamp',
            content_category: 'Full Stack Developer Online'
          });
      

            if (invoice_id){

                this.sleep(3000).then(r => {
                    window.open("https://plataforma-dojopy-media.s3.us-east-1.amazonaws.com/INVOICES/" + invoice_id + ".pdf", '_blank').focus();
                });
                // Mostrar el valor en la consola
            }

            // Obtener la URL actual
            // Leer el parámetro 'session_id'
    
     
        }


        if (pathdata.includes("masterclass")){
            const iframe = document.getElementById('iframe-video');
            const estilo = window.getComputedStyle(iframe);
            const anchoExacto = parseInt(estilo.width, 10)
        
            const windowWidth = window.type_device ? window.innerWidth : anchoExacto;
            // Calcular el alto basado en la proporción 16:9
            const aspectRatio = 16 / 9;
            const height = windowWidth / aspectRatio;
            iframe.style.height = height  + 'px';

       
          
   

        } else {

 

        }





        const isParameterPresent = (param) => {
            const urlParams = new URLSearchParams(window.location.search);
            return urlParams.has(param);
        }

        // const isDiscountActive = isParameterPresent("discount");
        // if (isDiscountActive){
        //     console.log("Descuento activo flex-now!");
        //     this.setState({showDeadLine: true, bootcampSlug: "fullstack-especial", bootcampSlugDescuento: "fullstack-especial"})
        // }

        
        let fechaActual = new Date();

        try {
            const response = await axios.get("https://hiuaik2gocmwdeh2ub6lqz3hxq0ycvbe.lambda-url.us-east-1.on.aws/");
            let dataPrice = response.data;
            this.setState({pricingAPI: dataPrice})

   
            this.sleep(1000).then(r => {
                this.setState({showPrice: true});
            });


            this.DynamicCountry();

      
            try {
                const pathdata = window.location.pathname;
                if (true){

                    const responseIP = await axios.get("https://ipapi.co/json/");
                    let dataPriceIP = responseIP.data;
                    if (!dataPriceIP.country_code) throw "api error";

                
    
                    this.setState({countryCode: dataPriceIP.country_code});
                    this.DynamicCountry(dataPriceIP.country_code);

                    // this.setState({countryCode: "MX"});
                    // this.DynamicCountry("MX");

                }

            } catch {
                axios.get('https://vplrntrovd.execute-api.us-east-1.amazonaws.com/DEV').then((response) => {
                    let data = response.data;


                    this.setState({countryCode: data.countryCode});
                    this.DynamicCountry(data.country_code);

                    // if (pathdata.includes('beca50')){
                    //     window.location.href = `/enroll/beca50/${data.country_code}`;
                    // } else if (pathdata.includes('unirme')){
                    //     window.location.href = `/enroll/fullstack/${dataPriceIP.country_code}`;
                    // }

                    }).catch((error) => {
                        console.log("error api");
                    });
            }


        } catch (error) {
            console.log(error);
          }



        this.sleep(120000).then(r => {
            toast.success("¡Geiler y Jhon ya se inscribieron, ahora es tu turno de unirte!");
        })


        this.sleep(2000).then(r => {
                this.setState({showBtnWasi: true});
            })

        this.sleep(100).then(r => {
                this.setState({showBtnTemario: true});
            })


    this.sleep(4000).then(r => {
        this.setState({showPayal: true})
    })

        const email = localStorage.getItem('email');
        const name = localStorage.getItem('name');
        const phone = localStorage.getItem('phone');
        const fbclid_short_code = localStorage.getItem('fbclid_short_code');

        if (email){
            this.setState({Email: email});
        }
        if (name){
            this.setState({Name: name});
        }
        if (phone){
            this.setState({Phone: phone});
        }

        if (fbclid_short_code){
            this.setState({fbclid_short_code: fbclid_short_code});
        }


    }

}


export default BootcampEnginier;
